import { isEmpty, isNull, isUndefined, repeat } from 'lodash';
import Swal from 'sweetalert2';
import moment from 'moment';
// import $ from 'jquery';
import { ResponseClass } from '../classes/main/responseClass';
import { AuthContextType } from '../auth/AuthContext';

const { REACT_APP_RECAPTCHA_SITE_KEY, REACT_APP_RECAPTCHAv2_SITE_KEY, REACT_APP_REACT_ENV } = process.env;
const $ = window?.$;

export function getResponse({
  type = 0,
  msgText_ = '',
  currentMethod_ = '',
  urlGoTo = '',
  subMethod_ = ''
} = {}) {
  const responseHeader = {
    isSuccess: type === -1 ? false : true,
    isWarning: type === 1 ? true : false,
    msgType: type,
  };

  let msgText = '';
  if (currentMethod_ !== undefined && currentMethod_ !== null && currentMethod_ !== '') {
    msgText += `Method: ${currentMethod_}<br/>`;
  }
  if (subMethod_ !== undefined && subMethod_ !== null && subMethod_ !== '') {
    msgText += `Sub method: ${subMethod_}<br/>`;
  }
  if (msgText_ !== undefined && msgText_ !== null && msgText_ !== '') {
    msgText += `${msgText_}<br/>`;
  }

  const responseBody = {
    msgText: msgText,
    msgTextHtml: '',
    result: null,
    urlGoTo: urlGoTo,
    record: {
      delete: false,
      notFound: false,
    }
  };

  return { ...responseHeader, ...responseBody };
}

export const settingsPassword = {
  maxLength: 6,
};

export const settings = Object.freeze({
  app: {
    about: {
      whatIsIt: {
        title: {
          en: 'What is Mercado Libre App?',
          es: '¿Qué es Mercado Libre App?',
        },
        paragrap: {
          en: '<b>Mercado Libre App</b> is a professional, independent (unofficial) solution designed to optimize and boost commercial management within the <b>Mercado Libre</b> ecosystem. Its fundamental purpose is to centralize, streamline, and automate the comprehensive administration of listings, enabling sellers to scale their business efficiently.',
          es: '<b>Mercado Libre App</b> es una solución profesional independiente (no oficial) diseñada para optimizar y potenciar la gestión comercial dentro del ecosistema de <b>Mercado Libre</b>. Su propósito fundamental es centralizar, agilizar y automatizar la administración integral de sus publicaciones, permitiendo a los vendedores escalar su negocio de manera eficiente.',
        },
      },
      whatAreYouDoing: {
        title: {
          en: 'What does Mercado Libre App do?',
          es: '¿Qué hace Mercado Libre App?',
        },
        en: 'It enables the bulk and local editing of <b>multiple listings (both Articles and Services)</b>. Users can make modifications offline and, with a single click, synchronize all changes directly to the <b>Mercado Libre</b> portal. This drastically reduces operational time and eliminates the complexity of manually updating listings one by one.',
        es: 'Permite la edición masiva y local de <b>múltiples publicaciones (tanto de Artículos como de Servicios)</b>. El usuario puede realizar modificaciones fuera de línea y, con un solo clic, sincronizar todos los cambios directamente con el portal de <b>Mercado Libre</b>. Esto reduce drásticamente el tiempo operativo y elimina la complejidad de actualizar artículo por artículo de forma manual.'
      },
      advantage: {
        title: {
          en: 'What advantages does Mercado Libre App offer?',
          es: '¿Qué ventajas ofrece Mercado Libre App?',
        },
        paragrap: {
          en: 'When managing multiple accounts simultaneously, the platform optimizes workflow by avoiding redundant identity verifications. Thanks to an advanced <b>Token authentication</b> system with automatic renewal, the user only needs to log in securely once per registered account. From that point on, all secure access delegation and communication are managed internally, eliminating the need to repeatedly access the traditional website.',
          es: 'Al gestionar múltiples cuentas simultáneamente, la plataforma optimiza el flujo de trabajo al evitar verificaciones redundantes de identidad. Gracias a un avanzado sistema de <b>autenticación por Token</b> de renovación automática, el usuario solo necesita iniciar sesión de forma segura una única vez por cuenta registrada. A partir de ese momento, toda la comunicación y la delegación de accesos seguros se administran internamente, eliminando la necesidad de acceder repetidamente al sitio web tradicional.'
        },
      },
      itIsSafe: {
        title: {
          en: 'Is the Mercado Libre app safe?',
          es: '¿Es seguro Mercado Libre App?',
        },
        paragrap: {
          en: 'Absolutely. All our security and connection protocols strictly adhere to the official documentation and standards of the <b>Mercado Libre Developers</b> platform. We implement rigorous processes for encryption, token management, and secure authentication to ensure that the integrity of your data and accounts is protected under the highest technological standards of the industry.',
          es: 'Absolutamente. Todos nuestros protocolos de seguridad y conexión se adhieren estrictamente a la documentación oficial y estándares de la sección de <b>Desarrolladores (Developers) de Mercado Libre</b>. Implementamos procesos rigurosos de cifrado, gestión de tokens y autenticación segura para asegurar que la integridad de sus datos y de sus cuentas esté protegida bajo los más altos estándares tecnológicos de la industria.',
        }
      },
    },
    backend: {
      documents: {
        accounts: 'accounts',
      },
      mercadoLibre: {
        errors: {
          items: {
            notFound: {
              notFoudCode: 'not_found',
              notFound: 'Item with id ',
            },
            description: {
              notFoudCode: 'not_found',
              notFound: 'Item descriptions of item id',
            },
            update: {
              cannotUpdateItem: 'Cannot update item',
            },
          },
          questions: {
            notFound: {
              notFoudCode: 'not_found',
              notFound: 'Question not found',
            },
          },
        },
        methods: {
          items: {
            itemsByUser: 'itemsByUser',
            itemsSend: 'itemsSend',
          },
          sites: {
            get: 'sitesGet',
          }
        },
        messages: {
          salePost: {
            maxLength: 350,
          },
        },
        notifications: {
          created_orders: 'created_orders',
          items: 'items',
          messages: 'messages',
          orders: 'orders',
          orders_feedback: 'orders_feedback',
          orders_v2: 'orders_v2',
          payments: 'payments',
          questions: 'questions',
        },
        status: {
          active: 'active',
          closed: 'closed',
          deleted: 'deleted',
          paused: 'paused',
          under_review: 'under_review',
        },
        urlApi: 'https://api.mercadolibre.com',
        urlAuthorization: 'http://auth.mercadolibre.com/authorization?response_type=code&client_id=',
      },
      methods: {
        accounts: {
          authorized: 'authorized',
          changePassword: 'changePassword',
          delete: 'delete',
          sendEmailVerification: 'sendEmailVerification',
          emailVerificationSet: 'emailVerificationSet',
          forgotPassword: 'forgotPassword',
          profile: 'profile',
          register: 'register',
          registerStatus: 'registerStatus',
        },
        files: {
          delete: 'delete',
          uploadString: 'uploadString',
          uploadDeleteString: 'uploadDeleteString',
        },
        home: {
          getData: 'getData',
        },
        rates: {
          addList: 'addList',
          deleteList: 'deleteList',
        },
        users: {
          clearTokenLogs: 'clearTokenLogs',
          generateToken: 'generateToken',
          getInformation: 'getInformation',
        },
      },
      urls: {
        url: REACT_APP_REACT_ENV === 'dev' ? 'http://localhost:3001' : 'https://mlanb.up.railway.app',
        about: '/about',
        accounts: '/accounts',
        advancedCommands: '/advancedCommands',
        ai: '/ai',
        aiEdit: '/aiEdit',
        apiV1: '/api/v1',
        bots: '/bots',
        botEdit: '/botEdit',
        categories: '/categories',
        contact: '/contact',
        contactMessages: '/contactMessages',
        dev: 'http://localhost:3001',
        files: '/files',
        forgotPassword: '/forgotPassword',
        home: '/home',
        items: '/items',
        llmModels: '/llmmodels',
        largeLanguageModels: '/largeLanguageModels',
        login: '/login',
        mercadoLibre: '/mercadoLibre',
        mlCategories: '/mlCategories',
        mlSites: '/mlSites',
        notifications: '/notifications',
        notificationToasts: '/notificationToasts',
        privacy: '/privacy',
        process: '/process',
        profile: '/profile',
        prompts: '/prompts',
        rates: '/rates',
        registerNewUser: '/registerNewUser',
        registerStatus: '/registerStatus',
        roles: '/roles',
        sales: '/sales',
        sites: '/sites',
        userLlmModelSelects: '/userLlmModelSelects',
        userCode: '/userCode',
        users: '/users',
      }
    },
    copyRight: 2020,
    emails: {
      dptoSupport: 'mercadolibrevzla.soporte@gmail.com',
      //admin: 'carlos.e.herrera.j@gmail.com',
    },
    fileSize: {
      max: 2097152,
    },
    fileTypes: {
      images: ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp',],
      filesOne: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',],
      filesTwo: ['application/pdf', 'text/plain',],
      filesThree: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',],
      filesOnlyPdf: ['application/pdf'],
    },
    name: 'Mercado Libre App',
    privacy: {
      paragraph01: {
        en: 'These regulations come into effect once the client has agreed with any of the sales executives of the CHEJ group to prepare any of our software, we detail below:',
        es: 'Estas regulaciones entran en vigencia una vez que el cliente haya acordado con cualquiera de los ejecutivos de ventas del grupo CHEJ la preparación de cualquiera de nuestros desarrollos de software, los cuales detallamos a continuación:',
      },
      paragraph02: {
        en: 'The <b>customer</b> will be subject to these conditions once the initial negotiation of any project is established.',
        es: 'El <b>cliente</b> estará sujeto a estas condiciones una vez que se establezca la negociación inicial de cualquier proyecto.',
      },
      paragraph03: {
        en: 'The sale or illegal reproduction of any of our software to persons, internal or external legal entities of the client to whom the initial contract was established is totally prohibited.',
        es: 'Queda totalmente prohibida la venta o reproducción ilegal de cualquiera de nuestros desarrollos de software a personas o entidades jurídicas internas o externas al cliente con quien se estableció el contrato inicial.',
      },
      paragraph04: {
        en: 'Any negotiation regarding the creation, modification or maintenance of the original Software of the <b>CHEJ</b> group or of third parties that has been established with the client, will only be delivered to the <b>“Final product prepared and compiled"</b> the sources are the sole and exclusive property of the <b>CHEJ</b> group.',
        es: 'Cualquier negociación relacionada con la creación, modificación o mantenimiento del Software original del grupo <b>CHEJ</b> o de terceros que se haya establecido con el cliente, se entregará únicamente como <b>"Producto final preparado y compilado"</b>; los códigos fuente son propiedad única y exclusiva del grupo <b>CHEJ</b>.',
      },
      paragraph05: {
        en: 'The information provided by our customers (<b>Ideas, information gathering, process, among others</b>) will be subject to mutual agreement determined as <b>"Confidentiality Contract"</b>, that is, The <b>"Final product prepared and compiled"</b> adapted to the customer requests cannot be marketed with third parties, that is, the idea of the product is completely from our customers.',
        es: 'La información suministrada por nuestros clientes (<b>ideas, levantamiento de información, procesos, entre otros</b>) estará sujeta a un acuerdo mutuo determinado como <b>"Contrato de Confidencialidad"</b>; es decir, el <b>"Producto final preparado y compilado"</b> adaptado a los requerimientos del cliente no podrá ser comercializado con terceros, garantizando que la idea del producto pertenece por completo a nuestros clientes.',
      },
      paragraph06: {
        en: 'The information stored by the application will be fully responsible for the customer who has acquired the <b>"Final product prepared and compiled"</b>, that is, the customer may dispose and manipulate in any way the information stored through the applicable.',
        es: 'La información almacenada por la aplicación será de total responsabilidad del cliente que haya adquirido el <b>"Producto final preparado y compilado"</b>; es decir, el cliente podrá disponer y manipular de cualquier forma la información almacenada a través del aplicativo.',
      },
      paragraph07: {
        en: 'The requirements that arise from the client once the <b>"Final product prepared and compiled"</b> has been delivered will be considered <b>"new requirements"</b>, these must be established as a new phase of the initial project and will generate new fees at the time the client approves the putting in mark of the same.',
        es: 'Los requerimientos que surjan por parte del cliente una vez entregado el <b>"Producto final preparado y compilado"</b> serán considerados como <b>"nuevos requerimientos"</b>; estos deberán establecerse como una nueva fase del proyecto inicial y generarán nuevos honorarios al momento en que el cliente apruebe la puesta en marcha de los mismos.',
      }
    },
    reCAPTCHA: {
      reCaptchaSiteKey: REACT_APP_RECAPTCHA_SITE_KEY,
      //reCAPTCHASecretKey: REACT_APP_RECAPTCHA_SECRET_KEY,
      reCaptchaV2SiteKey: REACT_APP_RECAPTCHAv2_SITE_KEY,
      //reCaptchaV2SecretKey: REACT_APP_RECAPTCHAv2_SECRET_KEY,
      urlPrivaciConditions: 'https://policies.google.com/terms?hl=es-419',
    },
    url: 'https://mercadolibreapivzla.web.app',
    version: '2.1.0',
  },
  colors: {
    dangerColorExp: '#DC3545',
    infoColorExp: '#18A2B8',
    primaryColorExp: '#007BFF',
    secondaryColorExp: '#747474',
    successColorExp: '#53a451',
    warningColorExp: '#f7c244',
  },
  collections: {
    accounts: 'accounts',
    items: 'items',
    notificationsToast: 'notificationsToast',
    questions: 'questions',
    rates: 'rates',
    roles: 'roles',
    tokenUsers: 'tokenUsers',
    users: 'users',
  },
  company: {
    name: 'CHEJ Consultor, C.A',
    slogan: '- Su Requerimiento es Nuestro Compromiso -',
    address: 'Caracas. Miranda - VzLa',
    zipCode: '1060',
    url: 'https://chejconsultor.web.app',
    // phoneNumber001: '+58 424-2339234',
    // phoneNumber002: '+58 412-5958947',
    phoneNumbers: {
      primary: '+58 424-2339234',
    },
    supportEmail: 'soporte.chejconsultor@gmail.com',
    salesEmail: 'ventas.chejconsultor@gmail.com',
    administrationEmail: 'admon.chejconsultor@gmail.com',
    contact: {
      socialNetworks: {
        facebook: 'https://www.facebook.com/CHEJ.Consultor.CA',
        instagram: 'https://www.instagram.com/chejconsultor/',
        telegram: 'https://t.me/CHEJConsultor',
        twitter: 'https://twitter.com/chejconsultor',
        whatsApp: {
          en: 'https://api.whatsapp.com/send?phone=584242339234&text=Hello%20%F0%9F%91%8B%2C%20I%20want%20to%20get%20in%20touch%20with%20you',
          es: 'https://api.whatsapp.com/send?phone=584242339234&text=Hola%20%F0%9F%91%8B%2C%20quiero%20ponerme%20en%20contacto%20con%20ustedes',
        }
      }
    },
  },
  //decimalsPlace: 2,
  dataTables: {
    formats: {
      smStripedBordered: 'table table-sm table-striped table-bordered',
    },
  },
  dualListBox: {
    events: {
      destroy: 'destroy',
      getContainer: 'getContainer',
      refresh: 'refresh',
    },
    btnEvents: {
      destroy: 'btnDLBDestroy',
      getContainer: 'btnDLBGetContainer',
      getValue: 'btnDLBGetValue',
      init: 'btnDLBInit',
      refresh: 'btnDLBReset',
      setValue: 'btnDLBSetValue',
    },
    labels: {
      nonSelectedListLabel: {
        en: 'Unassigned',
        es: 'No asignadas',
      },
      selectedListLabel: {
        en: 'Assigned',
        es: 'Asignadas',
      },
      filterPlaceHolder: {
        en: 'Filter...',
        es: 'Filtrar...',
      },
      filterTextClear: {
        en: 'Show all',
        es: 'Mostrar todos',
      },
      infoText: {
        en: 'Showing all {0}',
        es: 'Mostrando todos ({0})',
      },
      infoTextFiltered: {
        en: '<span class="badge badge-warning">Filtered</span> {0} from {1}',
        es: '<span class="badge badge-warning">Filtrados</span> {0} de {1}',
      },
      infoTextEmpty: {
        en: 'Empty list',
        es: 'Lista vacía',
      },
      moveSelectedLabel: {
        en: 'Move selected',
        es: 'Mover seleccionado',
      },
      moveAllLabel: {
        en: 'Move all',
        es: 'Mover todos',
      },
      removeSelectedLabel: {
        en: 'Remove selected',
        es: 'Quitar seleccionado',
      },
      removeAllLabel: {
        en: 'Remove all',
        es: 'Quitar todos',
      },
    },
  },
  errors: {
    items: {
      description: {
        notFoudCode: 'not_found',
        notFound: 'Item descriptions of item id',
      },
    },
    users: {
      newNotCode: {
        en: 'You must update the account details for this user and generate the security <b>token</b> before running this process',
        es: 'Debes actualizar los datos de la cuenta de este usuario y generar el <b>token</b> de seguridad antes de ejecutar este proceso',
      },
    },
  },
  firebase: {
    firestore: {
      fields: {
        accounts: 'accounts',
        accountId: 'accountId',
        aiApiKey: 'aiApiKey',
        availableQuantity: 'availableQuantity',
        code: 'code',
        createAt: 'createAt',
        date_created: 'date_created',
        description: 'description',
        email: 'email',
        enabled: 'enabled',
        eventId: 'eventId',
        expDate: 'expDate',
        firstName: 'firstName',
        id: 'id',
        itemId: 'itemId',
        isDeleted: 'isDeleted',
        message: 'message',
        mlUserId: 'mlUserId',
        moduleId: 'moduleId',
        name: 'name',
        lastName: 'lastName',
        llmId: 'llmId',
        order: 'order',
        password: 'password',
        phoneNumber: 'phoneNumber',
        priceOtherCurrency: 'priceOtherCurrency',
        priority: 'priority',
        questionId: 'questionId',
        rate: 'rate',
        reCaptchaToken: 'reCaptchaToken',
        register: 'register',
        role: 'role',
        roleId: 'roleId',
        secondId: 'secondId',
        seller: 'seller',
        sellerId: 'sellerId',
        settings: 'settings',
        status: 'status',
        subject: 'subject',
        title: 'title',
        token: 'token',
        topic: 'topic',
        topicId: 'topicId',
        userId: 'userId',
        userName: 'userName',
      },
      ordersBy: {
        asc: 'asc',
        desc: 'desc',
      },
      operators: {
        arrayContains: 'array-contains',
        arrayContainsAny: 'array-contains-any',
        different: '!=',
        equal: '==',
        in: 'in',
        major: '>',
        majorEqual: '>=',
        minor: '<',
        minoEqual: '<=',
        notIn: 'not-in',
      },
    },
  },
  gifs: {
    normal: {
      loading: '/images/loading/loading.gif',
      circle: '/images/loading/circle.gif',
      circle2: '/images/loading/circle2.gif',
    },
    svg: {
      spinner: '/images/loading/spinner.svg',
      spinnerWhite: '/images/loading/spinner-white.svg',
      typing: '/images/loading/typing.svg',
    },
  },
  html: {
    cards: {
      default: 'card border-0 shadow-lg login-card',
    },
    buttons: {
      primary: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
      secondary: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
      outlinePrimary: 'btn btn-outline-primary shadow-sm font-weight-bold mx-1 px-4',
      outlineSecondary: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
    },
    dataTables: {
      formats: {
        bordered: 'table table-bordered',
        striped: 'table table-striped',
        small: 'table table-sm',
        smBordered: 'table table-sm table-bordered',
        smStriped: 'table table-sm table-striped',
        smStripedBordered: 'table table-sm table-striped table-bordered',
        stripedBordered: 'table table-striped table-bordered',
        tableResponsiveSm: 'table-responsive-sm',
        tableHoverW100Border0: 'table table-hover w-100 border-0',
      },
    },
    popup: 'rounded-lg shadow border-0',
    space: {
      formatOne: '&nbsp;',
      formatTwo: '&nbsp;&nbsp;',
      formatThree: '&nbsp;&nbsp;&nbsp;',
      formatFour: '&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFive: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSix: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSevent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatEight: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatNine: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatTen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatEleven: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatTwelve: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatThirteen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFourTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatFiftTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSixTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
      formatSevenTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
    },
    errorText: 'form-text mt-1 form-error-text animate__animated animate__fadeIn',
  },
  icons: {
    faFa: {
      calendar: 'fa fa-calendar',
      check: 'fa fa-check',
    },
    farFa: {
      arrowAltCircleUp: 'far fa-arrow-alt-circle-up',
      arrowAltCircleDown: 'far fa-arrow-alt-circle-down',
      circleNavIcon: 'far fa-circle nav-icon',
      file: 'far fa-file',
      moon: 'far fa-moon',
      pauseCircle: 'far fa-pause-circle',
      squareMinus: 'far fa-minus-square',
      sun: 'far fa-sun',
    },
    fasFa: {
      addressCard: 'fas fa-address-card',
      alignJustify: 'fas fa-align-justify',
      angleLeftRight: 'right fas fa-angle-left',
      // arrowCircleLeft: 'fas fa-arrow-alt-circle-left',
      arrowAltCircleLeft: 'fas fa-arrow-alt-circle-left',
      arrowDown: 'fas fa-arrow-down',
      arrowUp: 'fas fa-arrow-up',
      ban: 'fas fa-ban',
      bell: 'fas fa-bell',
      brain: 'fas fa-brain',
      calculator: 'fas fa-calculator',
      clock: 'fas fa-clock',
      close: 'fas fa-times',
      cloudDownloadAlt: 'fas fa-cloud-download-alt',
      cloudUploadAlt: 'fas fa-cloud-upload-alt',
      chartBar: 'fas fa-chart-bar',
      check: 'fas fa-check',
      checkCircle: 'fas fa-check-circle',
      codeBranch: 'fas fa-code-branch',
      cogs: 'fas fa-cogs',
      edit: 'fas fa-edit',
      ellipsisV: 'fas fa-ellipsis-v',
      equals: 'fas fa-equals',
      envelope: 'fas fa-envelope',
      envelopeOpenText: 'fas fa-envelope-open-text',
      eraser: 'fas fa-eraser',
      exclamationTriangle: 'fas fa-exclamation-triangle',
      eye: 'far fa-eye',
      eyeSlash: 'far fa-eye-slash',
      fileAlt: 'fas fa-file-alt',
      grin: 'far fa-grin',
      home: 'fas fa-home',
      idCard: 'fas fa-id-card',
      key: 'fas fa-key',
      list: 'fas fa-list',
      listOl: 'fas fa-list-ol',
      listUl: 'fas fa-list-ul',
      lock: 'fas fa-lock',
      minus: 'fas fa-minus',
      minusCircle: 'fas fa-minus-circle',
      mobileAlt: 'fas fa-mobile-alt',
      paperPlane: 'fas fa-paper-plane',
      pauseCircle: 'fas fa-pause-circle',
      plusCircle: 'fas fa-plus-circle',
      powerOff: 'fas fa-power-off',
      robot: 'fas fa-robot',
      search: 'fas fa-search',
      save: 'fas fa-save',
      shieldAlt: 'fas fa-shield-alt',
      sortNumericUpAlt: 'fas fa-sort-numeric-up-alt',
      signIn: 'fas fa-sign-in-alt',
      signOut: 'fas fa-sign-out-alt',
      spellCheck: 'fas fa-spell-check',
      store: 'fas fa-store',
      stopCircle: 'fas fa-stop-circle',
      syncSpin: 'fas fa-sync fa-spin',
      tasks: 'fas fa-tasks',
      toggleOff: 'fas fa-toggle-off',
      toggleOn: 'fas fa-toggle-on',
      trashAlt: 'fas fa-trash-alt',
      undo: 'fas fa-undo',
      user: 'fas fa-user',
      userCheck: 'fas fa-user-check',
      userPrefix: 'fas fa-user prefix',
      userTag: 'fas fa-user-tag',
      userShield: 'fas fa-user-shield',
      users: 'fas fa-users',
    },
    addressCardFar: 'far fa-address-card',
    //arrowAltCircleLeft: 'far fa-arrow-alt-circle-left',
    arrowCircleRight: 'fas fa-arrow-circle-right',
    arrowCircleUp: 'fas fa-arrow-alt-circle-up',
    award: 'fas fa-award',
    bed: 'fas fa-bed',
    building: 'fas fa-building',
    buildingFa: 'fa fa-building',
    bullhorn: 'fas fa-bullhorn',
    calendarAltFas: 'fas fa-calendar-alt',
    calendarAlt: 'fa fa-calendar-alt',
    car: 'fas fa-car',
    caretDown: 'fas fa-caret-down',
    caretLeft: 'fas fa-caret-left',
    caretRight: 'fas fa-caret-right',
    caretUp: 'fas fa-caret-up',
    certificate: 'fas fa-certificate',
    circleDotNavIcon: 'far fa-dot-circle nav-icon',
    chartArea: 'fas fa-chart-area',
    chartColumn: 'fas fa-chart-column',
    chartLine: 'fas fa-chart-line',
    chevronUp: 'fas fa-chevron-up',
    checkSquare: 'fas fa-check-square',
    coins: 'fas fa-coins',
    collectionCash: 'fas fa-cash-register',
    creditCardFas: 'fas fa-credit-card',
    dollarSign: 'fas fa-dollar-sign',
    earthAmericas: 'fas fa-earth-americas',
    eyeIpasswordIpassword: 'far fa-eye ipassword ipassword',
    eyeSlashIpasswordIpassword: 'far fa-eye-slash ipassword ipassword',
    fax: 'fas fa-fax',
    fileContract: 'fas fa-file-contract',
    fileAltFar: 'far fa-file-alt',
    fileFas: 'fas fa-file',
    //fileLines: 'fa fa-file-lines',
    //fileTextFa: 'fas fa-file-text',
    //fileTextFas: 'fas fa-file-text',
    fileInvoice: 'fas fa-file-invoice',
    folderOpen: 'fas fa-folder-open',
    glassCheers: 'fas fa-glass-cheers',
    globe: 'fas fa-globe',
    handHoldingUsd: 'fas fa-hand-holding-usd',
    headset: 'fas fa-headset',
    houseUser: 'fas fa-house-user',
    icons: 'fas fa-icons',
    idBadge: 'fas fa-id-badge',
    invoiceDollar: 'fas fa-file-invoice-dollar',
    layerGroup: 'fas fa-layer-group',
    levelUp: 'fas fa-level-up-alt',
    listAlt: 'fas fa-list-alt',
    listTh: 'fas fa-th-list',
    mailBulk: 'fas fa-mail-bulk',
    mapMarker: 'fas fa-map-marker-alt',
    mapMarkedAlt: 'fas fa-map-marked-alt',
    moneyBill: 'fa fa-money-bill',
    moneyCheckAlt: 'fas fa-money-check-alt',
    //moneyBillWave: 'fa fa-money-bill-wave',
    moneyBillWave: 'fas fa-money-bill-wave',
    notEqual: 'fas fa-not-equal',
    paperClip: 'fas fa-paperclip',
    percentage: 'fas fa-percentage',
    piggyBank: 'fas fa-piggy-bank',
    print: 'fas fa-print',
    receipt: 'fas fa-receipt',
    tag: 'fas fa-tag',
    tags: 'fas fa-tags',
    textHeight: 'fas fa-text-height',
    shoppingCart: 'fas fa-shopping-cart',
    sign: 'fas fa-sign',
    sortNumericDown: 'fas fa-sort-numeric-down',
    square: 'fa fa-square',
    stickyNote: 'far fa-sticky-note',
    stream: 'fas fa-stream',
    sync: 'fas fa-sync',
    usd: 'fa fa-dollar-sign',
    university: 'fas fa-university',
    userCog: 'fas fa-user-cog',
    usersSlash: 'fas fa-users-slash',
    userTie: 'fas fa-user-tie',
    userEdit: 'fas fa-user-edit',
    userClock: 'fas fa-user-clock',
    userLock: 'fas fa-user-lock',
    voteYea: 'fas fa-vote-yea',
    windowRestoreFas: 'fas fa-window-restore',
    windowRestoreFar: 'far fa-window-restore',
  },
  images: {
    address: '/images/locationIcon.png',
    detailsIcon: '/images/detailsIcon.png',
    email: '/images/EmailIcon.png',
    emojies_eyes: '/images/emojies_eyes.png',
    facebook: '/images/FacebookIcon.png',
    instagram: '/images/InstagramIcon.png',
    itemsLogo: '/images/items.png',
    appLogo: '/images/MercadoLibreLogo.png',
    logoCHEJ: '/images/logo_chej.png',
    logoCompany: '/images/LogoCompany.png',
    logoCompanyNotBackgroud: '/images/LogoSinFondo.png',
    noImage: '/images/NoImage.png',
    notificationsToast: '/images/NotificationToastsIcon.png',
    userLogin: '/images/UserIcon.png',
    passwordIcon01: '/images/PasswordIcon.png',
    passwordIcon02: '/images/passwordIcon02.png',
    phone: '/images/TelephoneIcon.png',
    rateLogo: '/images/RatesIcon.png',
    role: '/images/role.png',
    roles: '/images/roles.png',
    rrss: '/images/RRSSIcon.png',
    telegram: '/images/TelegramIcon.png',
    twitter: '/images/TwitterIcon.png',
    users: '/images/users.png',
    user: '/images/user.png',
    whatsApp: '/images/WhatsAppIcon.png',
    icons: {
      advancedCommands: '/images/icons/advancedCommands.png',
      bot: '/images/icons/bot.png',
      categories: '/images/icons/list.png',
      checkSquare: '/images/icons/check.png',
      comment: '/images/icons/comment.png',
      dataProtection: '/images/icons/dataProtection.png',
      email: '/images/icons/email.png',
      error404: '/images/icons/error404.png',
      forex: '/images/icons/forex.png',
      group: '/images/icons/group.png',
      info: '/images/icons/info.png',
      largeLanguageModels: '/images/icons/llm.png',
      llmModel: '/images/icons/llmModel.png',
      map: '/images/icons/map.png',
      newMessage: '/images/icons/newMessage.png',
      pricetag: '/images/icons/price-tag.png',
      review: '/images/icons/review.png',
      siteMap: '/images/icons/site-map.png',
      smartphone: '/images/icons/smartphone.png',
      socialMedia: '/images/icons/socialMedia.png',
      store: '/images/icons/store.png',
    },
  },
  labels: {
    abbrevations: {
      'supportDept': {
        en: 'Support Dept.',
        es: 'Dpto. Soporte',
      },
      'salesDept': {
        en: 'Sales Dept.',
        es: 'Dpto. Ventas',
      },
      administrationDept: {
        en: 'Administration Dept.',
        es: 'Dpto. Administración',
      },
    },
    about: {
      en: 'About',
      es: 'Acerca de',
    },
    accountApproved: {
      en: 'Account approved',
      es: 'Cuenta aprobada',
    },
    accountNotApproved: {
      en: 'Account not approved',
      es: 'Cuenta no aprobada',
    },
    accountPendingApproval: {
      en: 'Account pending approval',
      es: 'Cuenta pendiente de aprobación',
    },
    advantages: {
      en: 'Advantages',
      es: 'Ventajas',
    },
    security: {
      en: 'Security',
      es: 'Seguridad',
    },
    sincerely: {
      en: 'Sincerely...',
      es: 'Atentamente...',
    },
    buyer: {
      en: 'Buyer',
      es: 'Comprador',
    },
    account: {
      en: 'Account',
      es: 'Cuenta',
    },
    accountDisabled: {
      en: 'Account disabled',
      es: 'Cuenta deshabilitada',
    },
    accountDeleted: {
      en: 'Account deleted',
      es: 'Cuenta eliminada',
    },
    accountNotDeleted: {
      en: 'Account not deleted',
      es: 'Cuenta no eliminada',
    },
    accountEnabled: {
      en: 'Account enabled',
      es: 'Cuenta habilitada',
    },
    accounts: {
      en: 'Accounts',
      es: 'Cuentas',
    },
    accountInformation: {
      en: 'Account information',
      es: 'Información de la cuenta',
    },
    add: {
      en: 'Add',
      es: 'Agregar',
    },
    addNewRate: {
      en: 'Add new rate',
      es: 'Agregar tasa nueva',
    },
    address: {
      en: 'Address',
      es: 'Dirección',
    },
    advancedCommand: {
      en: 'Advanced command',
      es: 'Comando avanzado',
    },
    advancedCommands: {
      en: 'Advanced commands',
      es: 'Comandos avanzados',
    },
    aiApiKey: {
      en: 'Artificial intelligence API Key',
      es: 'Inteligencia artificial API Key'
    },
    allUsers: {
      en: 'All users',
      es: 'Todos los usuarios',
    },
    applyTo: {
      en: 'Apply to',
      es: 'Aplicar a',
    },
    artificialIntelligence: {
      en: 'Artifical intelligence',
      es: 'Inteligencia artificial',
    },
    assigRole: {
      en: 'Assig role',
      es: 'Role asignado',
    },
    authorizate: {
      en: 'Authorizate',
      es: 'Autorizar',
    },
    authentication: {
      en: 'Authentication',
      es: 'Autenticación',
    },
    authorized: {
      en: 'Authorized',
      es: 'Autorizado',
    },
    authUser: {
      en: 'Auth. user',
      es: 'Autor. usuario',
    },
    availableQuantity: {
      en: 'Available quantity',
      es: 'Cantidad disponible',
    },
    calculateRates: {
      en: 'calculate rates',
      es: 'Calcular tasa',
    },
    changePassword: {
      en: 'Change password',
      es: 'Cambiar contraseña',
    },
    checkRegistrationStatus: {
      en: 'Check registration status',
      es: 'Consultar estado de registro',
    },
    clearTokenLogs: {
      en: 'Clear token logs',
      es: 'Borrar registros de token',
    },
    comment: {
      en: 'Comment',
      es: 'Comentario',
    },
    contact: {
      en: 'Contact',
      es: 'Contacto'
    },
    createNew: 'Create new',
    currency: {
      en: 'Currency',
      es: 'Moneda',
    },
    currentPassword: {
      en: 'Current password',
      es: 'Contraseña actual',
    },
    approvalDone: {
      en: 'Approval done',
      es: 'Aprobación realizada',
    },
    back: {
      en: 'Back',
      es: 'Volver',
    },
    bot: {
      en: 'Bot',
      es: 'Robot',
    },
    bots: {
      en: 'Bots',
      es: 'Robots',
    },
    cancel: {
      en: 'Cancel',
      es: 'Cancelar',
    },
    category: {
      en: 'Category',
      es: 'Categoría',
    },
    categories: {
      en: 'Categories',
      es: 'Categorías',
    },
    clickToChangePicture: {
      en: 'Click to change picture',
      es: 'Clic para cambiar la imagen',
    },
    close: {
      en: 'Close',
      es: 'Cerrar',
    },
    code: {
      en: 'Code',
      es: 'Código',
    },
    country: {
      en: 'Country',
      es: 'País',
    },
    confrEmail: {
      en: 'Confr. email',
      es: 'Confir. correo',
    },
    confirmationDone: {
      en: 'Confirmation done',
      es: 'Confirmación realizada',
    },
    confirmNewPassword: {
      en: 'Confirm new password',
      es: 'Confirmar contraseña nueva',
    },
    copy: {
      en: 'Copy',
      es: 'Copiar',
    },
    create: {
      en: 'Create',
      es: 'Crear',
    },
    createAccount: {
      en: 'Create account',
      es: 'Crear cuenta',
    },
    created: {
      en: 'Created',
      es: 'Creado',
    },
    date: {
      en: 'Date',
      es: 'Fecha',
    },
    dateTime: {
      en: 'Date / time',
      es: 'Fecha / hora',
    },
    day: {
      en: 'Day',
      es: 'Día',
    },
    delete: {
      en: 'Delete',
      es: 'Eliminar'
    },
    deleted: {
      en: 'Deleted',
      es: 'Eliminado',
    },
    deleteAccount: {
      en: 'Delete account',
      es: 'Eliminar cuenta',
    },
    description: {
      en: 'Description',
      es: 'Descripción',
    },
    detail: {
      en: 'Detail',
      es: 'Detalle',
    },
    details: {
      en: 'Details',
      es: 'Detalles',
    },
    disabled: {
      en: 'Disabled',
      es: 'Deshabilitado',
    },
    disableAccount: {
      en: 'Disable account',
      es: 'Deshabilitar cuenta',
    },
    displayName: {
      en: 'Display name',
      es: 'Nombre para mostrar',
    },
    edit: {
      en: 'Edit',
      es: 'Editar',
    },
    email: {
      en: 'Email',
      es: 'Correo',
    },
    emailVerified: {
      en: 'Email verified',
      es: 'Correo verificado',
    },
    emailNotVerified: {
      en: 'Email not verified',
      es: 'Correo no verificado',
    },
    emailPlaceholder: {
      en: 'name@company.com',
      es: 'nombre@empresa.com',
    },
    emailConfi: {
      en: 'Email confi.',
      es: 'Correo confir.',
    },
    emails: {
      en: 'Emails',
      es: 'Correos',
    },
    emoji: {
      en: 'Emoji',
      es: 'Emoji',
    },
    emojis: {
      en: 'Emojis',
      es: 'Emojis',
    },
    enable: {
      en: 'Enable',
      es: 'Habilitar',
    },
    enabled: {
      en: 'Enabled',
      es: 'Habilitado',
    },
    enableAccount: {
      en: 'Enable account',
      es: 'Habilitar cuenta',
    },
    enterRemark: {
      en: 'Enter a remark',
      es: 'Ingrese un comentario',
    },
    enterYourEmailCheckStatus: {
      en: 'Enter your email to check status',
      es: 'Ingrese su correo para verificar el estado',
    },
    enterYourEmail: {
      en: 'Enter your email',
      es: 'Ingrese su correo',
    },
    error: {
      en: 'Error',
      es: 'Error',
    },
    event: {
      en: 'Event',
      es: 'Evento',
    },
    events: {
      en: 'Events',
      es: 'Eventos',
    },
    example: {
      en: 'Example',
      es: 'Ejemplo',
    },
    firstName: {
      en: 'First name',
      es: 'Nombre',
    },
    fullName: {
      en: 'Full name',
      es: 'Nombre y apellido',
    },
    getContext: {
      en: 'Get context',
      es: 'Obtener contexto',
    },
    getToken: {
      en: 'Get token',
      es: 'Obtener token',
    },
    getUserInfo: {
      en: 'Get user info',
      es: 'obtener información del usuario',
    },
    forgotYourPassword: {
      en: 'Forgot your password?',
      es: '¿Olvidaste tu contraseña?'
    },
    home: {
      en: 'Home',
      es: 'Inicio',
    },
    image: {
      en: 'Image',
      es: 'Imagen',
    },
    images: {
      en: 'Images',
      es: 'Imagenes',
    },
    item: {
      en: 'Item',
      es: 'Artículo',
    },
    items: {
      en: 'Items',
      es: 'Artículos',
    },
    index: {
      en: 'Index',
      es: 'Índice',
    },
    information: {
      en: 'Information',
      es: 'Información',
    },
    isActive: {
      en: 'Is active',
      es: 'Está activa',
    },
    largeLanguageModel: {
      en: 'Large Language Model',
      es: 'Modelo de Lenguaje Grande',
    },
    largeLanguageModels: {
      en: 'Large Language Models',
      es: 'Modelos de Lenguaje Grande',
    },
    latestPostsCreated: {
      en: 'Latest posts created',
      es: 'Últimas publicaciones creadas',
    },
    lastName: {
      en: 'Last name',
      es: 'Apellidos',
    },
    lineReturn: {
      en: 'Line return',
      es: 'Retorno de línea',
    },
    listingTypeId: {
      en: 'Listing type Id',
      es: 'Tipo de publicación'
    },
    loading: {
      en: 'Loading',
      es: 'Cargando',
    },
    login: {
      en: 'Login',
      es: 'Iniciar sesión',
    },
    logOff: 'Log off',
    message: {
      en: 'Message',
      es: 'Mensaje',
    },
    metric: {
      en: 'Metric',
      es: 'Métrica',
    },
    metrics: {
      en: 'Metrics',
      es: 'Métricas',
    },
    modifiedBy: {
      en: 'Modified by',
      es: 'Modificado por',
    },
    model: {
      en: 'Model',
      es: 'Modelo',
    },
    models: {
      en: 'Models',
      es: 'Modelos',
    },
    module: {
      en: 'Module',
      es: 'Módulo',
    },
    moreInfo: {
      en: 'More info',
      es: 'Más info',
    },
    myStatus: {
      en: 'My status',
      es: 'Mi estado',
    },
    newPassword: {
      en: 'New password',
      es: 'Contraseña nueva',
    },
    newPrice: {
      en: 'New price',
      es: 'Precio nuevo',
    },
    name: {
      en: 'Name',
      es: 'Nombre',
    },
    nickName: {
      en: 'Nick name',
      es: 'Seudónimo',
    },
    no: {
      en: 'No',
      es: 'No',
    },
    notification: {
      en: 'Notification',
      es: 'Notificación',
    },
    notifications: {
      en: 'Notifications',
      es: 'Notificaciones',
    },
    notificationsToast: {
      en: 'Notifications (toast)',
      es: 'Notificaciones (toast)'
    },
    number: {
      en: 'Number',
      es: 'Número'
    },
    order: {
      en: 'Order',
      es: 'Pedido',
    },
    orders: {
      en: 'Orders',
      es: 'Pedidos',
    },
    password: {
      en: 'Password',
      es: 'Contraseña',
    },
    passwordConfirm: {
      en: 'Password confirm',
      es: 'confirmar contraseña',
    },
    pending: {
      en: 'Pending',
      es: 'Pendiente',
    },
    phone: {
      en: 'Phone',
      es: 'Teléfono',
    },
    phones: {
      en: 'Phones',
      es: 'Teléfonos',
    },
    phoneNumber: {
      en: 'Phone number',
      es: 'Número de teléfonor',
    },
    phoneNumberPlaceholder: {
      en: '+1 123 1234567',
      es: '+58 123 1234567',
    },
    personalInformation: {
      en: 'Personal information',
      es: 'Información personal',
    },
    priceOtherCurrency: {
      en: 'Price other currency',
      es: 'Precio otra moneda',
    },
    price: {
      en: 'Price',
      es: 'Precio',
    },
    priceML: {
      en: 'Price ML',
      es: 'Precio ML',
    },
    priceOC: {
      en: 'Price OC',
      es: 'Precio OM',
    },
    priority: {
      en: 'Priority',
      es: 'Prioridad',
    },
    privacy: {
      en: 'Privacy',
      es: 'Privacidad'
    },
    privacyPolicy: {
      en: 'Privacy policy',
      es: 'Política de privacidad',
    },
    privacyAndConditions: {
      en: 'Privacy and conditions',
      es: 'Privacidad y condiciones',
    },
    process: {
      en: 'Process',
      es: 'Procesos',
    },
    processesCompletedSuccessfully: {
      en: 'Processes completed successfully',
      es: 'Procesos completados con éxito',
    },
    profile: {
      en: 'Profile',
      es: 'Perfil',
    },
    protectedByReCAPTCHA: {
      en: 'Protected by reCAPTCHA',
      es: 'Protegido por reCAPTCHA',
    },
    provider: {
      en: 'Provider',
      es: 'Proveedor',
    },
    quantity: {
      en: 'Quantity',
      es: 'Cantidad',
    },
    question: {
      en: 'Question',
      es: 'Pregunta',
    },
    rate: {
      en: 'Rate',
      es: 'Tasa',
    },
    rates: {
      en: 'Rates',
      es: 'Tasas',
    },
    registrationJourney: {
      en: 'Registration journey',
      es: 'Viaje de registro',
    },
    registerDate: {
      en: 'Register date',
      es: 'Fecha de registro',
    },
    registerNewMembership: {
      en: 'Register a new membership',
      es: 'Registrar una nueva membresía',
    },
    registerStatus: {
      en: 'Register status',
      es: 'Estatus registro',
    },
    registry: {
      en: 'Registry',
      es: 'Registro',
    },
    rememberMe: {
      en: 'Remember Me?',
      es: '¿Recordarme?',
    },
    restore: {
      en: 'Restore',
      es: 'Restaurar',
    },
    restoreAccount: {
      en: 'Restore account',
      es: 'Restaurar cuenta',
    },
    ratesVariations: {
      en: 'Rates variations',
      es: 'Variaciones de tasa',
    },
    reAuthentication: {
      en: 'Re Authentication',
      es: 'Re autenticación',
    },
    registrationDone: 'Registration done',
    role: {
      en: 'Role',
      es: 'Rol',
    },
    roles: {
      en: 'Roles',
      es: 'Roles',
    },
    roleAssigned: {
      en: 'Role assigned',
      es: 'Role asignado',
    },
    roleNotAssigned: {
      en: 'Role not assigned',
      es: 'Role no asignado',
    },
    roleAssignmentDone: {
      en: 'Role assignment done',
      es: 'Asignación de role realizada',
    },
    sale: {
      en: 'Sale',
      es: 'Venta',
    },
    sales: {
      en: 'Sales',
      es: 'Ventas',
    },
    save: {
      en: 'Save',
      es: 'Guardar',
    },
    search: {
      en: 'Search',
      es: 'Buscar',
    },
    seeAllPosts: {
      en: 'See all posts',
      es: 'Ver todas las publicaciones'
    },
    seeAllRates: {
      en: 'See all rates',
      es: 'Ver todas las tasas'
    },
    allRightsReserved: {
      en: 'All rights reserved.',
      es: 'Todos los derechos reservados.',
    },
    seeItems: {
      en: 'See items',
      es: 'Ver artículos',
    },
    secondId: {
      en: 'Second id',
      es: 'Id secundario',
    },
    securedConnection: {
      en: 'Secured Connection',
      es: 'Conexión segura',
    },
    selectRole: {
      en: 'Select a role',
      es: 'Selecciona un rol',
    },
    seller: {
      en: 'Seller',
      es: 'Vendedor',
    },
    send: {
      en: 'Send',
      es: 'Enviar',
    },
    session: {
      en: 'Session',
      es: 'Sesión',
    },
    settings: {
      es: 'Configuraciones',
      en: 'Settings',
    },
    signIn: {
      en: 'Sign in',
      es: 'iniciar sesión',
    },
    signInToStartYourSession: {
      en: 'Sign in to start your session',
      es: 'Regístrese para iniciar su sesión',
    },
    site: {
      en: 'Site',
      es: 'Sitio',
    },
    sites: {
      en: 'Sites',
      es: 'Sitios',
    },
    status: {
      en: 'Status',
      es: 'Estado',
    },
    socialNetworks: {
      en: 'Social netwroks',
      es: 'Redes sociales',
    },
    subject: {
      en: 'Subject',
      es: 'Asunto',
    },
    success: {
      en: 'Success',
      es: 'Éxito',
    },
    sync: {
      en: 'Sync',
      es: 'Sincronizar',
    },
    synchronizeItems: {
      en: 'Synchronize items',
      es: 'Sincronizar artículos',
    },
    systemAdministratorMustApproveAccount: {
      en: 'A system administrator must approve your account',
      es: 'Un administrador del sistema debe aprobar su cuenta',
    },
    systemAdministratorMustAssignYouRole: {
      en: 'A system administrator must assign you a role',
      es: 'Un administrador del sistema debe asignarle un rol',
    },
    systemAdministratorAssignedRole: {
      en: 'The system administrator assigned your role',
      es: 'El administrador del sistema asignó su rol',
    },
    tab: {
      en: 'Tab',
      es: 'Tabulador'
    },
    telegram: {
      en: 'Telegram',
      es: 'Telegram',
    },
    theUserHasAlReadyConfirmedEmail: {
      en: 'The user has already confirmed the email',
      es: 'El usuario ya ha confirmado el correo electrónico',
    },
    theSystemAdministratorApprovedAccount: {
      en: 'The system administrator approved your account',
      es: 'El administrador del sistema aprobó su cuenta',
    },
    theUserHasAlreadyMadeRegistration: {
      en: 'The user has already made the registration',
      es: 'El usuario ya ha realizado el registro.',
    },
    thisUser: {
      en: 'This user',
      es: 'Este usuario',
    },
    time: {
      en: 'Time',
      es: 'Hora',
    },
    title: {
      en: 'Title',
      es: 'Título',
    },
    user: {
      en: 'User',
      es: 'Usuario',
    },
    userCode: {
      en: 'User code',
      es: 'Código usuario',
    },
    userId: {
      en: 'User Id',
      es: 'Id usuario',
    },
    users: {
      es: 'Usuarios',
      en: 'Users',
    },
    userName: {
      en: 'User name',
      es: 'Nombre de usuario',
    },
    undefined: 'Undefined',
    yes: {
      en: 'Yes',
      es: 'Si'
    },
    youCanNowLogIntoOurSystemWithCredentials: {
      en: 'You can now log into our system with your credentials',
      es: 'Ya puedes iniciar sesion a nuestro sistema con tus credenciales'
    },
    youMustFinishAboveProcessesAccessSystem: {
      en: 'You must finish the above processes to access the system',
      es: 'Debe finalizar los procesos anteriores para acceder al sistema',
    },
    version: {
      en: 'Version',
      es: 'Versión',
    },
    verfEmail: {
      en: 'Verf. email',
      es: 'Verif. Correo',
    },
    viewAllRates: {
      en: 'View all rates',
      es: 'Ver todas las tasas',
    },
    waitingConfirmation: {
      en: 'Waiting confirmation',
      es: 'Esperando confimación',
    },
    waitingApproval: {
      en: 'Waiting for approval',
      es: 'A la espera de aprobación',
    },
    waitingAssignRole: {
      en: 'Waiting to assign role',
      es: 'A la espera de asignar un rol',
    },
    waitingPreviousProcesses: {
      en: 'Waiting for previous processes',
      es: 'En espera de procesos anteriores',
    },
    warning: {
      en: 'Warning',
      es: 'Advertencia',
    },
    wellcomeEmail: {
      en: 'Wellcome email',
      es: 'Correo bienvenida',
    },
  },
  lineReturn: {
    br: '<br/>',
    ln: '\n',
  },
  languages: {
    en: {
      code: 'en',
      id: 'en',
      format: {
        date: {
          f1: 'm/d/y',
          f2: 'm-d-y',
          f3: 'mm/dd/yy',
          f4: 'mm-dd-yy',
          f5: 'mm/dd/yyyy',
          f6: 'mm-dd-yyyy',
          f7: 'M/D/Y',
          f8: 'M-D-Y',
          f9: 'MM/DD/YY',
          f10: 'MM-DD-YY',
          f11: 'MM/DD/YYYY',
          f12: 'MM-DD-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'HH:mm',
            hhmmss: 'HH:mm:ss',
          },
          type: 24,
        },
      },
      numbers: {
        separators: {
          decimals: '.',
          thousands: ',',
        },
      },
    },
    enUS: {
      code: 'en-US',
      id: 'en',
      format: {
        date: {
          f1: 'm/d/y',
          f2: 'm-d-y',
          f3: 'mm/dd/yy',
          f4: 'mm-dd-yy',
          f5: 'mm/dd/yyyy',
          f6: 'mm-dd-yyyy',
          f7: 'M/D/Y',
          f8: 'M-D-Y',
          f9: 'MM/DD/YY',
          f10: 'MM-DD-YY',
          f11: 'MM/DD/YYYY',
          f12: 'MM-DD-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'HH:mm',
            hhmmss: 'HH:mm:ss',
          },
          type: 24,
        },
      },
      numbers: {
        separators: {
          decimals: '.',
          thousands: ',',
        },
      },
    },
    es: {
      code: 'es',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esAR: {
      code: 'es-AR',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esCL: {
      code: 'es-CL',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esCO: {
      code: 'es-CO',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esMX: {
      code: 'es-MX',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esUS: {
      code: 'es-US',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    esVE: {
      code: 'es-VE',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
    es419: {
      code: 'es-419',
      id: 'es',
      format: {
        date: {
          f1: 'd/m/y',
          f2: 'd-m-y',
          f3: 'dd/mm/yy',
          f4: 'dd-mm-yy',
          f5: 'dd/mm/yyyy',
          f6: 'dd-mm-yyyy',
          f7: 'D/M/Y',
          f8: 'D-M-Y',
          f9: 'DD/MM/YY',
          f10: 'DD-MM-YY',
          f11: 'DD/MM/YYYY',
          f12: 'DD-MM-YYYY',
          f13: 'YYYY-MM-DD',
        },
        time: {
          f1: 'HH:mm',
          f2: 'HH:mm:ss',
          f3: 'hh:mm a',
          f4: 'hh:mm:ss a',
          picker: {
            hhmm: 'hh:mm a',
            hhmmss: 'hh:mm:ss a',
          },
          type: 12,
        },
      },
      numbers: {
        separators: {
          decimals: ',',
          thousands: '.',
        },
      },
    },
  },
  localStorage: {
    accountId: 'VzLaMl_account',
    redirectId: 'VzLaMl_redirectUrl',
    theme: 'VzLaMl_theme',
  },
  menu: {
    left: {
      home: {
        home: '',
        subHome: '',
        index: '',
        about: '',
        contact: '',
        privacy: '',
      },
    },
  },
  messages: {
    addToken: 'Add token please wait...',
    afterDeletingPublicationThereIsNoGoingBack: {
      en: 'After <b>deleting</b> a publication there is no going back',
      es: 'Después de <b>borrar</b> una publicación no hay vuelta atrás',
    },
    allowedCharacters: {
      en: 'Allowed characters',
      es: 'Caracteres permitidos',
    },
    areYouSureDeleteThis: {
      en: 'Are you sure delete this?',
      es: '¿Estás seguro de eliminar esto?'
    },
    areYouSureToLogOut: {
      en: 'Are you sure to logout?',
      es: '¿Estás seguro de cerrar sesión?',
    },
    avaliableQuantityYouMustEnterOnlyNumbersAndDot: '<b>Avaliable quantity</b><br/>You must enter only numbers and a dot',
    availableQuantityBeMustGreaterThanZero: {
      en: '<b>Available quantity</b> be must greater than zero',
      es: '<b>Cantidad disponible</b> debe ser mayor que cero',
    },
    charactersRemaining: {
      en: 'Characters remaining',
      es: 'Caracteres restantes',
    },
    closedItemCanOnlyBeActivatedOrDeleted: {
      en: 'Closed item can only be <b>activated</b> or <b>deleted</b>',
      es: 'Items cerrado solo pueden ser <b>activados</b> o <b>eliminados</b>',
    },
    creatingNewRate: {
      en: 'Creating new rate, please wait...',
      es: 'Creando tasa nueva, pro favor espere...'
    },
    currentPasswordNotValid: 'Current password is not valid',
    noDataAvailable: {
      en: 'No data available',
      es: 'Datos no disponibles'
    },
    deleteTokenLogs: 'Delete tokens (logs) please wait...',
    deleteUserProcesing: 'Delete user Procesing please wait...',
    displaysTheBuyerName: {
      en: 'Displays the buyer name',
      es: 'Muestra e nombre del comprador',
    },
    displaysTheGreetingAccordingToTheTime: {
      en: 'Displays the greeting according to the time',
      es: 'Muestra el saludo según la hora',
    },
    doYouWantAuthorizeTheUser: 'Do you want to authorize the user',
    doYouWantRemoveTheUserAuthorization: 'Do you want to remove the user authorization',
    doYouWantToChangeTheAuthorizationStatus: {
      en: 'do you want to change the authorization status?',
      es: '¿Desea cambiar el estado de autorización?',
    },
    doYouWantToChangeTheEmailConfirmationStatus: {
      en: 'Do you want to change the email confirmation status?',
      es: '¿Desea cambiar el estado de la confirmación correo electrónico?',
    },
    doYouWantToEnableTheAccount: {
      en: 'Do you want to enable the account?',
      es: '¿Desea habilitar la cuenta?',
    },
    doYouWantToDisableTheAccount: {
      en: 'Do you want to disable the account?',
      es: '¿Desea deshabilitar la cuenta?',
    },
    doYouWantToRestoreDeletedRegistry: {
      en: 'Do you want to restore deleted registry?',
      es: '¿Desea restaurar el registro eliminado?',
    },
    doYouWantToSendWelcomeEmail: {
      en: 'Do you want to send a welcome email?',
      es: '¿Quieres enviar un email de bienvenida?',
    },
    doYouWantConfirmTheEmail: 'Do you want to confirm the email',
    doYouWantSendTheConfirmationEmail: {
      en: 'Do you want to send the confirmation email',
      es: '¿Desea enviar el email de confirmación?',
    },
    doYouWantGenerateAuthorization: {
      en: 'Do you want to generate authorization?',
      es: '¿Desea generar una autorización?',
    },
    doYouWantToGenerateTheToken: {
      en: 'Do you want to generate the token?',
      es: '¿Desea generar el token?',
    },
    doYouWantUpdateData: {
      en: 'Do you want to update the data?',
      es: '¿Desea actualizar los datos?',
    },
    doYouWantToEnableTheAccountSeeTheAddedCommentOrCancel: {
      en: 'Do you want to enable the account, see the added comment or cancel?',
      es: '¿Desea habilitar la cuenta, ver el comentario agregado o cancelar?',
    },
    doYouWantToRestoreTheRecordViewTheAddedCommentOrCancel: {
      en: 'Do you want to restore the record, view the added comment or cancel?',
      es: '¿Desea restaurar el registro, ver el comentario agregado o cancelar?',
    },
    doYouWantToDisableTheRecordViewTheAddedCommentOrCancel: {
      en: 'Do you want to disable the record, view the added comment or cancel?',
      es: '¿Desea deshabilitar el registro, ver el comentario agregado o cancelar?',
    },
    doYouWantRemoveTheConfirmationFromEmail: {
      en: 'Do you want to remove the confirmation from the email?',
      es: '¿Desea eliminar la confirmación del correo?',
    },
    emojiCopiedToMemory: {
      en: 'Emoji copied to memory',
      es: 'Emoji copiado en memoria',
    },
    forgotPasswordSubTitle01: {
      en: 'You must enter your <b>email</b> to send the password recovery instructions',
      es: 'Debes introducir tu <b>correo</b> para enviar las instrucciones de recuperación de contraseña'
    },
    forgotPasswordSubTitle02: {
      en: 'The email must be previously <b>registered in our system</b>, otherwise no information will be sent',
      es: 'El correo debe estar previamente <b>registrado en nuestro sistema</b>, de lo contrario no se enviará la información',
    },
    freeItemsOnlyAllowOneQuantity: {
      en: 'Free items only allow <b>1</b> quantity',
      es: 'Los artículos gratuitos sólo admiten <b>1</b> cantidad',
    },
    forSecurityReasonsYouMustLogInWithTheNewPassword: {
      en: 'For security reasons you must log in with the new password',
      es: 'Por seguridad deberá iniciar sesión con la nueva contraseña',
    },
    getUsers: {
      en: 'Get users, please wait...',
      es: 'Obteniendo usuarios, por favor espere...',
    },
    getUser: {
      en: 'Get user, please wait...',
      es: 'Buscando usuario, por favor espere..'
    },
    getUserData: 'Get user data please wait...',
    getItemData: {
      en: 'Get item id data, please wait...',
      es: 'Opteniendo datos del item, favor espere...',
    },
    getItemsId: 'Get items id, please wait...',
    getItemsDetails: 'Get items details, please wait...',
    getUserInformation: 'Get user information, please wait...',
    getRates: {
      en: 'Get rates, please wait...',
      es: 'Opteniendo tasas, favor espere...',
    },
    getTokenData: 'Get token data please wait...',
    getTokenNew: 'Get token (new) please wait...',
    getTokenLogs: 'Get tokens (logs) please wait...',
    getTokenRefresh: 'Get token (refresh) please wait...',
    itemUpdatedSuccessfully: {
      en: 'Item updated successfully',
      es: 'Artículo actualizado satisfactoriamente',
    },
    itWillAutomaticallyCalculatePriceAnotherCurrency: {
      en: 'It will automatically calculate<br/>The <b>price of another currency</b>',
      es: 'Calcula automáticamente<br/>El <b>precio en otra moneda</b>',
    },
    maximunWeightAllowed: {
      en: 'Maximum weight allowed',
      es: 'Peso máximo permitido',
    },
    multipleRecordsCannotHaveTheSamePriority: {
      en: 'Multiple records cannot have the same priority',
      es: 'Múltiples registros no pueden tener la misma prioridad',
    },
    newPasswordAndNewPasswordConfirmNotMatch: {
      en: 'The <b>new password</b> and <b>new password confirm</b> fields do not match',
      es: 'Los campos <b>nueva contraseña</b> y <b>nueva contraseña confirmada</b> no coinciden',
    },
    noPublicationsYet: {
      en: 'No publications yet',
      es: 'No hay publicaciones aún',
    },
    onlyImageTypeFilesAreAllowed: {
      en: 'Only <b>image</b> type files are <b>allowed</b>',
      es: 'Solo los archivos de tipo <b>imagen</b> están <b>permitidos</b>',
    },
    onlyPlainTextIsAllowed: {
      en: 'Only plain text is allowed',
      es: 'Sólo se permite texto sin formato',
    },
    onlyTheFollowingFilesAreAllowed: {
      en: 'Only the following files are allowed',
      es: 'Soló se permiten los siguientes archivos',
    },
    pageNotFound: {
      en: 'Page not found',
      es: 'Página no encontrada'
    },
    passwordMinimunCharacters: {
      en: `Minimun <b>${settingsPassword.maxLength}</b> characters`,
      es: `Mínimo <b>${settingsPassword.maxLength}</b> caracteres`,
    },
    passwordAndPasswordConfirmNotMatch: {
      en: 'The <b>Password</b> and <b>Password Confirm</b> fields do not match',
      es: 'La <b>contraseña</b> y la <b>confirmación de contraseña</b> no son iguales'
    },
    pleaseAcceptTheCaptcha: {
      en: 'Please accept the captcha',
      es: 'Por favor acepta el captcha',
    },
    pleaseTryAgain: {
      en: 'Please try again',
      es: 'Por favor vuelva a intentar',
    },
    processing: {
      en: 'Processing, please wait...',
      es: 'Procesando, por favor espere...',
    },
    processCompletedSuccessfully: {
      en: 'Process completed successfully',
      es: 'Proceso finalizado satisfactoriamente',
    },
    priceOtherCurrencyYouMustEnterOnlyNumbersAndDot: {
      en: '<b>Price other currency</b> you must enter only numbers and a dot',
      es: '<b>Precio en otra moneda</b> debe ingresar solo números y un punto'
    },
    priceOtherCurrencyBeMustGreaterThanOrEqualToZero: {
      en: '<b>Price other currency</b> be must greater than or equal to zero',
      es: '<b>Precio en otra moneda</b> debe ser mayor o igual a cero',
    },
    rememberToEnableTheBotAndAddMessageAccordingToItsFunction: {
      en: 'Remember to enable the robot and add message according to its function',
      es: 'Recuerda habilitar el robot y agregar mensaje según su función',
    },
    registerNewUserTittle01: {
      en: 'Perfect, you just need to verify your account',
      es: 'Perfecto, solo necesitas verificar tu cuenta',
    },
    rateCreatedSuccessfully: {
      en: 'Rate created successfully',
      es: 'Tasa creada satisfactoriamente',
    },
    selectEvent: {
      en: 'Select an event',
      es: 'Selecciona un evento',
    },
    selectMethod: {
      en: 'Select a method',
      es: 'Selecciona un método',
    },
    selectModel: {
      en: 'Select a model',
      es: 'Selecciona un modelo',
    },
    selectLargeLanguageModel: {
      en: 'Select a large language model',
      es: 'Selecciona un modelo de lenguaje largo',
    },
    selectUser: {
      en: 'Select a user',
      es: 'Selecciona un usuario',
    },
    systemAdministratorMustApproveYourAccount: 'A system <b>administrator</b> must approve your <b>account</b>',
    systemAdministratorMustAssignYouRole: 'A system <b>administrator</b> must assign you a <b>role</b>',
    synchronizingData: 'Synchronizing data, please wait...',
    textWithInvalidHtmlFormatting: {
      en: 'Text with invalid html formatting',
      es: 'Texto con formato html inválido',
    },
    theEmailAlreadyByAnotherAccount: 'The <b>email</b> address is <b>already</b> in use by another account',
    theItemIsInStatusUnderReviewYouMustCorrectTheProblemInTheMercadoLibrePortal: {
      en: 'The item is in status: <b>under review</b>, you must correct the problem in the <b>Mercado Libre</b> portal',
      es: 'El artículo se encuentra en estado: <b>en revisión</b>, debe corregir el problema en el portal de <b>Mercado Libre</b>',
    },
    thereIsNoDataToProcess: {
      en: 'There is no data to process',
      es: 'No hay datos que procesar',
    },
    thereAreNotRecordsDelete: 'There are not records to delete',
    theInstructionsPasswordRecoveryWereSentEmail: 'The instructions for the <b>password recovery</b> were sent to your email',
    //thePasswordHasBeenUpdatedSuccessfully: 'The data has been updated successfully',
    thePasswordHasBeenChangedSuccessfully: {
      en: 'The password has been changed successfully',
      es: 'La contraseña se ha modificado satisfactoriamente',
    },
    theRateMustBeGreaterThanZero: 'The rate must be greater than zero',
    thisProcessIrreversibleDoYouWishContinue: {
      en: 'This process is irreversible.<br/>Do you wish to continue?',
      es: 'Este proceso es irreversible<br/>¿Desea continuar?',
    },
    thisUserDoesNotExist: 'This user does not exist',
    thisFieldRequired: {
      en: 'This <b>field</b> is <b>required</b>',
      es: 'Este <b>campo</b> es requerido',
    },
    toDoThisYouMustEditTheInformation: {
      en: 'To do this you must edit the information',
      es: 'Para eso debe editar la información',
    },
    tokenCreatedSuccessfully: 'Token created successfully',
    tokenGeneratedSuccessfully: 'Token generated successfully',
    tokenHasExpired: 'The token has expired',
    tokenIsTillValid: 'The token is till valid',
    userEdited: 'User edited sucessfully',
    updateUser: 'Update user please wait...',
    userCreateSucessfully: 'User create sucessfully',
    userDeletedSucessfully: 'User detelted sucessfully',
    updatingItem: 'Updating item, please wait...',
    userUpdatedSuccessfully: 'User updated successfully',
    userMustHaveCodeBeforeGeneratingToken: {
      en: 'User must have code before generating token',
      es: 'El usuario debe tener el código antes de generar el token',
    },
    updateUserInformation: 'Update user information, please wait...',
    youCanNotAssingTheStatus: ({ statusType = '', languageId = 'en', }) => {
      switch (languageId) {
        case 'en':
          return `You cannot assign the status: <b>${statusType}</b><br/>That status is handled directly by <b>Mercado Libre</b>`;
        case 'es':
          return `No puede asignar el estatus: <b>${statusType}</b><br/>Esto es manejado directamente por <b>Mercado Libre</b>`;
        default:
          return `You cannot assign the status: <b>${statusType}</b><br/>That status is handled directly by <b>Mercado Libre</b>`
      }
    },

    youDoNotHaveSufficientPrivilegesToRunThisProcess: {
      en: 'You do not have sufficient privileges to run this process',
      es: 'No tiene suficientes privilegios para ejecutar este proceso',
    },
    youMustAddComment: {
      en: 'You must add a comment',
      es: 'Debes agregar un comentario',
    },
    youMustGreaterThanOrEqualToZero: {
      en: 'You must greater than or equal to zero',
      es: 'Debe ser mayor o igual que cero',
    },
    youMustLogInAccessThisSection: {
      en: 'You must <b>log in</b> to access this <b>section</b>',
      es: 'Debes estar <b>autenticado</b> para acceder a esta <b>sección</b>',
    },
    youMustConfirmYourEmailAccountCompleteRegistration: {
      en: 'You must confirm your email account to complete the registration',
      es: 'Debe confirmar su cuenta de correo electrónico para completar el registro',
    },
    youMustDefineFileTypes: {
      en: 'You must define file types',
      es: 'Debes definir tipo de archivos',
    },
    youMustEnterValidEmail: {
      en: 'You must enter valid <b>email</b>',
      es: 'Debe ingresar un <b>correo</b> válido',
    },
    youMustEnterValidTelegramId: {
      en: 'You must enter a valid <b>Telegram id</b>',
      es: 'debe introducir un <b>id</b> de <b>Telegram</b> válida',
    },
    youMustEnterOnlyNumbersAndDot: {
      en: 'You must enter only numbers and a dot',
      es: 'Debes ingresar solo números y un punto',
    },
    youMustChooseWhoToApplyTo: 'You must choose who to apply to',
    youMustEnterAnUserNameValid: 'You must enter an user name valid',
    youMustEnterValidPassword: {
      en: 'You must enter a valid <b>password</b>',
      es: 'Debes ingresar una <b>contraseña</b> válida',
    },
    youMustEnterValidNewPassword: {
      en: 'You must enter a valid <b>new password</b>',
      es: 'Debes ingresar una <b>contraseña nueva</b> válida',
    },
    youMustEnterValidPasswordConfirm: {
      en: 'You must enter a valid <b>password confirm</b>',
      es: 'Debes ingresar una <b>confirmación de contraseña</b> válida'
    },
    youMustEnterValidNewPasswordConfirm: {
      en: 'You must enter a valid <b>new password confirm</b>',
      es: 'Debes ingresar una <b>confirmacion de contraseña</b> válida',
    },
    youMustEnterValidPhoneNumber: {
      en: 'You must enter a valid <b>phone number</b>',
      es: 'Debes ingresar un <b>número de teléfono</b> válido',
    },
    youMustEnterValidAmount: 'You must enter a valid amount',
    youMustAnterDateTimeValue: 'You must enter a valid date time',
    youMustEnterValidTitle: 'You must enter a valid title',
    waitingConfirmation: 'Waiting confirmation',
    weCouldNotFindThePageYouWereLookingFor: {
      en: 'We could not find the page you were looking for',
      es: 'No podemos encontrar la página que estas buscando',
    },
  },
  mercadoLibre: {
    feedback: {
      ratings: {
        negative: 'negative',
        neutral: 'neutral',
        positive: 'positive',
      },
    },
    methods: {
      items: {
        itemsByUser: 'itemsByUser',
        itemsSend: 'itemsSend',
        calculateRates: 'calculateRates',
      },
      postSales: {
        buyer: {
          htmlFormat: false,
          maxLength: 0,
        },
        seller: {
          buyer: {
            fullName: '[buyerFullName]',
            nickName: '[buyerNickName]',
          },
          greeting: '[greeting]',
          htmlFormat: true,
          item: {
            title: '[itemTitle]',
            quantity: '[itemQuantity]',
            price: '[itemPrice]',
            priceOC: '[itemPriceOC]',
            dateTime: '[orderDateTime]',
          },
          maxLength: 350,
          maxMessages: 3,
          order: {
            date: '[orderDate]',
            dateTime: '[orderDateTime]',
            number: '[orderNumber]',
            time: '[orderTime]',
          },
        },
      },
      questionsAnswers: {
        answers: {
          buyerName: '[buyerName]',
          greeting: '[greeting]',
          htmlFormat: false,
          maxLength: 3000,
        },
      },
      sites: {
        get: 'sitesGet',
      },
    },
    objects: {
      html: {
        bots: {
          messageId: 'textAreaBotMessage',
          messageHideId: 'textAreaBotMessageHide',
          messageHideInnerTextId: 'messageHideInnerText',
          duallistboxId: 'duallistboxId',
        },
      },
    },
    process: {
      events: [
        { id: 'answers', moduleId: 'questionsAnswers', name: { en: 'Answers', es: 'Respuestas' }, },
        { id: 'questions', moduleId: 'questionsAnswers', name: { en: 'Questions', es: 'Preguntas' }, },
        { id: 'psmSendMessage', moduleId: 'postSalesMessaging', name: { en: 'Send message', es: 'Enviar mensaje' }, }
      ],
      modules: [
        { id: 'questionsAnswers', name: { en: 'Questions and answers', es: 'Preguntas y respuestas' }, },
        { id: 'postSalesMessaging', name: { en: 'Post sales messaging', es: 'Mensajería posventa' }, }
      ],
    },
    status: {
      active: 'active',
      closed: 'closed',
      deleted: 'deleted',
      paused: 'paused',
      under_review: 'under_review',
    },
    //urlApi: 'https://api.mercadolibre.com/',
    urlApi: 'https://api.mercadolibre.com',
    urlAuthorization: 'http://auth.mercadolibre.com/authorization?response_type=code&client_id=',
  },
  navOptions: {
    menu: 'navOptionMenu',
    item: 'navOptionItem',
  },
  numberPositions: {
    decimalsPlace: 2,
  },
  react: {
    CssfxLoading: {
      barWave: 'BarWave',
      bouncingBalls: 'BouncingBalls',
      coin: 'Coin',
      circularProgress: 'CircularProgress',
      fadingBalls: 'FadingBalls',
      fadingDots: 'FadingDots',
      fillingBottle: 'FillingBottle',
      flippingSquare: 'FlippingSquare',
      hypnosis: 'Hypnosis',
      messaging: 'Messaging',
      ring: 'Ring',
      spin: 'Spin',
      spinStretch: 'SpinStretch',
      twinSpin: 'TwinSpin',
    },
    html: {
      button: {
        classes: {
          disabled: 'btn disabled',
          progress: 'btn-progress',
        },
      },
      dropDown: {
        active: 'dropdown active',
        normal: 'dropdown',
      },
      li: {
        active: 'active text-primary',
        normal: '',
      },
      spaces: {
        one: '&nbsp;',
        two: '&nbsp;&nbsp;',
        three: '&nbsp;&nbsp;&nbsp;',
      },
      spinner: {
        borderSm: 'spinner-border spinner-border-sm mr-1',
      }
    },
    loadingComponents: {
      audio: 'audio',
      ballTriangle: 'ball_triangle',
      bars: 'bars',
      circles: 'circles',
      grid: 'grid',
      hearts: 'hearts',
      oval: 'oval',
      puff: 'puff',
      rings: 'rings',
      spinningCircles: 'spinning_circles',
      tailSpin: 'tail_spin',
      threeDots: 'three_dots',
    },
    tempusDominus: {
      buttons: {
        showToday: true,
        showClear: false,
        showClose: true,
      },
      icons: {
        time: 'fas fa-clock',
        date: 'fas fa-calendar',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'fas fa-calendar-check-o',
        clear: 'fas fa-trash',
        close: 'fas fa-times'
      },
      //#region old code
      // tooltips: {
      //   today: 'Hoy',
      //   clear: 'Inicializar selección',
      //   close: 'Cerrar selector',
      //   selectMonth: 'Seleccionar mes',
      //   prevMonth: 'Mes anterior',
      //   nextMonth: 'Próximo mes',
      //   selectYear: 'Seleccionar año',
      //   prevYear: 'Año anterior',
      //   nextYear: 'Año siguiente',
      //   selectDecade: 'Selecciondar decada',
      //   prevDecade: 'Década anterior',
      //   nextDecade: 'Década siguiente',
      //   prevCentury: 'Siglo anterior',
      //   nextCentury: 'Siglo siguiente',
      //   pickHour: 'Seleccionar hora',
      //   incrementHour: 'Incrementar hora',
      //   decrementHour: 'Disminuir hora',
      //   pickMinute: 'Seleccionar minuto',
      //   incrementMinute: 'ncrementar minuto',
      //   decrementMinute: 'Disminuir minuto',
      //   pickSecond: 'Seleccionar segundo',
      //   incrementSecond: 'Incrementar segundo',
      //   decrementSecond: 'Disminuir segundo',
      //   togglePeriod: 'Alternar período',
      //   selectTime: 'Seleccionar hora',
      //   selectDate: 'Seleccionar fecha'
      // },
      //#endregion old code
      tooltips: ({
        languageId = 'en'
      } = {}) => {
        switch (languageId) {
          case 'es':
            return {
              today: 'Hoy',
              clear: 'Inicializar selección',
              close: 'Cerrar selector',
              selectMonth: 'Seleccionar mes',
              prevMonth: 'Mes anterior',
              nextMonth: 'Próximo mes',
              selectYear: 'Seleccionar año',
              prevYear: 'Año anterior',
              nextYear: 'Año siguiente',
              selectDecade: 'Selecciondar decada',
              prevDecade: 'Década anterior',
              nextDecade: 'Década siguiente',
              prevCentury: 'Siglo anterior',
              nextCentury: 'Siglo siguiente',
              pickHour: 'Seleccionar hora',
              incrementHour: 'Incrementar hora',
              decrementHour: 'Disminuir hora',
              pickMinute: 'Seleccionar minuto',
              incrementMinute: 'Incrementar minuto',
              decrementMinute: 'Disminuir minuto',
              pickSecond: 'Seleccionar segundo',
              incrementSecond: 'Incrementar segundo',
              decrementSecond: 'Disminuir segundo',
              togglePeriod: 'Alternar período',
              selectTime: 'Seleccionar hora',
              selectDate: 'Seleccionar fecha',
            };
          default:
            return {
              today: 'Today',
              clear: 'Clear',
              close: 'Close',
              selectMonth: 'Select month',
              prevMonth: 'Prev. month',
              nextMonth: 'Next month',
              selectYear: 'Select year',
              prevYear: 'Prev. year',
              nextYear: 'Next year',
              selectDecade: 'Select decade',
              prevDecade: 'Prev. decade',
              nextDecade: 'Next decade',
              prevCentury: 'Prev. century',
              nextCentury: 'Next century',
              pickHour: 'Select hour',
              incrementHour: 'Increment hour',
              decrementHour: 'Decrement hour',
              pickMinute: 'Pick minute',
              incrementMinute: 'Increment minute',
              decrementMinute: 'Decrement minute',
              pickSecond: 'Pick second',
              incrementSecond: 'Increment second',
              decrementSecond: 'Decrement second',
              togglePeriod: 'Toggle period',
              selectTime: 'Select time',
              selectDate: 'Select date',
            };
        }
      },
      formatDatedmy: 'd/m/y',
      formatDatedmyTwo: 'd-m-y',
      formatDatemdy: 'm/d/y',
      formatDatemdyTwo: 'm-d-y',
      formatDateymd: 'y/m/d',
      formatDateymdTwo: 'y-m-d',
      formatDateDMY: 'D/M/Y',
      formatDateDDMMYY: 'DD/MM/YY',
      formatDateDDMMYYYY: 'DD/MM/YYYY',
      formatDateDDMMYYYYTwo: 'DD-MM-YYYY',
      formatDateMMDDYYYY: 'MM/DD/YYYY',
      formatDateMMDDYYYYTwo: 'MM-DD-YYYY',
      formatDateYYYYMMDD: 'YYYY/MM/DD',
      formatDateYYYYMMDDTwo: 'YYYY-MM-DD',
      formatTimehhmmA: 'hh:mm A',
      formatTimeHHmm: 'HH:mm',
    },
    sweetAlert2: {
      icons: {
        error: 'error',
        success: 'success',
        warning: 'warning',
        info: 'info',
        question: 'question',
      },
      images: {
        information: '/images/sweetalert2/informationIcon.png',
        success: '/images/sweetalert2/successIcon.png',
      },
      position: {
        bottom: 'bottom',
        bottomStart: 'bottom-start',
        bottomEnd: 'bottom-end',
        center: 'center',
        centerStart: 'center-start',
        centerEnd: 'center-end',
        top: 'top',
        topStart: 'top-start',
        topEnd: 'top-end',
      },
    },
  },
  roles: {
    admin: 'admin',
    anonymous: 'anonymous',
    master: 'master',
    user: 'user',
  },
  tabs: {
    four: '&nbsp;&nbsp;&nbsp;&nbsp;',
  },
  summerNote: {
    events: {
      code: 'code',
      destroy: 'destroy',
      isEmpty: 'isEmpty',
      reset: 'reset',
    },
    btnEvents: {
      code: 'btnSNCode',
      destroy: 'btnSNDestroy',
      init: 'btnSNInit',
      isEmpty: 'btnSNIsEmpty',
      reset: 'btnSNReset',
      setCode: 'btnSNSetCode',
    },
  },
  sweetAlert2: {
    dismiss: {
      backdrop: 'backdrop',
      cancel: 'cancel',
    },
  },
  timers: {
    threeNanoSeconds: 300,
    fourNanoSeconds: 400,
    fiveNanoSeconds: 500,
    oneSeconds: 1000,
    twoSeconds: 2000,
    threeSeconds: 3000,
    fourSeconds: 4000,
    twentySeconds: 20000,
    thirtySeconds: 30000,
    fourthySeconds: 40000,
    fiftySeconds: 50000,
    sixtySeconds: 60000,

  },
  undefined: 'Undefined',
});

export const getSettings = (email) => {
  return {
    messages: {
      thisEmailAlreadyOurSystemConfirmAccount: `This <b>${email}</b> email is already registered in our system, you must confirm your account from your email to verify your identity and be able to access our system.`,
    },
  };
}

export const itemsLocal = {
  description: {
    text: '',
    plain_text: '',
    last_updated: '2000-01-01T00:00:00.000Z',
    date_created: '2000-01-01T00:00:00.000Z',
    snapshot: {
      url: '',
      width: 0,
      height: 0,
      status: '',
    },
  },
};

//#region old code
// export const sendMessage = (msgType, msgText, timer, confirmButton, timerProgressBar) => {
//   if (msgType === -2) {
//     Swal.close();
//   } else {
//     let msgTitle = null;
//     switch (msgType) {
//       case -1:
//         msgType = 'error';
//         msgTitle = settings?.labels?.error.en;
//         break;
//       case 0:
//         msgType = 'success';
//         msgTitle = settings?.labels?.success.en;
//         break;
//       case 1:
//         msgType = 'warning';
//         msgTitle = settings?.labels?.warning.en;
//         break;
//       case 2:
//         msgType = 'info';
//         msgTitle = settings?.labels?.information.en;
//         break;
//       default:
//         msgType = 'question';
//         msgTitle = settings?.labels?.question.en;
//         break;
//     }

//     if (timerProgressBar) {
//       let timerInterval;
//       const swalProperties = {
//         icon: msgType,
//         title: msgTitle,
//         html: msgText,
//         timer: timer !== null ? timer : null,
//         confirmButtonColor: settings?.colors?.successColorExp,
//         showConfirmButton: confirmButton,
//         timerProgressBar: timerProgressBar,
//         //onBeforeOpen: () => {
//         didOpen: () => {
//           Swal.showLoading()
//           timerInterval = setInterval(() => {
//             //const content = Swal.getContent()

//             //if (content) {
//             //    const b = content.querySelector('strong')
//             //    if (b) {
//             //        //b.textContent = Swal.getTimerLeft()
//             //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
//             //        b.textContent = percent
//             //    }
//             //}
//           }, 100)
//         },
//         //onClose: () => {
//         willClose: () => {
//           clearInterval(timerInterval)
//         }
//       };

//       Swal.fire(swalProperties).then((result) => {
//         /* Read more about handling dismissals below */
//         if (result.dismiss === Swal.DismissReason.timer) {
//           console.info('I was closed by the timer')
//         }
//       });

//     } else {
//       const swalProperties = {
//         icon: msgType,
//         title: msgTitle,
//         html: msgText,
//         timer: timer !== null ? timer : null,
//         confirmButtonColor: settings?.colors?.successColorExp,
//         showConfirmButton: confirmButton,
//         timerProgressBar: timerProgressBar,
//       };

//       Swal.fire(swalProperties);
//     }
//   }
// };
//#endregion old code

export const sendMessageNew = ({
  msgType = 0,
  msgText = '',
  timer = 0,
  confirmButton = false,
  timerProgressBar = false,
  languageId = 'en',
}) => {
  const currentMethod = 'sendMessageNew';
  let response = new ResponseClass()?.getClass();
  try {
    const { colors, labels, } = settings;
    if (msgType === -2) {
      Swal.close();
    } else {
      let msgTitle = null;
      let timerInterval;
      let swalProperties;

      switch (msgType) {
        case -1:
          msgType = 'error';
          msgTitle = labels?.error?.[languageId]
          break;
        case 0:
          msgType = 'success';
          msgTitle = labels?.success?.[languageId]
          break;
        case 1:
          msgType = 'warning';
          msgTitle = labels?.warning?.[languageId]
          break;
        case 2:
          msgType = 'info';
          msgTitle = labels?.information?.[languageId]
          break;
        default:
          msgType = 'question';
          msgTitle = labels?.question?.[languageId]
          break;
      }

      if (timerProgressBar) {
        if (timer > 0) {
          swalProperties = {
            icon: msgType,
            title: msgTitle,
            html: msgText,
            timer: timer !== null ? timer : null,
            confirmButtonColor: colors?.successColorExp,
            showConfirmButton: confirmButton,
            timerProgressBar: timerProgressBar,
            allowOutsideClick: false, // Deshabilita el cierre al hacer clic fuera
            allowEscapeKey: false,     // Deshabilita el cierre con la tecla Escape
            //onBeforeOpen: () => {
            didOpen: () => {
              Swal.showLoading()
              timerInterval = setInterval(() => {
                //const content = Swal.getContent()

                //if (content) {
                //    const b = content.querySelector('strong')
                //    if (b) {
                //        //b.textContent = Swal.getTimerLeft()
                //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
                //        b.textContent = percent
                //    }
                //}
              }, 100)
            },
            //onClose: () => {
            willClose: () => {
              clearInterval(timerInterval)
            }
          };

          Swal.fire(swalProperties).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              console.info('I was closed by the timer')
            }
          });
        } else {
          swalProperties = {
            icon: msgType,
            title: msgTitle,
            html: msgText,
            timer: timer !== null ? timer : null,
            confirmButtonColor: colors?.successColorExp,
            showConfirmButton: confirmButton,
            timerProgressBar: timerProgressBar,
            allowOutsideClick: false, // Deshabilita el cierre al hacer clic fuera
            allowEscapeKey: false,     // Deshabilita el cierre con la tecla Escape
            didOpen: () => {
              Swal.showLoading()
            },
            willClose: () => {
              clearInterval(timerInterval)
            }
          };

          Swal.fire(swalProperties).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              console.info('I was closed by the timer')
            }
          });
        }
      } else {
        swalProperties = {
          icon: msgType,
          title: msgTitle,
          html: msgText,
          timer: timer !== null ? timer : null,
          confirmButtonColor: colors?.successColorExp,
          showConfirmButton: confirmButton,
          timerProgressBar: timerProgressBar,
        };

        Swal.fire(swalProperties);
      }
    }
  }
  catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}</br>`;
    response.msgText += `Error: ${ex.message}`;
    console?.error(response);
  }
};

//#region old code
// export const sendMessageCloseCurrentWindowAsync = async (msgType = 0, msgText = '', closeWindow = false, urlGoTo = '', auth = null, isLogout = false) => {
//   let response = getResponse({ type: 0 });
//   try {
//     //#region Logout

//     if (!isEmpty(urlGoTo)) {
//       if (urlGoTo === settings.app.backend.urlLogin && !isNull(auth)) {
//         auth.logout();
//       } else if (!isNull(auth) && isLogout) {
//         auth.logout();
//       }
//     }

//     //#endregion Logout

//     //#region SHow message

//     const localSwal = Swal;
//     if (!isNull(msgText) && !isEmpty(msgText)) {
//       msgText = msgText.replace('\n', '<br/>');
//     }

//     if (msgType === -2) {
//       localSwal.close();
//     } else {
//       let localMsgTitle;
//       let swalProperties;

//       switch (msgType) {
//         case -1:
//           msgType = 'error';
//           localMsgTitle = settings?.labels?.error.en;
//           break;
//         case 0:
//           msgType = 'success';
//           localMsgTitle = settings?.labels?.success.en;
//           break;
//         case 1:
//           msgType = 'warning';
//           localMsgTitle = settings?.labels?.warning.en;
//           break;
//         case 2:
//           msgType = 'info';
//           localMsgTitle = settings?.labels?.information.en;
//           break;
//         default:
//           msgType = 'question';
//           localMsgTitle = settings?.labels?.question.en;
//           break;
//       }

//       swalProperties = {
//         icon: msgType,
//         title: localMsgTitle,
//         html: msgText,
//         timer: 0,
//         confirmButtonColor: settings?.colors?.successColorExp,
//         showConfirmButton: true,
//         timerProgressBar: 0,
//         didOpen: () => {
//           localSwal.hideLoading();
//         },
//       };

//       //#endregion SHow message

//       //#region Close window / redirect page

//       const { dismiss, isConfirmed, } = await localSwal.fire(swalProperties);
//       if (dismiss === settings.sweetAlert2.dismiss.backdrop || isConfirmed) {
//         //window.close();
//         if (closeWindow) {
//           window.close();
//         } else if (!isEmpty(urlGoTo)) {
//           if (urlGoTo === settings.app.backend.urlLogin && !isNull(auth)) {
//             //auth.logout();
//           } else if (!isNull(auth) && isLogout) {
//             //auth.logout();
//           }
//           window.location.href = urlGoTo;
//         }
//       } else {
//         response.isWarning = true;
//         response.msgType = 1;
//         response.result = { dismiss, isConfirmed };
//       }

//       //#endregion Close window / redirect page
//     }
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.msgText = `Method: sendMessageCloseCurrentWindowAsync</br>`;
//     response.msgText += `Error: ${ex.message}`;
//     console?.error(response);
//   }
//   return response;
// };
//#endregion old code

export const sendMessageCloseCurrentWindowAsyncNew = async ({
  msgType = 0,
  msgText = '',
  closeWindow = false,
  urlGoTo = '',
  auth = AuthContextType,
  isLogout = false,
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'sendMessageCloseCurrentWindowAsyncNew';
  let response = new ResponseClass()?.getClass();
  try {
    //#region variables
    const swalLocal = Swal;
    let msgTitleLocal;
    let swalProperties;
    const { app, colors, labels } = settings;
    const { backend: appBackend, } = app;
    //#endregion variables

    //#region logout
    if (!isUndNullEmpNew({ data: urlGoTo, subMethod: currentMethod, })?.result) {
      if (urlGoTo === appBackend?.urls?.login && !isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result) {
        auth.logout({ savePath: true, subMethod: currentMethod });
      } else if (!isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
        auth.logout({ savePath: true, subMethod: currentMethod });
      }
    }
    //#endregion logout

    //#region show message
    if (!isUndNullEmpNew({ data: msgText, subMethod: currentMethod })?.result && !isUndNullEmpNew({ data: msgText, subMethod: currentMethod, })?.result) {
      msgText = msgText.replace('\n', '<br/>');
    }

    if (msgType === -2) {
      swalLocal.close();
    } else {
      switch (msgType) {
        case -1:
          msgType = 'error';
          msgTitleLocal = labels?.error?.[languageId];
          break;
        case 0:
          msgType = 'success';
          msgTitleLocal = labels?.success?.[languageId];
          break;
        case 1:
          msgType = 'warning';
          msgTitleLocal = labels?.warning?.[languageId];
          break;
        case 2:
          msgType = 'info';
          msgTitleLocal = labels?.information?.[languageId];
          break;
        default:
          msgType = 'question';
          msgTitleLocal = labels?.question?.[languageId];
          break;
      }

      swalProperties = {
        icon: msgType,
        title: msgTitleLocal,
        html: msgText,
        timer: 0,
        confirmButtonColor: colors?.successColorExp,
        showConfirmButton: true,
        timerProgressBar: 0,
        didOpen: () => {
          swalLocal.hideLoading();
        },
      };
      //#endregion show message

      //#region close window / redirect page
      const { dismiss, isConfirmed, } = await swalLocal.fire(swalProperties);
      if (dismiss === settings.sweetAlert2.dismiss.backdrop || isConfirmed) {
        //window.close();
        if (closeWindow) {
          window.close();
        } else if (!isUndNullEmpNew({ data: urlGoTo, subMethod: currentMethod, })?.result) {
          if (urlGoTo === appBackend?.urls?.login && !isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result) {
            // auth.logout({
            //   subMethod: currentMethod,
            // });
          } else if (!isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
            // auth.logout({
            //   subMethod: currentMethod,
            // });
          }
          window.location.href = urlGoTo;
        }
      } else {
        response = getResponse({ type: 1 });
        response.result = { dismiss, isConfirmed };
      }

      //#endregion Close window / redirect page
    }
  } catch (ex) {
    // response.msgType = -1;
    // response.isSuccess = false;
    // response.msgText = `Method: ${currentMethod}</br>`;
    // response.msgText += `Error: ${ex.message}`;
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    console?.error(response);
  }
  return response;
};

export const sendMessageCloseCurrentWindow = async ({
  response = getResponse({ type: 0, }),
  closeWindow = false,
  auth = AuthContextType,
  isLogout = false,
  savePath = true,
  customClass = {
    popup: settings?.html?.popup,
    confirmButton: settings?.html?.buttons?.primary,
    cancelButton: settings?.html?.buttons?.secondary,
  },
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'sendMessageCloseCurrentWindow';
  let responseMethod = getResponse({ type: 0 });
  try {
    //#region variables
    const swalLocal = Swal;
    let msgTitleLocal;
    let swalProperties;
    const { app, colors, labels } = settings;
    const { urls } = app?.backend;
    let { msgType, msgText, msgTextHtml, urlGoTo } = response;
    const isSendMessage = !isUndNullEmpNew({ data: msgText, subMethod: currentMethod })?.result ||
      !isUndNullEmpNew({ data: msgTextHtml, subMethod: currentMethod })?.result;
    const isUrlGoTo = !isUndNullEmpNew({ data: urlGoTo, subMethod: currentMethod })?.result;
    //#endregion variables

    if (!isSendMessage && !isUrlGoTo && !closeWindow) return;

    //#region logout
    if (!isUndNullEmpNew({ data: urlGoTo, subMethod: currentMethod, })?.result) {
      if (urlGoTo === urls?.login && !isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result) {
        auth.logout({ savePath: savePath, subMethod: currentMethod });
      } else if (!isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
        auth.logout({ savePath: savePath, subMethod: currentMethod });
      }
    }
    //#endregion logout

    if (!isSendMessage && !closeWindow && isUrlGoTo) window.location.href = urlGoTo;
    if (!isSendMessage && !closeWindow) return;
    if (!isSendMessage && closeWindow) {
      window?.close();
      return;
    }

    //#region show message
    msgText = msgText.replace('\n', '<br/>');

    if (msgType === -2) {
      swalLocal.close();
    } else {
      switch (msgType) {
        case -1:
          msgType = 'error';
          msgTitleLocal = labels?.error?.[languageId];
          break;
        case 0:
          msgType = 'success';
          msgTitleLocal = labels?.success?.[languageId];
          break;
        case 1:
          msgType = 'warning';
          msgTitleLocal = labels?.warning?.[languageId];
          break;
        case 2:
          msgType = 'info';
          msgTitleLocal = labels?.information?.[languageId];
          break;
        default:
          msgType = 'question';
          msgTitleLocal = labels?.question?.[languageId];
          break;
      }

      swalProperties = {
        icon: msgType,
        title: msgTitleLocal,
        html: msgText,
        timer: 0,
        confirmButtonColor: colors?.successColorExp,
        showConfirmButton: true,
        timerProgressBar: 0,
        customClass: customClass,
        didOpen: () => {
          swalLocal.hideLoading();
        },
      };
      //#endregion show message

      //#region close window / redirect page
      const { dismiss, isConfirmed, } = await swalLocal.fire(swalProperties);
      if (dismiss === settings.sweetAlert2.dismiss.backdrop || isConfirmed) {
        //window.close();
        if (closeWindow) {
          window.close();
        } else if (!isUndNullEmpNew({ data: urlGoTo, subMethod: currentMethod, })?.result) {
          if (urlGoTo === urls?.login && !isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result) {
            // auth.logout({
            //   subMethod: currentMethod,
            // });
          } else if (!isUndNullEmpNew({ data: auth, subMethod: currentMethod, })?.result && isLogout) {
            // auth.logout({
            //   subMethod: currentMethod,
            // });
          }
          if (window?.location?.pathname !== urlGoTo && window?.location?.pathname !== urls?.login) window.location.href = urlGoTo;
        }
      } else {
        response = getResponse({ type: 1 });
        response.result = { dismiss, isConfirmed };
      }
      //#endregion close window / redirect page
    }
  } catch (ex) {
    responseMethod = getError({ ex: ex, response: responseMethod, currentMethod_: currentMethod, subMethod_: subMethod });
    console?.error(responseMethod);
  }
  return responseMethod;
};

export const getItemStatsHtml = ({
  data = ''
} = {}) => {
  //#region old code
  // switch(status){
  //     case settings.mercadoLibre.status.active:
  //        return( <span className='badge bg-success'>{status}</span>);
  //     case settings.mercadoLibre.status.closed:
  //         return( <span className='badge bg-secondary'>{status}</span>);
  //     case settings.mercadoLibre.status.paused:
  //         return( <span className='badge bg-warning'>{status}</span>);
  //     case settings.mercadoLibre.status.deleted:
  //         return( <span className='badge bg-danger'>{status}</span>);
  //     default:
  //         return( <span className='badge bg-info'>{status}</span>);
  // }
  //#endregion old code
  switch (data) {
    case settings.mercadoLibre.status.active:
      return `<span class='badge bg-success'>${data}</span>`;
    case settings.mercadoLibre.status.closed:
      return `<span class='badge bg-secondary'>${data}</span>`;
    case settings.mercadoLibre.status.paused:
      return `<span class='badge bg-warning'>${data}</span>`;
    case settings.mercadoLibre.status.deleted:
      return `<span class='badge bg-danger'>${data}</span>`;
    default:
      return `<span class='badge bg-info'>${data}</span>`;
  }
  // <span class='badge bg-primary'>Primary</span>
  // <span class='badge bg-secondary'>Secondary</span>
  // <span class='badge bg-success'>Success</span>
  // <span class='badge bg-danger'>Danger</span>
  // <span class='badge bg-warning text-dark'>Warning</span>
  // <span class='badge bg-info text-dark'>Info</span>
  // <span class='badge bg-light text-dark'>Light</span>
  // <span class='badge bg-dark'>Dark</span>
}

//#region old code
// export const setSeparatorsNumbers = (number) => {
//   let newNumber = '';
//   try {
//     const decimalSeparator = '.';
//     const thousendSeparator = ',';
//     let numberString = !isNaN(number) ? number.toString() : number;
//     let decimals = 2;
//     let flat = 1;

//     if (decimals !== 0) {
//       if (numberString.indexOf('.') < 0) {
//         numberString += `${decimalSeparator}${repeat('0', decimals)}`;
//       }
//     }

//     for (var index = numberString.length + 1; index >= 0; index--) {
//       if (flat === (decimals + 6) || flat === (decimals + 9) || flat === (decimals + 12)) {
//         newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
//       } else {
//         newNumber = numberString.substr(index, 1) + newNumber;
//       }
//       flat++;
//     }

//     // 
//     if (newNumber.substr(0, 1) === ',') {
//       newNumber = newNumber.substr(1);
//     }
//     if (newNumber.indexOf('-,') >= 0) {
//       newNumber = newNumber.replace('-,', '-');
//     }

//   } catch (ex) {
//     sendMessageNew({
//       msgType: response?.msgType,
//       msgText: response?.msgText,
//       timer: 0,
//       confirmButton: true,
//       timerProgressBar: false,
//       languageId: languageObj?.id,
//     });
//   }
//   return newNumber;
// }
//#endregion old code

export function getGlobalFormat() {
  return {
    code: '',
    id: '',
    format: {
      date: {
        f1: '',
        f2: '',
        f3: '',
        f4: '',
        f5: '',
        f6: '',
        f7: '',
        f8: '',
        f9: '',
        f10: '',
        f11: '',
        f12: '',
        f13: '',
      },
      time: {
        f1: '',
        f2: '',
        f3: '',
        f4: '',
        picker: {
          hhmm: '',
          hhmmss: '',
        },
        type: 0,
      },
    },
    numbers: {
      separators: {
        decimals: '',
        thousands: '',
      },
    },
  };
}

export const getLanguageObj = ({
  subMethod = ''
} = {}) => {
  const currentMethod = 'getLanguageObj';
  let response = getResponse({ type: 0 });
  const localFormat = getGlobalFormat();
  try {
    //#region variables
    const languageId = navigator?.language || navigator?.uerLanguage;
    const { languages } = settings;
    //#endregion variables

    //#region process
    if (isUndNullEmp({ data: languageId, subMethod: currentMethod })?.result) {
      response.result = languages?.enUS;
    } else {
      switch (languageId) {
        case languages?.enUS?.code:
          response.result = languages?.enUS;
          break;
        case languages?.es?.code:
          response.result = languages?.es;
          break;
        case languages?.esAR?.code:
          response.result = languages?.esAR;
          break;
        case languages?.esCL?.code:
          response.result = languages?.esCL;
          break;
        case languages?.esCO?.code:
          response.result = languages?.esCO;
          break;
        case languages?.esMX?.code:
          response.result = languages?.esMX;
          break;
        case languages?.esUS?.code:
          response.result = languages?.esUS;
          break;
        case languages?.esVE?.code:
          response.result = languages?.esVE;
          break;
        case languages?.es419?.code:
          response.result = languages?.es419;
          break;
        default:
          response.result = languages?.enUS;
          break;
      }
    }
    //#endregion process
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex?.message}<br/>`, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = localFormat;
    console?.error(response);
  }
  return response;
}

export const setSeparatorsNumbers = (number = 0, withDecimals = true) => {
  let response = getResponse({ type: 0 });
  try {
    let newNumber = '';
    const decimalPlaces = withDecimals ? settings?.numberPositions?.decimalsPlace : 0;
    const decimalSeparator = '.';
    const thousendSeparator = ',';
    let numberString = !isUndefined(number) ? (!isNaN(number) ? number.toString() : number) : '';
    let decimals = decimalPlaces;
    let flat = 1;
    const decimalPosition = numberString.indexOf('.');

    if (decimals !== 0) {
      if (decimalPosition < 0) {
        numberString += `${decimalSeparator}${repeat('0', decimals)}`;
      } else {
        const localDecimals = numberString.substr((decimalPosition + 1), decimalPlaces);
        if (localDecimals.length !== decimalPlaces) {
          numberString += `${repeat('0', (decimalPlaces - localDecimals.length))}`;
        }
      }
    }

    for (var index = numberString.length + 1; index >= 0; index--) {
      if (flat === (withDecimals ? decimals + 6 : 5) || flat === (withDecimals ? decimals + 9 : 8) || flat === (withDecimals ? decimals + 12 : 11)) {
        newNumber = `${thousendSeparator}${numberString.substr(index, 1)}` + newNumber;
      } else {
        newNumber = numberString.substr(index, 1) + newNumber;
      }
      flat++;
    }

    // 
    if (newNumber.substr(0, 1) === ',') {
      newNumber = newNumber.substr(1);
    }
    if (newNumber.indexOf('-,') >= 0) {
      newNumber = newNumber.replace('-,', '-');
    }
    response.result = newNumber;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '0.00';
    response.msgText = `Method: setSeparatorsNumbers<br/>`;
    response.msgText += `Error: ${ex.message}`;
  }
  return response;
}

export const setSeparatorsNumbersNew = ({
  number = 0,
  withDecimals = true,
  subMethod = ''
} = {}) => {
  const currentMethod = 'setSeparatorsNumbersNew';
  let response = getResponse({ type: 0 });
  try {
    const { numberPositions } = settings
    let newNumber = '';
    const decimalPlaces = withDecimals ? numberPositions?.decimalsPlace : 0;
    const decimalSeparator = '.';
    const thousendSeparator = ',';
    let numberString = !isUndefined(number) ? (!isNaN(number) ? number?.toString() : number) : '';
    let decimals = decimalPlaces;
    let flat = 1;
    const decimalPosition = numberString?.indexOf('.');

    if (decimals !== 0) {
      if (decimalPosition < 0) {
        numberString += `${decimalSeparator}${repeat('0', decimals)}`;
      } else {
        const localDecimals = numberString?.substr((decimalPosition + 1), decimalPlaces);
        if (localDecimals?.length !== decimalPlaces) {
          numberString += `${repeat('0', (decimalPlaces - localDecimals?.length))}`;
        }
      }
    }

    for (var index = numberString?.length + 1; index >= 0; index--) {
      if (flat === (withDecimals ? decimals + 6 : 5) || flat === (withDecimals ? decimals + 9 : 8) || flat === (withDecimals ? decimals + 12 : 11)) {
        newNumber = `${thousendSeparator}${numberString?.substr(index, 1)}` + newNumber;
      } else {
        newNumber = numberString?.substr(index, 1) + newNumber;
      }
      flat++;
    }

    // 
    if (newNumber?.substr(0, 1) === ',') {
      newNumber = newNumber?.substr(1);
    }
    if (newNumber?.indexOf('-,') >= 0) {
      newNumber = newNumber?.replace('-,', '-');
    }
    response.result = newNumber;
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex?.message}<br/>`, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = '0.00';
    console?.error(response);
  }
  return response;
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\\[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email)
}

export const validatePhoneNumber = (phoneNumber) => {
  // //const re = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  // const re = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const re = /^\+\d{1,3}\s?\d{10}$/;
  return re.test(phoneNumber);
}

export const validateTextIsHTML = ({
  text = '',
  subMethod = ''
}) => {
  const currentMethod = 'validateTextIsHTML';
  let response = getResponse({ type: 0 });
  try {
    let regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
    response.result = regexForHTML.test(text);
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmpNew({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
    response.result += {
      text: text,
      subMethod: subMethod,
    };
  }
  return response;
}

export const validateTelegramId = ({
  id = '',
  subMethod = '',
}) => {
  const currentMethod = 'validateTelegramId';
  let response = getResponse({ type: 0 });
  try {
    response.result = true;
    if (isNaN(id)) {
      response.result = false;
      return response;
    } else if (id.length < 9 || id.length > 10) {
      response.result = false;
      return response;
      //} else if ((id.match(new RegExp('-', 'g')) || []).length > 1) {
    } else if ((typeof id) === 'string') {
      if ((id.match(new RegExp('-', 'g')) || []).length > 1) {
        response.result = false;
        return response;
      } else if ((id.match(new RegExp('-', 'g')) || []).length === 1) {
        if (id.length < 10 || id.length > 12) {
          response.result = false;
          return response;
        }
      }
    } else if ((typeof id) === 'number') {
      if ((id.toString().match(new RegExp('-', 'g')) || []).length > 1) {
        response.result = false;
        return response;
      } else if ((id.toString().match(new RegExp('-', 'g')) || []).length === 1) {
        if (id.length < 10 || id.length > 12) {
          response.result = false;
          return response;
        }
      }
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (!isUndNullEmpNew({ data: subMethod, subMethod: currentMethod, })?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
    response.result += {
      id: id,
      subMethod: subMethod,
    };
  }
  return response;
}

export const validURL = ({
  url = '',
  subMethod = ''
} = {}) => {
  const currentMethod = 'validURL';
  let response = getResponse({ type: 0 });
  try {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    response.result = !!pattern.test(url);
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = false;
  }
  return response;
}

export const getTooltipOptions = {
  showDelay: 500,
  style: {
    opacity: 1,
    borderRadius: '10%',
    border: 1,
    color: '#ffff',
    margin: 5,
    float: 'right',
    textAlign: 'left',
    backgroundColor: '#737373',
  },
};

//#region old code
// export const dateTimeFormatSet = (seconds, type, format) => {

//   const dateTime = seconds > 0 ? new Date(seconds * 1000) : new Date();
//   let formatDateTime = ''

//   switch (type) {
//     case 'd-m-y':
//       formatDateTime = 'DD-MM-YYYY';
//       break;
//     case 'm-d-y':
//       formatDateTime = 'MM-DD-YYYY';
//       break;
//     case 'd/m/y':
//       formatDateTime = 'DD/MM/YYYY';
//       break;
//     default:
//       formatDateTime = 'MM/DD/YYYY';
//       break;
//   }

//   switch (format) {
//     case 24:
//       formatDateTime += ' - HH:mm:ss';
//       break;
//     case 12:
//       formatDateTime += ' - hh:mm:ss a';
//       break;
//     default:
//       formatDateTime += '';
//       break;
//   }

//   let dateTimeFormat = Moment(dateTime).format(formatDateTime);
//   return dateTimeFormat;
// }
//#endregion old code

//#region old code
// export const dateTimeFormatTwoSet = (date, type, format) => {

//   const dateTime = new Date(date);
//   let formatDateTime = ''

//   switch (type) {
//     case 'd-m-y':
//       formatDateTime = 'DD-MM-YYYY';
//       break;
//     case 'm-d-y':
//       formatDateTime = 'MM-DD-YYYY';
//       break;
//     case 'd/m/y':
//       formatDateTime = 'DD/MM/YYYY';
//       break;
//     case '':
//       formatDateTime = '';
//       break;
//     default:
//       formatDateTime = 'MM/DD/YYYY';
//       break;
//   }

//   switch (type) {
//     case '':
//       switch (format) {
//         case 0:
//           formatDateTime += '';
//           break;
//         case 24:
//           formatDateTime += 'HH:mm:ss';
//           break;
//         default:
//           formatDateTime += 'hh:mm:ss a';
//           break;
//       };
//       break;
//     default:
//       switch (format) {
//         case 0:
//           formatDateTime += '';
//           break;
//         case 24:
//           formatDateTime += ' - HH:mm:ss';
//           break;
//         default:
//           formatDateTime += ' - hh:mm:ss a';
//           break;
//       };
//       break;
//   }

//   let dateTimeFormat = Moment(dateTime).format(formatDateTime);
//   return dateTimeFormat;
// }
//#endregion old code

export const dateTimeFormatSet = (seconds = 0, type = '', format = '', withSeconds = true) => {
  const dateTime = seconds > 0 ? new Date(seconds * 1000) : new Date();
  let formatDateTime = ''

  switch (type) {
    //case 'd-m-y':
    case settings.react.tempusDominus.formatDatedmyTwo:
      //formatDateTime = 'DD-MM-YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateDDMMYYYYTwo;
      break;
    //case 'm-d-y':
    case settings.react.tempusDominus.formatDatemdyTwo:
      //formatDateTime = 'MM-DD-YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYYTwo;
      break;
    //case 'y-m-d':
    case settings.react.tempusDominus.formatDateymdTwo:
      //formatDateTime = 'YYYY-MM-DD';
      formatDateTime = settings.react.tempusDominus.formatDateYYYYMMDDTwo;
      break;
    //case 'd/m/y':
    case settings.react.tempusDominus.formatDatedmy:
      //formatDateTime = 'DD/MM/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateDDMMYYYY;
      break;
    //case 'm/d/y':
    case settings.react.tempusDominus.formatDatemdy:
      //formatDateTime = 'MM/DD/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYY;
      break;
    //case 'y/m/d':
    case settings.react.tempusDominus.formatDateymd:
      //formatDateTime = 'YYYY/MM/DD';
      formatDateTime = settings.react.tempusDominus.formatDateYYYYMMDD;
      break;
    case '':
      formatDateTime = '';
      break;
    default:
      //formatDateTime = 'MM/DD/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYY;
      break;
  }

  switch (type) {
    case '':
      switch (format) {
        case 0:
          formatDateTime += '';
          break;
        case 24:
          if (withSeconds) {
            formatDateTime += 'HH:mm:ss';
          } else {
            formatDateTime += 'HH:mm';
          }
          break;
        default:
          if (withSeconds) {
            formatDateTime += 'hh:mm:ss a';
          } else {
            formatDateTime += 'hh:mm a';
          }
          break;
      };
      break;
    default:
      switch (format) {
        case 0:
          formatDateTime += '';
          break;
        case 24:
          if (withSeconds) {
            formatDateTime += ' - HH:mm:ss';
          } else {
            formatDateTime += ' - HH:mm';
          }
          break;
        default:
          if (withSeconds) {
            formatDateTime += ' - hh:mm:ss a';
          } else {
            formatDateTime += ' - hh:mm a';
          }
          break;
      };
      break;
  }

  let dateTimeFormat = moment(dateTime).format(formatDateTime);
  return dateTimeFormat;
}

export const dateTimeFormatTwoSet = (date = '', type = '', format = 0, addTime = false, withSeconds = true) => {

  //const dateTime = new Date(!isUndefined(addTime) && addTime ? (date + 'T12:00:00') : date);
  const dateTime = new Date((!isUndefined(addTime) && addTime && date.indexOf('T') < 0) ? (date + 'T12:00:00') : date);

  let formatDateTime = ''

  switch (type) {
    //case 'd-m-y':
    case settings.react.tempusDominus.formatDatedmyTwo:
      //formatDateTime = 'DD-MM-YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateDDMMYYYYTwo;
      break;
    //case 'm-d-y':
    case settings.react.tempusDominus.formatDatemdyTwo:
      //formatDateTime = 'MM-DD-YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYYTwo;
      break;
    //case 'y-m-d':
    case settings.react.tempusDominus.formatDateymdTwo:
      //formatDateTime = 'YYYY-MM-DD';
      formatDateTime = settings.react.tempusDominus.formatDateYYYYMMDDTwo;
      break;
    //case 'd/m/y':
    case settings.react.tempusDominus.formatDatedmy:
      //formatDateTime = 'DD/MM/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateDDMMYYYY;
      break;
    //case 'm/d/y':
    case settings.react.tempusDominus.formatDatemdy:
      //formatDateTime = 'MM/DD/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYY;
      break;
    //case 'y/m/d':
    case settings.react.tempusDominus.formatDateymd:
      //formatDateTime = 'YYYY/MM/DD';
      formatDateTime = settings.react.tempusDominus.formatDateYYYYMMDD;
      break;
    case '':
      formatDateTime = '';
      break;
    default:
      //formatDateTime = 'MM/DD/YYYY';
      formatDateTime = settings.react.tempusDominus.formatDateMMDDYYYY;
      break;
  }

  switch (type) {
    case '':
      switch (format) {
        case 0:
          formatDateTime += '';
          break;
        case 24:
          if (withSeconds) {
            formatDateTime += 'HH:mm:ss';
          } else {
            formatDateTime += 'HH:mm';
          }
          break;
        default:
          if (withSeconds) {
            formatDateTime += 'hh:mm:ss a';
          } else {
            formatDateTime += 'hh:mm a';
          }
          break;
      };
      break;
    default:
      switch (format) {
        case 0:
          formatDateTime += '';
          break;
        case 24:
          if (withSeconds) {
            formatDateTime += ' - HH:mm:ss';
          } else {
            formatDateTime += ' - HH:mm';
          }
          break;
        default:
          if (withSeconds) {
            formatDateTime += ' - hh:mm:ss a';
          } else {
            formatDateTime += ' - hh:mm a';
          }
          break;
      };
      break;
  }

  let dateTimeFormat = moment(dateTime).format(formatDateTime);
  return dateTimeFormat;
}

export const dateTimeFormatGlobalSet = (
  date = {},
  type = settings.react.tempusDominus.formatDatemdy,
  format = 0,
  addTime = false,
  withSeconds = true,
  subMethod = ''
) => {
  const currentMethod = 'dateTimeFormatGlobalSet';
  let response = getResponse({ type: 0 });
  try {
    if (!isUndefined(date.seconds) && !isNull(date.seconds)) {
      response.result = dateTimeFormatSet(date.seconds, type, format, withSeconds);
    } else if (!isUndefined(date._seconds) && !isNull(date._seconds)) {
      response.result = dateTimeFormatSet(date._seconds, type, format, withSeconds);
    } else {
      response.result = dateTimeFormatTwoSet(date, type, format, addTime, withSeconds);
    }
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = format;
  }
  return response;
}

export const setDateTimeFormat = ({
  seconds = 0,
  type = '',
  format = '',
  withSeconds = true,
  subMethod = '',
} = {}) => {
  const currentMethod = 'setDateTimeFormat';
  let response = getResponse({ type: 0 });
  try {
    const { tempusDominus } = settings?.react;
    const dateTime = seconds > 0 ? new Date(seconds * 1000) : new Date();
    let formatDateTime = ''

    switch (type) {
      //case 'd-m-y':
      case tempusDominus?.formatDatedmyTwo:
        //formatDateTime = 'DD-MM-YYYY';
        formatDateTime = tempusDominus?.formatDateDDMMYYYYTwo;
        break;
      //case 'm-d-y':
      case tempusDominus?.formatDatemdyTwo:
        //formatDateTime = 'MM-DD-YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYYTwo;
        break;
      //case 'y-m-d':
      case tempusDominus?.formatDateymdTwo:
        //formatDateTime = 'YYYY-MM-DD';
        formatDateTime = tempusDominus?.formatDateYYYYMMDDTwo;
        break;
      //case 'd/m/y':
      case tempusDominus?.formatDatedmy:
        //formatDateTime = 'DD/MM/YYYY';
        formatDateTime = tempusDominus?.formatDateDDMMYYYY;
        break;
      //case 'm/d/y':
      case tempusDominus?.formatDatemdy:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYY;
        break;
      //case 'y/m/d':
      case tempusDominus?.formatDateymd:
        //formatDateTime = 'YYYY/MM/DD';
        formatDateTime = tempusDominus?.formatDateYYYYMMDD;
        break;
      case '':
        formatDateTime = '';
        break;
      default:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYY;
        break;
    }

    switch (type) {
      case '':
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            if (withSeconds) {
              formatDateTime += 'HH:mm:ss';
            } else {
              formatDateTime += 'HH:mm';
            }
            break;
          default:
            if (withSeconds) {
              formatDateTime += 'hh:mm:ss a';
            } else {
              formatDateTime += 'hh:mm a';
            }
            break;
        };
        break;
      default:
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            if (withSeconds) {
              formatDateTime += ' - HH:mm:ss';
            } else {
              formatDateTime += ' - HH:mm';
            }
            break;
          default:
            if (withSeconds) {
              formatDateTime += ' - hh:mm:ss a';
            } else {
              formatDateTime += ' - hh:mm a';
            }
            break;
        };
        break;
    }

    response.result = moment(dateTime).format(formatDateTime);
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = 'error: 00/00/000 00:00 am/pm';
  }
  return response;
}

export const setDateTimeFormatTwo = ({
  date = '',
  type = '',
  format = 0,
  addTime = false,
  withSeconds = true,
  subMethod = ''
}) => {
  const currentMethod = 'setDateTimeFormatTwo';
  let response = getResponse({ type: 0 });
  try {
    const { tempusDominus } = settings?.react;
    // const dateTime = new Date(!isUndefined(addTime) && addTime ? (date + 'T12:00:00') : date);
    const dateTime = new Date((!isUndefined(addTime) && addTime && date.indexOf('T') < 0) ? (date + 'T12:00:00') : date);
    let formatDateTime = ''

    switch (type) {
      //case 'd-m-y':
      case tempusDominus?.formatDatedmyTwo:
        //formatDateTime = 'DD-MM-YYYY';
        formatDateTime = tempusDominus?.formatDateDDMMYYYYTwo;
        break;
      //case 'm-d-y':
      case tempusDominus?.formatDatemdyTwo:
        //formatDateTime = 'MM-DD-YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYYTwo;
        break;
      //case 'y-m-d':
      case tempusDominus?.formatDateymdTwo:
        //formatDateTime = 'YYYY-MM-DD';
        formatDateTime = tempusDominus?.formatDateYYYYMMDDTwo;
        break;
      //case 'd/m/y':
      case tempusDominus?.formatDatedmy:
        //formatDateTime = 'DD/MM/YYYY';
        formatDateTime = tempusDominus?.formatDateDDMMYYYY;
        break;
      //case 'm/d/y':
      case tempusDominus?.formatDatemdy:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYY;
        break;
      //case 'y/m/d':
      case tempusDominus?.formatDateymd:
        //formatDateTime = 'YYYY/MM/DD';
        formatDateTime = tempusDominus?.formatDateYYYYMMDD;
        break;
      case '':
        formatDateTime = '';
        break;
      default:
        //formatDateTime = 'MM/DD/YYYY';
        formatDateTime = tempusDominus?.formatDateMMDDYYYY;
        break;
    }

    switch (type) {
      case '':
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            if (withSeconds) {
              formatDateTime += 'HH:mm:ss';
            } else {
              formatDateTime += 'HH:mm';
            }
            break;
          default:
            if (withSeconds) {
              formatDateTime += 'hh:mm:ss a';
            } else {
              formatDateTime += 'hh:mm a';
            }
            break;
        };
        break;
      default:
        switch (format) {
          case 0:
            formatDateTime += '';
            break;
          case 24:
            if (withSeconds) {
              formatDateTime += ' - HH:mm:ss';
            } else {
              formatDateTime += ' - HH:mm';
            }
            break;
          default:
            if (withSeconds) {
              formatDateTime += ' - hh:mm:ss a';
            } else {
              formatDateTime += ' - hh:mm a';
            }
            break;
        };
        break;
    }

    response.result = moment(dateTime).format(formatDateTime);
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
  }
  return response;
}

export const setDateTimeFormatGlobal = ({
  date = {},
  type = settings.react.tempusDominus.formatDatemdy,
  format = 0,
  addTime = false,
  withSeconds = true,
  subMethod = ''
}) => {
  const currentMethod = 'setDateTimeFormatGlobal';
  let response = getResponse({ type: 0 });
  try {
    if (!isUndNullEmpNew({ data: date?.seconds, subMethod: currentMethod })?.result) {
      response.result = setDateTimeFormat({ seconds: date?.seconds, type: type, format: format, withSeconds: withSeconds, subMethod: currentMethod })?.result;
    } else if (!isUndNullEmpNew({ data: date?._seconds, subMethod: currentMethod })?.result) {
      response.result = setDateTimeFormat({ seconds: date?._seconds, type: type, format: format, withSeconds: withSeconds, subMethod: currentMethod })?.result;
    } else {
      response.result = setDateTimeFormatTwo({ date: date, type: type, format: format, addTime: addTime, withSeconds: withSeconds, subMethod: currentMethod })?.result;
    }
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = format;
  }
  return response;
}

//#region old code
// export let conditionals = [];
// export const conditional = { field: '', operator: '', value: '' };
// export let ordersBy = [];
// export const orderBy = { field: '', value: '', };

// export const setDefaultConditionals = () => {
//   conditionals = [];
//   conditional.field = '';
//   conditional.operator = '';
//   conditional.value = '';

//   ordersBy = [];
//   orderBy.field = '';
//   orderBy.value = '';
// };
//#endregion old code

//#region user (login)
//#region old code
// export const checkIfUserIsAdmin = (email = '', subMethod = '') => {
//   let response = getResponse({ type: 0 });
//   try {
//     const { messages, } = settings;
//     response.msgType = 1;
//     //response.msgText = 'This user is not admin.<br/>';
//     response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess.en}<br/>`;
//     response.msgText += `${settings?.labels?.email.en}: <b>${isEmpty(email) ? 'Anonymous' : email}</b>`;

//     if (email !== undefined && email !== null && email !== '') {
//       if (email !== settings.users.sysAdmin.email) {
//         //response.result = 'user';
//         response.isWarning = true;
//         response.result = settings.roles.user;
//       } else {
//         //response.result = 'admin';
//         response.msgType = 0;
//         response.msgText = '';
//         response.result = settings.roles.admin;
//       }
//     } else {
//       //response.result = 'anonymous';
//       response.isWarning = true;
//       response.result = settings.roles.anonymous;
//     }
//   } catch (ex) {
//     response.msgType = -1;
//     response.isSuccess = false;
//     response.msgText = `Method: checkIfUserIsAdmin<br/>`;
//     if (subMethod !== '') {
//       response.msgText += `Sub method: ${subMethod}<br/>`;
//     }
//     response.msgText += `Error: ${ex.message}`;
//     response.result = 'anonymous';
//   }
//   return response;
// }
//#endregion old code

//#region old code
// export const checkRole = ({
//   user = {
//     email: '',
//     role: {
//       role: '',
//       roleId: '',
//       roleDate: '',
//       roleUserId: '',
//     },
//   },
//   languageId = 'en',
//   subMethod = ''
// }) => {
//   const currentMethod = 'checkRole';
//   let response = ResponseUserRoleClass?.getClass();
//   let roleType = UserRoleProcess?.getClass();
//   try {
//     const { messages, roles, } = settings;

//     response.msgType = 1;
//     response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageId]}<br/>`;

//     if (!isUndNullEmpNew({ data: user?.email, subMethod: currentMethod, })?.result) {
//       if (user?.role?.role === roles?.user && !isUndNullEmpNew({ data: user?.role?.roleId, subMethod: currentMethod, })?.result) {
//         response.isWarning = true;
//         roleType.user = true;
//       } else if (user?.role?.role === roles?.admin && !isUndNullEmpNew({ data: user?.role?.roleId, subMethod: currentMethod, })?.result) {
//         response.msgType = 0;
//         response.msgText = '';
//         roleType.admin = true;
//       } else if (user?.role?.role === roles?.master && !isUndNullEmpNew({ data: user?.role?.roleId, subMethod: currentMethod, })?.result) {
//         response.msgType = 0;
//         response.msgText = '';
//         roleType.master = true;
//       } else if (isUndNullEmpNew({ data: user?.role?.role, subMethod: currentMethod, })?.result ||
//         isUndNullEmpNew({ data: user?.role?.roleId, subMethod: currentMethod, })?.result) {
//         response.isWarning = true;
//         roleType.anonymous = true;
//       }
//     } else {
//       response.isWarning = true;
//       roleType.anonymous = true;
//     }
//   } catch (ex) {
//     // response.msgType = -1;
//     // response.isSuccess = false;
//     // response.msgText = `Method: ${currentMethod}<br/>`;
//     // if (isUndNullEmpNew({ data: subMethod, subMethod: currentMethod })?.result) {
//     //   response.msgText += `Sub method: ${subMethod}<br/>`;
//     // }
//     // response.msgText += `Error: ${ex.message}`;
//     // response.result = 'anonymous';
//     response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
//     roleType.anonymous = true;
//     console?.error(response);
//   }

//   response.result = roleType;
//   return response;
// }
//#endregion old code
//#endregion user (login)

export const getDefaultScript = () => {

  let msgText = ``;
  msgText = `$(document).ready(function () {`;
  msgText += `    `;
  msgText += `    $('.btn').tooltip(); `;
  msgText += `    $('.form-control').tooltip(); `;
  msgText += `    $('.far').tooltip(); `;
  msgText += `});`;
  msgText += `    `;
  return msgText;
}

export const setDocumentScript = (scriptId, scriptText) => {

  const elementScript = document.getElementById(scriptId);
  const script = document.createElement('script');
  script.id = scriptId;
  script.text = scriptText;

  if (!elementScript) {
    document.body.appendChild(script);
  } else {
    document.body.replaceChild(script, elementScript);
  }
}

export const getDtAccountsScript = () => {

  let msgText = '';
  /*msgText = '$(function () {';
  msgText += '    ';
  msgText += '    $("#dtAccounts").DataTable({';
  msgText += `        data: ${JSON.stringify(accounts)}, `;
  msgText += '        columns: [';
  msgText += '            { title: "Image", width: "15%", },';
  msgText += '            { title: "User", width: "30%", },';
  msgText += '            { title: "Name" },';
  msgText += '            { title: "Process", className: "text-center", width: "5%", }';
  msgText += '        ], '
  msgText += '        "responsive": true, "lengthChange": false, "autoWidth": false, ';
  msgText += '        "buttons": ["copy", "csv", "excel", "pdf", "print", "colvis"] ';
  msgText += '    }).buttons().container().appendTo("#dtAccounts_wrapper .col-md-6:eq(0)"); ';
  msgText += '  });';
  msgText += '    ';*/
  /*msgText += '$(document).ready(function (){ ';
  msgText += '    ';
  msgText += '    $(".btn").tooltip(); ';
  msgText += '    $(".form-control").tooltip(); ';
  msgText += '}); '
  msgText += '    ';*/
  /*msgText += '    function editUser(userId){';
  msgText += '    ';
  msgText += '        Swal.fire({';
  msgText += '            icon: "info", ';
  msgText += '            title: "Information", ';
  msgText += '            html: "Processing, please wait...", ';
  msgText += '            timer: 30000, ';
  msgText += '            timerProgressBar: true, ';
  msgText += '            showConfirmButton: false, ';
  msgText += '        });';
  msgText += '        window.location.href="/accountDetails/" + userId;';
  msgText += '    };';*/
  return msgText;
}

export const getDtViewRatesAllScript = (dtId, dtRows) => {

  let msgText = '';
  msgText = '$(document).ready(function () {';
  msgText += '    ';

  msgText += `    if($.fn.dataTable.isDataTable("#${dtId}")){ `;
  msgText += `      const dataTable = $("#${dtId}").DataTable(); `;
  msgText += `      dataTable.destroy(); `;
  msgText += `      $("#${dtId}").DataTable({`;
  msgText += `          data: ${JSON.stringify(dtRows)}, `;
  msgText += '          order: [[1, "desc"]], ';
  msgText += '          columns: [';
  msgText += '              { title: "Rate", width: "50%", orderable: false, },';
  msgText += '              { title: "Registry", width: "50%", orderable: false, },';
  msgText += '          ], '
  msgText += '          responsive: true, ';
  msgText += '          lengthChange: true, ';
  msgText += '          autoWidth: false, ';
  //msgText += '          buttons: ["copy", "csv", "excel", "pdf", "print", "colvis"] ';
  //msgText += `      }).buttons().container().appendTo("#${dtId}_wrapper .col-md-6:eq(0)"); `;
  msgText += '      }); ';
  msgText += '    } else { ';
  msgText += `      $("#${dtId}").DataTable({`;
  msgText += `          data: ${JSON.stringify(dtRows)}, `;
  msgText += '          order: [[1, "desc"]], ';
  msgText += '          columns: [';
  msgText += '              { title: "Rate", width: "50%", orderable: false, },';
  msgText += '              { title: "Registry", width: "50%", orderable: false, },';
  msgText += '          ], '
  msgText += '          responsive: true, ';
  msgText += '          lengthChange: true, ';
  msgText += '          autoWidth: false, ';
  //msgText += '          buttons: ["copy", "csv", "excel", "pdf", "print", "colvis"] ';
  //msgText += `      }).buttons().container().appendTo("#${dtId}_wrapper .col-md-6:eq(0)"); `;
  msgText += `      }); `;
  msgText += '    }';

  msgText += '    ';
  //msgText += '    $(".btn").tooltip(); ';
  msgText += '    $(".far").tooltip(); ';
  msgText += '});';
  msgText += '    ';
  return msgText;
}

export const getDtMainViewRatesAllScript = (dtId, dtRows) => {
  let msgText = '';
  msgText = '$(document).ready(function () {';
  msgText += '    ';

  msgText += `    if($.fn.dataTable.isDataTable("#${dtId}")){ `;
  msgText += `      const dataTable = $("#${dtId}").DataTable(); `;
  msgText += `      dataTable.destroy(); `;
  msgText += `      $("#${dtId}").DataTable({`;
  msgText += `          data: ${JSON.stringify(dtRows)}, `;
  msgText += '          order: [[1, "desc"]], ';
  msgText += '          columns: [';
  msgText += '              { title: "Rate", width: "50%", orderable: false, },';
  msgText += '              { title: "Registry", width: "45%", orderable: false, },';
  msgText += '              { title: "", width: "5%", orderable: false, },';
  msgText += '          ], ';
  msgText += '          responsive: true, ';
  msgText += '          lengthChange: true, ';
  msgText += '          autoWidth: false, ';
  //msgText += '          buttons: ["copy", "csv", "excel", "pdf", "print", "colvis"] ';
  //msgText += `      }).buttons().container().appendTo("#${dtId}_wrapper .col-md-6:eq(0)"); `;
  msgText += '      }); ';
  msgText += '    } else { ';
  msgText += `      $("#${dtId}").DataTable({`;
  msgText += `          data: ${JSON.stringify(dtRows)}, `;
  msgText += '          order: [[1, "desc"]], ';
  msgText += '          columns: [';
  msgText += '              { title: "Rate", width: "50%", orderable: false, },';
  msgText += '              { title: "Registry", width: "50%", orderable: false, },';
  msgText += '              { title: "", width: "5%", orderable: false, },';
  msgText += '          ], ';
  msgText += '          responsive: true, ';
  msgText += '          lengthChange: true, ';
  msgText += '          autoWidth: false, ';
  //msgText += '          buttons: ["copy", "csv", "excel", "pdf", "print", "colvis"] ';
  //msgText += `      }).buttons().container().appendTo("#${dtId}_wrapper .col-md-6:eq(0)"); `;
  msgText += `      }); `;
  msgText += '    }';

  msgText += '    ';
  //msgText += '    $(".btn").tooltip(); ';
  msgText += '    $(".far").tooltip(); ';
  msgText += '});';
  msgText += '    ';
  return msgText;
}

export const getImageCircularGeneric = (alt, src) => {
  let msgText = '';
  msgText = '<img class="profile-user-img img-circle img-fluid" ';
  msgText += `     alt="${alt}" `;
  msgText += `     src="${!isEmpty(src) ? src : settings?.images?.noImage}" `;
  msgText += '     style="width:45px;height:45px;max-width:100%;">';
  //msgText += '     style="width:45px;max-width:100%;height:auto;">';
  return msgText;
}

export const getImageCircularGenericNew = ({
  alt = '',
  src = '',
  subMethod = ''
} = {}) => {
  const currentMethod = 'getImageCircularGenericNew';
  let response = getResponse({ type: 0 });
  try {
    const { images } = settings;

    response.result = '<img class="profile-user-img img-circle img-fluid" ';
    response.result += `     alt="${alt}" `;
    response.result += `     src="${src !== '' && src !== undefined && src !== null ? src : images?.noImage}" `;
    response.result += '     style="width:45px;height:45px;max-width:100%;">';
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
  return response;
}

export const setBadgeBoolean = (type = false, languageId = 'en') => {
  switch (type) {
    case true:
      return `<span class='badge badge-success'>${settings?.labels?.yes[languageId]}</span>`;
    //break;
    default:
      return `<span class='badge badge-secondary'>${settings?.labels?.no[languageId]}</span>`;
    //break;
  }
}

export const setBadgeBooleanNew = ({
  type = false,
  languageId = 'en'
} = {}) => {
  const { labels } = settings;

  switch (type) {
    case true:
      return `<span class='badge badge-success'>${labels?.yes[languageId]}</span>`;
    //break;
    default:
      return `<span class='badge badge-secondary'>${labels?.no[languageId]}</span>`;
    //break;
  }
}

export const fileToBlobAsync = async (path) => {
  const fileFullPat = await fetch(path);
  const blob = await fileFullPat.blob();
  return blob;
}

export const awaitDelayAsync = (delayTime = 0) => new Promise(
  resolve => setTimeout(resolve, delayTime)
);

export const awaitDelay = ({
  delayTime = 0
} = {}) => new Promise(
  resolve => setTimeout(resolve, delayTime)
);

export const dataTableLanguaje = (code = '') => {
  switch (code) {
    case 'es':
      return {
        sProcessing: 'Procesando..',
        //sLengthMenu: 'Mostrar _MENU_ registros',
        sLengthMenu: 'Mostrar _MENU_',
        sZeroRecords: 'No se encontraron resultados',
        sEmptyTable: 'Ningún dato disponible en esta tabla',
        //sInfo: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        sInfo: 'Mostrando _START_ al _END_ de _TOTAL_ registros',
        //sInfoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
        sInfoEmpty: 'Mostrando 0 al 0 de 0 registros',
        //sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
        sInfoFiltered: '',
        sInfoPostFix: '',
        //sSearch: 'Buscar:',
        sSearch: 'Buscar',
        sUrl: '',
        sInfoThousands: ',',
        sLoadingRecords: 'Cargando..',
        oPaginate: {
          sFirst: 'Primero',
          sLast: 'Último',
          sNext: 'Siguiente',
          sPrevious: 'Anterior'
        },
        oAria: {
          sSortAscending: ': Activar para ordenar la columna de manera ascendente',
          sSortDescending: ': Activar para ordenar la columna de manera descendente'
        }
      }

    default:
      return {
        sEmptyTable: 'No data available in table',
        sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
        sInfoEmpty: 'Showing 0 to 0 of 0 entries',
        sInfoFiltered: '(filtered from _MAX_ total entries)',
        sInfoPostFix: '',
        sInfoThousands: ',',
        sLengthMenu: 'Show _MENU_ entries',
        sLoadingRecords: 'Loading..',
        sProcessing: 'Processing..',
        sSearch: 'Search:',
        sZeroRecords: 'No matching records found',
        oPaginate: {
          sFirst: 'First',
          sLast: 'Last',
          sNext: 'Next',
          sPrevious: 'Previous'
        },
        oAria: {
          sSortAscending: ': activate to sort column ascending',
          sSortDescending: ': activate to sort column descending'
        }
      }
  }
}

export const setDataTableLanguaje = ({
  code = ''
} = {}) => {
  switch (code) {
    case 'es':
      return {
        sProcessing: 'Procesando..',
        //sLengthMenu: 'Mostrar _MENU_ registros',
        sLengthMenu: 'Mostrar _MENU_',
        sZeroRecords: 'No se encontraron resultados',
        sEmptyTable: 'Ningún dato disponible en esta tabla',
        //sInfo: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        sInfo: 'Mostrando _START_ al _END_ de _TOTAL_ registros',
        //sInfoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
        sInfoEmpty: 'Mostrando 0 al 0 de 0 registros',
        //sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
        sInfoFiltered: '',
        sInfoPostFix: '',
        //sSearch: 'Buscar:',
        sSearch: 'Buscar',
        sUrl: '',
        sInfoThousands: ',',
        sLoadingRecords: 'Cargando..',
        oPaginate: {
          sFirst: 'Primero',
          sLast: 'Último',
          sNext: 'Siguiente',
          sPrevious: 'Anterior'
        },
        oAria: {
          sSortAscending: ': Activar para ordenar la columna de manera ascendente',
          sSortDescending: ': Activar para ordenar la columna de manera descendente'
        }
      }

    default:
      return {
        sEmptyTable: 'No data available in table',
        sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
        sInfoEmpty: 'Showing 0 to 0 of 0 entries',
        sInfoFiltered: '(filtered from _MAX_ total entries)',
        sInfoPostFix: '',
        sInfoThousands: ',',
        sLengthMenu: 'Show _MENU_ entries',
        sLoadingRecords: 'Loading..',
        sProcessing: 'Processing..',
        sSearch: 'Search:',
        sZeroRecords: 'No matching records found',
        oPaginate: {
          sFirst: 'First',
          sLast: 'Last',
          sNext: 'Next',
          sPrevious: 'Previous'
        },
        oAria: {
          sSortAscending: ': activate to sort column ascending',
          sSortDescending: ': activate to sort column descending'
        }
      }
  }
}

//#region old code
// export const processButtonsGet = (id = '', description = '', showDetails = false, labelDetails = '', enabledDetails = false, showEdit = false, labelEdit = '', enabledEdit = false, showDelete = false, labelDelete = '', enabledDelete = false, processButtons = []) => {
//   let response = getResponse({ type: 0 });
//   try {
//     response.result = `<div class='btn-group dropend'>`;
//     response.result += `<button class='btn btn-light btn-sm dropdown-toggle' type='button' id='dropdownMenu2' data-bs-toggle='dropdown' aria-expanded='false'> `;
//     response.result += `<i class='${settings?.icons?.fasFa?.ellipsisV}'></i> `;
//     response.result += `</button> `;
//     response.result += `<ul class='dropdown-menu' aria-labelledby='dropdownMenu2'> `;

//     //#region Primay process
//     if (showEdit) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledEdit) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='edit' `;
//       response.result += `type='button'><i class='${settings?.icons?.fasFa?.edit}'></i> ${labelEdit}</button></li> `;
//     }
//     if (showDetails) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledDetails) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='details' `;
//       response.result += `type='button'><i class='fas fa-align-justify'></i> ${labelDetails}</button></li> `;
//     }
//     if (showDelete) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledDelete) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='delete' `;
//       response.result += `type='button'><i class='${settings?.icons?.fasFa?.trashAlt}'></i> ${labelDelete}</button></li> `;
//     }
//     //#endregion Primary process

//     //#region add new buttons

//     if (!isUndefined(processButtons) && !isNull(processButtons) && processButtons.length > 0) {
//       processButtons.map((detail) => {
//         if (detail.isVisible) {

//           if (detail.showDivider) {
//             response.result += `<li class='dropdown-divider'></li>`;
//           }

//           response.result += `<li><button `;
//           response.result += `class='dropdown-item' `;
//           response.result += `description='${description}' `;
//           if (!detail.isEnabled) {
//             response.result += `disabled `;
//           }
//           response.result += `href='javascript:void(0)' `;
//           response.result += `id='${id}' `;
//           response.result += `method='${detail.methodName}' `;
//           response.result += `type='button'><i class='${detail.icon}'></i> ${detail.label}</button></li> `;
//         }
//         return '';
//       });
//     }

//     //#endregion add new buttons

//     response.result += `</ul> `;
//     response.result += `</div>`;
//   } catch (ex) {
//     response.isSuccess = false;
//     response.msgType = -1;
//     response.result = '';
//     response.msgText = `Method: processButtonsGet<br/>${ex.message}`;
//   }
//   return response;
// }
//#endregion old code

export const processButtonsGet = (
  id = '',
  description = '',
  showDetails = false,
  labelDetails = '',
  enabledDetails = false,
  showEdit = false,
  labelEdit = '',
  enabledEdit = false,
  showDelete = false,
  labelDelete = '',
  enabledDelete = false,
  processButtons = []
) => {
  let response = getResponse({ type: 0 });
  try {
    const { icons, labels } = settings;

    response.result = `<span title='${labels?.process.en}' `;
    response.result += `    class='btn btn-light' `;
    response.result += `    data-toggle='dropdown'> `;
    response.result += `<i class='${icons?.fasFa?.ellipsisV}'></i> `;
    response.result += `</span> `;

    response.result += `<div class='dropdown-menu'>`;

    //#region Primay process
    if (showEdit) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledEdit) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='edit' `;
      response.result += `type='button'><i class='${icons?.fasFa?.edit}'></i> ${labelEdit}</button></a> `;
    }
    if (showDetails) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDetails) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='details' `;
      response.result += `type='button'><i class='${icons?.fasFa?.alignJustify}'></i> ${labelDetails}</button></a> `;
    }
    if (showDelete) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!enabledDelete) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='delete' `;
      response.result += `type='button'><i class='${icons?.fasFa?.trashAlt}'></i> ${labelDelete}</button></a> `;
    }
    //#endregion Primary process

    //#region add new buttons

    if (!isUndefined(processButtons) && !isNull(processButtons) && processButtons.length > 0) {
      processButtons.map((detail) => {
        if (detail.isVisible) {

          if (detail.showDivider) {
            //#region old code
            //response.result += `<a class='dropdown-divider'></a>`;
            //#endregion old code
            response.result += `<a><ul class='dropdown-divider'></ul></a>`;
          }

          response.result += `<a><button `;
          response.result += `class='dropdown-item' `;
          response.result += `description='${description}' `;
          if (!detail.isEnabled) {
            response.result += `disabled `;
          }
          response.result += `href='javascript:void(0)' `;
          response.result += `id='${id}' `;
          response.result += `method='${detail.methodName}' `;
          response.result += `type='button'><i class='${detail.icon}'></i> ${detail.label}</button></a> `;
        }
        return '';
      });
    }

    //#endregion add new buttons

    response.result += `</div>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: processButtonsGet<br/>`;
    response.msgText += `Error: ${ex.message}`;
  }
  return response;
}

export const getProcessButtons = ({
  id = '',
  description = '',
  detailsShow = false,
  detailsLabel = '',
  detailsEnabled = false,
  editShow = false,
  editLabel = '',
  editEnabled = false,
  deleteShow = false,
  deleteLabel = '',
  deleteEnabled = false,
  processButtons = [],
  languageId = 'en',
  subMethod = '',
}) => {
  const currentMethod = 'getProcessButtons';
  let response = getResponse({ type: 0 });
  try {
    //#region variables
    const { icons, labels, } = settings;
    //#endregion variables

    // response.result = `<span title='${labels?.process?.[languageId]}' `;
    response.result = `<span data-title='${labels?.process?.[languageId]}' `;
    response.result += `    class='btn btn-light' `;
    response.result += `    data-toggle='dropdown'> `;
    response.result += `<i class='${icons?.fasFa?.ellipsisV}'></i> `;
    response.result += `</span> `;

    response.result += `<div class='dropdown-menu'>`;

    //#region Primay process
    if (editShow) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!editEnabled) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='edit' `;
      response.result += `type='button'><i class='${icons?.fasFa?.edit}'></i> ${editLabel}</button></a> `;
    }
    if (detailsShow) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!detailsEnabled) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='details' `;
      response.result += `type='button'><i class='fas fa-align-justify'></i> ${detailsLabel}</button></a> `;
    }
    if (deleteShow) {
      response.result += `<a><button `;
      response.result += `class='dropdown-item' `;
      response.result += `description='${description}' `;
      if (!deleteEnabled) {
        response.result += `disabled `;
      }
      response.result += `href='javascript:void(0)' `;
      response.result += `id='${id}' `;
      response.result += `method='delete' `;
      response.result += `type='button'><i class='${icons?.fasFa?.trashAlt}'></i> ${deleteLabel}</button></a> `;
    }
    //#endregion Primary process

    //#region add new buttons
    if (processButtons?.length > 0) {
      processButtons.map((detail) => {
        if (detail?.isVisible) {

          if (detail?.showDivider) {
            //#region old code
            //response.result += `<a class='dropdown-divider'></a>`;
            //#endregion old code
            response.result += `<a><ul class='dropdown-divider'></ul></a>`;
          }

          response.result += `<a><button `;
          response.result += `class='dropdown-item' `;
          response.result += `description='${description}' `;
          if (!detail?.isEnabled) {
            response.result += `disabled `;
          }
          response.result += `href='javascript:void(0)' `;
          response.result += `id='${id}' `;
          response.result += `method='${detail?.methodName}' `;
          response.result += `type='button'><i class='${detail?.icon}'></i> ${detail?.label}</button></a> `;
        }
        return '';
      });
    }
    //#endregion add new buttons

    response.result += `</div>`;
  } catch (ex) {
    return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
  return response;
}

// export const getProcessButtons = ({
//   id = '',
//   description = '',
//   showDetails = false,
//   labelDetails = '',
//   enabledDetails = false,
//   showEdit = false,
//   labelEdit = '',
//   enabledEdit = false,
//   showDelete = false,
//   labelDelete = '',
//   enabledDelete = false,
//   processButtons = [],
//   subMethod = ''
// } = {}) => {
//   let response = getResponse({ type: 0 });
//   const currentMethod = 'getProcessButtons';
//   try {
//     const { icons } = settings;

//     response.result = `<div class='btn-group dropleft'>`;
//     response.result += `<button class='btn btn-light border btn-sm dropdown-toggle shadow-sm font-weight-bold' style='border-radius: 5px;' type='button' id='dropdownMenu_${id}' data-toggle='dropdown' aria-expanded='false'> `;
//     response.result += `<i class='${icons?.fasFa?.ellipsisV}'></i> `;
//     response.result += `</button> `;
//     response.result += `<ul class='dropdown-menu' aria-labelledby='dropdownMenu_${id}'> `;

//     //#region primay process
//     if (showEdit) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledEdit) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='edit' `;
//       response.result += `type='button'><i class='${icons?.fasFa?.edit}'></i> ${labelEdit}</button></li> `;
//     }
//     if (showDetails) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledDetails) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='details' `;
//       response.result += `type='button'><i class='${icons?.fa?.alignJustify}'></i> ${labelDetails}</button></li> `;
//     }
//     if (showDelete) {
//       response.result += `<li><button `;
//       response.result += `class='dropdown-item' `;
//       response.result += `description='${description}' `;
//       if (!enabledDelete) {
//         response.result += `disabled `;
//       }
//       response.result += `href='javascript:void(0)' `;
//       response.result += `id='${id}' `;
//       response.result += `method='delete' `;
//       response.result += `type='button'><i class='${icons?.trashFasFa}'></i> ${labelDelete}</button></li> `;
//     }
//     //#endregion primary process

//     //#region add new buttons
//     if (!isUndNullEmp({ data: processButtons, subMethod: currentMethod })?.result && processButtons.length > 0) {
//       processButtons.forEach((detail) => {
//         if (detail.isVisible) {

//           if (detail.showDivider) {
//             response.result += `<li class='dropdown-divider'></li>`;
//           }

//           response.result += `<li><button `;
//           response.result += `class='dropdown-item' `;
//           response.result += `description='${description}' `;
//           if (!detail.isEnabled) {
//             response.result += `disabled `;
//           }
//           response.result += `href='javascript:void(0)' `;
//           response.result += `id='${id}' `;
//           response.result += `method='${detail.methodName}' `;
//           response.result += `type='button'><i class='${detail.icon}'></i> ${detail.label}</button></li> `;
//         }
//       });
//     }
//     //#endregion add new buttons

//     response.result += `</ul> `;
//     response.result += `</div>`;
//   } catch (ex) {
//     response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
//   }
//   return response;
// }

export const numberTruncator = (number = 0.00, decimalPlaces = settings?.numberPositions?.decimalsPlace) => {
  let response = getResponse({ type: 0 });
  try {
    //#region variables

    let localNumber = Math.pow(10, decimalPlaces);

    //#endregion variables

    //#region process

    //console.log({number, localNumber, decimalPlaces});
    response.result = Math.floor(number * localNumber) / localNumber;

    //#endregion process
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = setNumberFour('0.00', 'd')?.result;
    response.msgText = `Method: numberTruncator<br/>${ex.message}`;
  }
  return response;
}

export const numberTruncatorNew = ({
  number = 0.00,
  decimalPlaces = settings?.numberPositions?.decimalsPlace,
  subMethod = ''
} = {}) => {
  const currentMethod = 'numberTruncatorNew';
  let response = getResponse({ type: 0 });
  try {
    //#region variables
    let number_ = Math.pow(10, decimalPlaces);
    //#endregion variables

    //#region process
    response.result = Math.floor(number * number_) / number_;
    //#endregion process
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod })
    response.result = 0.00;
  }
  return response;
}

export const setNumber = (number = 0, type = 'd') => {
  switch (type) {
    case 'd':
      return parseFloat(Number(number).toFixed(settings?.numberPositions?.decimalsPlace));
    default:
      return parseInt(Number(number));
  }
}

export const setNumberTwo = (number = 0, type = 'd') => {
  let localNumber;
  let localZero = '0';
  localZero = `${localZero}.${localZero.repeat(settings?.numberPositions?.decimalsPlace)}`;
  let localZeroNumber = parseFloat(Number(localZero).toFixed(settings?.numberPositions?.decimalsPlace));

  switch (type) {
    case 'd':
      localNumber = parseFloat(Number(number).toFixed(settings?.numberPositions?.decimalsPlace));
      //localNumber = Number(number).toFixed(settings?.numberPositions?.decimalsPlace);
      return (isNaN(localNumber) ? localZeroNumber : localNumber);
    default:
      localNumber = parseInt(Number(number));
      return (isNaN(localNumber) ? 0 : localNumber);
  }
}

export const setNumberFour = (number = 0, type = 'd') => {
  let response = getResponse({ type: 0 });
  try {
    //#region variables

    let localNumber;
    let localZero = '0';
    let localDecimalPlaces = settings?.numberPositions?.decimalsPlace;
    //#region old code

    //let localTruncateDecimalPlaces = 6;

    //#endregion old code
    let localTruncateDecimalPlaces = 15;
    localZero = `${localZero}.${localZero.repeat(localDecimalPlaces)}`;
    let localZeroNumber = parseFloat(Number(localZero).toFixed(localDecimalPlaces));

    //#endregion variables

    //#region Procesos

    switch (type) {
      case 'd':
        response = countDecimals(number);
        if (!response?.isSuccess || response?.isWarning) {
          return response;
        }

        //localNumber = parseFloat(Number(number).toFixed(localDecimalPlaces));
        localNumber = parseFloat(Number(number).toFixed(localTruncateDecimalPlaces));
        //#region old code

        // if (number === 58000005) {
        //   console.log({ number, type });
        //   console.log({ n: 1, localNumber, t: numberTruncator(localNumber, localDecimalPlaces)?.result });
        // }

        //#endregion old code

        if (localDecimalPlaces !== response.result) {
          //response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
          response.result = (isNaN(localNumber) ? localZeroNumber : numberTruncator(localNumber, localDecimalPlaces)?.result);
        } else {
          response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
        }
        break;
      default:
        localNumber = parseInt(Number(number));
        //return (isNaN(localNumber) ? 0 : localNumber);
        response.result = (isNaN(localNumber) ? 0 : localNumber);
        break;
    }

    //#endregion Procesos
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = setNumber('0.00', 'd');
    response.msgText = `Method: setNumberThree<br/>Error: ${ex.message}`;
  }
  return response;
}

export const setNumberNew = ({
  number = 0,
  type = 'd',
  subMethod = ''
} = {}) => {
  const currentMethod = 'setNumberNew';
  let response = getResponse({ type: 0 });
  try {
    //#region variables
    let number_;
    let zero = '0';
    let decimalPlaces = settings?.numberPositions?.decimalsPlace;
    let truncateDecimalPlaces = 15;
    zero = `${zero}.${zero.repeat(decimalPlaces)}`;
    let zeroNumber = parseFloat(Number(zero).toFixed(decimalPlaces));
    //#endregion variables

    //#region Procesos

    switch (type) {
      case 'd':
        response = countDecimalsNew({
          number: number,
          subMethod: currentMethod
        });
        if (!response?.isSuccess || response?.isWarning) return response;

        number_ = parseFloat(Number(number).toFixed(truncateDecimalPlaces));

        if (decimalPlaces !== response.result) {
          response.result = isNaN(number_) ?
            zeroNumber :
            numberTruncatorNew({
              number: number_,
              decimalPlaces: decimalPlaces,
              subMethod: currentMethod
            })?.result;
        } else {
          response.result = isNaN(number_) ? zeroNumber : number_;
        }
        break;
      default:
        number_ = parseInt(Number(number));
        response.result = isNaN(number_) ? 0 : number_;
        break;
    }
    //#endregion Procesos
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod })
    response.result = 0.00;
  }
  return response;
}

export const checkDecimalPlaces = (number = 0.00) => {
  let response = getResponse({ type: 0 });
  try {
    let localNumberString = number.toString();
    let localNumberStringFinal = '';
    let localRepeat = 10;
    let localIndexOf = localNumberString.indexOf('.');
    if (localIndexOf < 0) {
      localNumberStringFinal = `${localNumberString}.${'0'.repeat(localRepeat)}1`;
    } else {
      localNumberStringFinal = `${localNumberString}${'0'.repeat(localRepeat)}1`;
    }
    response.result = Number(localNumberStringFinal);

  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = setNumber('0.00', 'd');
    response.msgText = `Method: checkDecimalPlaces<br/>Error: ${ex.message}`;
  }
  return response;
}

export const checkDecimalPlacesNew = ({
  number = 0.00,
  subMethod = ''
} = {}) => {
  const currentMethod = 'checkDecimalPlacesNew';
  let response = getResponse({ type: 0 });
  try {
    let numberString = number.toString();
    let numberStringFinal = '';
    let repeat = 10;
    let dotIndexOf = numberString.indexOf('.');
    if (dotIndexOf < 0) {
      numberStringFinal = `${numberString}.${'0'.repeat(repeat)}1`;
    } else {
      numberStringFinal = `${numberString}${'0'.repeat(repeat)}1`;
    }
    response.result = Number(numberStringFinal);
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod })
    response.result = 0.00;
  }
  return response;
}

export const countDecimals = (number = 0.00) => {
  let response = getResponse({ type: 0 });
  try {
    if (Math.floor(number.valueOf()) === number.valueOf()) {
      response.result = 0;
      return response;
    }

    var localNumberStr = number.toString();
    if (localNumberStr.indexOf(".") !== -1 && localNumberStr.indexOf("-") !== -1) {
      response.result = localNumberStr.split("-")[1] || 0;
      return response;
    } else if (localNumberStr.indexOf(".") !== -1) {
      response.result = localNumberStr.split(".")[1].length || 0;
      return response;
    }
    response.result = localNumberStr.split("-")[1] || 0;
  } catch (ex) {
    response.result = 0;
    response.msgType = -1;
    response.isSuccess = false;
    response.result = setNumber('0.00', 'd');
    response.msgText = `Method: countDecimals<br/>Error: ${ex.message}`;
  }
  return response;
}

export const countDecimalsNew = ({
  number = 0.00,
  subMethod = ''
} = {}) => {
  const currentMethod = 'countDecimalsNew';
  let response = getResponse({ type: 0 });
  try {
    if (Math.floor(number.valueOf()) === number.valueOf()) {
      response.result = 0;
      return response;
    }

    let numberStr = number.toString();
    if (numberStr.indexOf(".") !== -1 && numberStr.indexOf("-") !== -1) {
      response.result = numberStr.split("-")[1] || 0;
      return response;
    } else if (numberStr.indexOf(".") !== -1) {
      response.result = numberStr.split(".")[1].length || 0;
      return response;
    }
    response.result = numberStr.split("-")[1] || 0;
  } catch (ex) {
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod })
    response.result = 0.00;
  }
  return response;
}

export const validateDecimals = (e = {}) => {
  let start = 0;
  const state = { input: '' };

  start = e.target.selectionStart;
  let val = e.target.value;
  val = val.replace(/([^0-9.]+)/, '');
  val = val.replace(/^(0|\.)/, '');
  //const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
  const match = /(\d{0,15})[^.]*((?:\.\d{0,2})?)/g.exec(val);
  const value = match[1] + match[2];
  e.target.value = value;
  //this.setState({ input: value });
  state.input = value;
  if (val.length > 0) {
    e.target.value = Number(value).toFixed(settings?.numberPositions?.decimalsPlace);
    e.target.setSelectionRange(start, start);
    //this.setState({ input: Number(value).toFixed(2) });
    state.input = Number(value).toFixed(settings?.numberPositions?.decimalsPlace);
    //}
  } else {
    state.input = setNumberTwo('Nikole', 'd');
  }

  state.input = isNaN(e.target.value) ? setNumberTwo('Nikole', 'd') : state.input;
  return state.input;
};

export const getDtRowIndex = (dtId = '', this_ = {}, subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    let rowIndexLocal = undefined;
    rowIndexLocal = $(this_).children('td').children('ul').attr('data-dtr-index');
    if (rowIndexLocal !== undefined && rowIndexLocal !== null && rowIndexLocal !== '') {
      rowIndexLocal = parseInt(rowIndexLocal);
    } else {
      rowIndexLocal = $(`#${dtId}`).DataTable().row(this_).index();
    }
    response.result = rowIndexLocal;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: getDtRowIndex<br/>`;
    if (subMethod !== '') {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex.message}`;
    console?.error(response);
  }
  return response;
}

export const getDtRowIndexNew = ({
  dtId = '',
  this_ = {},
  subMethod = ''
} = {}) => {
  const currentMethod = 'getDtRowIndexNew';
  let response = getResponse({ type: 0 });
  try {
    let rowIndexLocal = undefined;
    rowIndexLocal = $(this_).children('td').children('ul').attr('data-dtr-index');
    if (rowIndexLocal !== undefined && rowIndexLocal !== null && rowIndexLocal !== '') {
      rowIndexLocal = parseInt(rowIndexLocal);
    } else {
      rowIndexLocal = $(`#${dtId}`).DataTable().row(this_).index();
    }
    response.result = rowIndexLocal;
  } catch (ex) {
    let response = getResponse({ type: 0, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
    console?.error(response);
  }
  return response;
}

export const navSetting = {
  navItemMenuOpen: 'nav-item menu-open',
  navItem: 'nav-item',
  navLinkActive: 'nav-link active',
  navLink: 'nav-link',
};

export const isUndNullEmp = (data = undefined, subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    //#region old code

    //response.result = (data === undefined || data === null || data === '');
    //response.result = (data === undefined || data === null || (data === [] && data.length <= 0) || data === '' || (Object.keys(data).length === 0 && data.constructor === Object));

    //#endregion old code
    response.result = (data === undefined || data === null || data === '' ||
      (Object.keys(data).length <= 0 && data.constructor === Object)
      || (Array.isArray(data) && data.length <= 0));
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: isUndNullEmp<br/>`;
    if (subMethod !== '') {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex.message}`;
    console?.error(response);
    sendMessageNew({
      msgType: response?.msgType,
      msgText: response?.msgText,
      timer: 0,
      confirmButton: true,
      timerProgressBar: false,
      languageId: 'en',
    });
  }
  return response;
}

export const isUndNull = (data = undefined, subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    response.result = (data === undefined || data === null);
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: isUndNull<br/>`;
    if (subMethod !== '') {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex.message}`;
    console?.error(response);
    sendMessageNew({
      msgType: response?.msgType,
      msgText: response?.msgText,
      timer: 0,
      confirmButton: true,
      timerProgressBar: false,
      languageId: 'en',
    });
  }
  return response;
}

export const isUndNullEmpNew = ({ data = undefined, subMethod = '', }) => {
  const currentMethod = 'isUndNullEmpNew';
  let response = getResponse({ type: 0 });
  try {
    response.result = (data === undefined || data === null || data === '' ||
      (Object.keys(data).length <= 0 && data.constructor === Object)
      || (Array.isArray(data) && data.length <= 0));
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: ${currentMethod}<br/>`;
    if (subMethod !== '') {
      response.msgText += `Sub method: ${subMethod}<br/>`;
    }
    response.msgText += `Error: ${ex.message}`;
    console?.error(response);
    sendMessageNew({
      msgType: response?.msgType,
      msgText: response?.msgText,
      timer: 0,
      confirmButton: true,
      timerProgressBar: false,
      languageId: 'en',
    });
  }
  return response;
}

export const isUndNullNew = ({ data = undefined, subMethod = '', }) => {
  const currentMethod = 'isUndNullNew';
  let response = getResponse({ type: 0 });
  try {
    response.result = (data === undefined || data === null);
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    console?.error(response);
    sendMessageNew({
      msgType: response?.msgType,
      msgText: response?.msgText,
      timer: 0,
      confirmButton: true,
      timerProgressBar: false,
      languageId: 'en',
    });
  }
  return response;
}

export const styles = {
  appLogo: {
    height: 45,
    width: 70,
  },

  appLogoHome: {
    //height: '240px',
    width: '250px',
    maxWidth: '100%',
    height: 'auto',
  },

  cardHeaderLogo: {
    height: 30,
    width: 30,
  },

  cardHeaderSaleDetailLogo: {
    height: 55,
    width: 55,
  },

  graphRates: {
    minHeight: 250,
    height: 250,
    maxHeight: 250,
    maxWidth: '100%',
  },

  labelMsgAlert: {
    fontSize: 12,
    color: 'orangered'
  },

  loginIcon: {
    height: 33,
    width: 33,
  },

  labelMsgInfo: {
    fontSize: 12,
    color: '#18A2B8'
  },

  inputMsgAlert: {
    fontSize: 12,
    color: 'orangered'
  },

  navStyle: {
    color: 'white',
  },

  titleUser: {
    marginBottom: 10,
  },

  loginBox: {
    margin: '0 auto'
  },

  userLogin: {
    width: 30,
    height: 'auto',
    maxWidth: '100%'
  },

  logoAppSmall: {
    width: 40,
    height: 'auto',
    maxWidth: '100%'
  },

  paragrapJustify: {
    textIndent: 4,
    textAlign: 'justify'
  },

  profileUserPicture: {
    aspectRatio: 1,
    flex: 1,
    height: 100,
    width: 100,

  },

  leftMenuUserPicture: {
    aspectRatio: 1,
    flex: 1,
    height: 40,
    width: 40,
  },

}

//#region old code
// export const axios = {
//   //#region delete

//   delete: async (url = '', headers = {}, subMethod = '') => {
//       //#region variables
//       let response = getResponse({ type: 0 });
//       const localMethod = 'axios / delete';
//       let result = {};

//       //#endregion variables
//       try {
//           //#region variables

//           result = {};
//           let options = {};

//           //#endregion variables

//           //#region Method

//           options = {
//               method: 'DELETE',
//               headers: isUndNullEmp(headers)?.result ?
//                   { 'Content-Type': 'application/json', } :
//                   { ...headers, 'Content-Type': 'application/json', },
//           };

//           result = await fetch(
//               url,
//               options,
//           );

//           response.result = await result.json();

//           //#endregion Method
//       } catch (ex) {
//           response.msgText = `Method: ${localMethod}<br/>`;
//           if (subMethod !== '') {
//               response.msgText += `Sub method: ${subMethod}<br/>`;
//           }

//           switch (isUndNullEmp(result)?.result) {
//               case true:
//                   response.isWarning = true;
//                   response.msgType = 1;
//                   response.msgText += `Error: 404 - url not found<br/>`;
//                   response.msgText += `Message: ${ex.message}`;
//                   break;
//               default:
//                   response.isSuccess = false;
//                   response.msgType = -1;
//                   response.msgText += `Error: ${ex.message}`;
//                   break;
//           }
//       }
//       return response;
//   },

//   //#endregion delete

//   //#region get

//   get: async (url = '', headers = {}, subMethod = '') => {
//       //#region variables
//       let response = getResponse({ type: 0 });
//       const localMethod = 'axios / get';
//       let result = {};

//       //#endregion variables
//       try {
//           //#region variables

//           result = {};
//           let options = {};

//           //#endregion variables

//           //#region Method

//           options = {
//               method: 'GET',
//               headers: isUndNullEmp(headers)?.result ?
//                   { 'Content-Type': 'application/json', } :
//                   { ...headers, 'Content-Type': 'application/json', },
//           };

//           result = await fetch(
//               url,
//               options,
//           );

//           response.result = await result.json();

//           //#endregion Method
//       } catch (ex) {
//           response.msgText = `Method: ${localMethod}<br/>`;
//           if (subMethod !== '') {
//               response.msgText += `Sub method: ${subMethod}<br/>`;
//           }

//           switch (isUndNullEmp(result)?.result) {
//               case true:
//                   response.isWarning = true;
//                   response.msgType = 1;
//                   response.msgText += `Error: 404 - url not found<br/>`;
//                   response.msgText += `Message: ${ex.message}`;
//                   break;
//               default:
//                   response.isSuccess = false;
//                   response.msgType = -1;
//                   response.msgText += `Error: ${ex.message}`;
//                   break;
//           }
//       }
//       return response;
//   },

//   //#endregion get

//   //#region post

//   post: async (url = '', data = {}, headers = {}, subMethod = '') => {
//       //#region variables
//       let response = getResponse({ type: 0 });
//       const localMethod = 'axios / post';
//       let result = {};

//       //#endregion variables
//       try {
//           //#region variables

//           result = {};
//           let options = {};

//           //#region Response is warning

//           let responseWarning = getResponse({ type: 0 });
//           responseWarning.msgType = 1;
//           responseWarning.isWarning = true;
//           responseWarning.msgText = `Method: ${localMethod}<br/>`;
//           if (responseWarning !== '') {
//               responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
//           }

//           //#endregion Response is warning

//           //#endregion variables

//           //#region Method

//           options = {
//               method: 'POST',
//               headers: isUndNullEmp(headers)?.result ?
//                   { 'Content-Type': 'application/json', } :
//                   { ...headers, 'Content-Type': 'application/json', },
//               body: JSON.stringify(data),
//           };

//           result = await fetch(
//               url,
//               options,
//           );

//           if (result.status !== 200) {
//               responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
//               //responseWarning.msgText += `Code: ${result.status}<br/>`;
//               responseWarning.msgText += `Url: ${result.url}`;
//               return responseWarning;
//           }

//           response.result = await result.json();

//           //#endregion Method
//       } catch (ex) {
//           response.msgText = `Method: ${localMethod}<br/>`;
//           if (subMethod !== '') {
//               response.msgText += `Sub method: ${subMethod}<br/>`;
//           }

//           switch (isUndNullEmp(result)?.result) {
//               case true:
//                   response.isWarning = true;
//                   response.msgType = 1;
//                   response.msgText += `Error: 404 - url not found<br/>`;
//                   response.msgText += `Message: ${ex.message}`;
//                   break;
//               default:
//                   response.isSuccess = false;
//                   response.msgType = -1;
//                   response.msgText += `Error: ${ex.message}`;
//                   break;
//           }
//       }
//       return response;
//   }

//   //#endregion post
// }

// export const axios = {
//   //#region delete

//   delete: async (url = '', headers = {}, subMethod = '') => {
//   },

//   //#endregion delete

//   //#region get

//   get: async (url = '', headers = {}, subMethod = '') => {
//   },

//   //#endregion get

//   //#region post

//   post: async (url = '', data = {}, headers = {}, subMethod = '') => {
//   }

//   //#endregion post
// }
//#endregion old code

//#region old code
// export const axios = {
//   //#region delete

//   delete: async (url = '', headers = {}, subMethod = '') => {
//     //#region variables
//     let response = getResponse({ type: 0 });
//     const localMethod = 'axios / delete';
//     let result = {};

//     //#endregion variables
//     try {
//       //#region variables

//       result = {};
//       let options = {};

//       //#region Response is warning

//       let responseWarning = getResponse({ type: 0 });
//       responseWarning.msgType = 1;
//       responseWarning.isWarning = true;
//       responseWarning.msgText = `Method: ${localMethod}<br/>`;
//       if (responseWarning !== '') {
//         responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       //#endregion Response is warning

//       //#endregion variables

//       //#region Method

//       options = {
//         method: 'DELETE',
//         headers: isUndNullEmp(headers)?.result ?
//           { 'Content-Type': 'application/json', } :
//           { ...headers, 'Content-Type': 'application/json', },
//       };

//       result = await fetch(
//         url,
//         options,
//       );

//       if (result.status !== 200) {
//         responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
//         //responseWarning.msgText += `Code: ${result.status}<br/>`;
//         responseWarning.msgText += `Url: ${result.url}`;
//         return responseWarning;
//       }

//       response = await result.json();

//       //#endregion Method
//     } catch (ex) {
//       response.msgText = `Method: ${localMethod}<br/>`;
//       if (subMethod !== '') {
//         response.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       switch (isUndNullEmp(result)?.result) {
//         case true:
//           response.isWarning = true;
//           response.msgType = 1;
//           response.msgText += `Error: 404 - url not found<br/>`;
//           response.msgText += `Message: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           break;
//         default:
//           response.isSuccess = false;
//           response.msgType = -1;
//           response.msgText += `Error: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           break;
//       }
//     }
//     return response;
//   },

//   //#endregion delete

//   //#region get

//   get: async (url = '', headers = {}, subMethod = '') => {
//     //#region variables
//     let response = getResponse({ type: 0 });
//     const localMethod = 'axios / get';
//     let result = {};

//     //#endregion variables
//     try {
//       //#region variables

//       result = {};
//       let options = {};

//       //#region Response is warning

//       let responseWarning = getResponse({ type: 0 });
//       responseWarning.msgType = 1;
//       responseWarning.isWarning = true;
//       responseWarning.msgText = `Method: ${localMethod}<br/>`;
//       if (responseWarning !== '') {
//         responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       //#endregion Response is warning

//       //#endregion variables

//       //#region Method

//       options = {
//         method: 'GET',
//         headers: isUndNullEmp(headers)?.result ?
//           { 'Content-Type': 'application/json', } :
//           { ...headers, 'Content-Type': 'application/json', },
//       };

//       result = await fetch(
//         url,
//         options,
//       );

//       if (result.status !== 200) {
//         responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
//         //responseWarning.msgText += `Code: ${result.status}<br/>`;
//         responseWarning.msgText += `Url: ${result.url}`;
//         return responseWarning;
//       }

//       response = await result.json();

//       //#endregion Method
//     } catch (ex) {
//       response.msgText = `Method: ${localMethod}<br/>`;
//       if (subMethod !== '') {
//         response.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       switch (isUndNullEmp(result)?.result) {
//         case true:
//           response.isWarning = true;
//           response.msgType = 1;
//           response.msgText += `Error: 404 - url not found<br/>`;
//           response.msgText += `Message: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           break;
//         default:
//           response.isSuccess = false;
//           response.msgType = -1;
//           response.msgText += `Error: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           break;
//       }
//     }
//     return response;
//   },

//   //#endregion get

//   //#region post

//   post: async (url = '', data = {}, headers = {}, subMethod = '') => {
//     //#region variables
//     let response = getResponse({ type: 0 });
//     const localMethod = 'axios / post';
//     let result = {};

//     //#endregion variables
//     try {
//       //#region variables

//       result = {};
//       let options = {};

//       //#region Response is warning

//       let responseWarning = getResponse({ type: 0 });
//       responseWarning.msgType = 1;
//       responseWarning.isWarning = true;
//       responseWarning.msgText = `Method: ${localMethod}<br/>`;
//       if (responseWarning !== '') {
//         responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       //#endregion Response is warning

//       //#endregion variables

//       //#region Method

//       options = {
//         method: 'POST',
//         headers: isUndNullEmp(headers)?.result ?
//           { 'Content-Type': 'application/json', } :
//           { ...headers, 'Content-Type': 'application/json', },
//         body: JSON.stringify(data),
//       };

//       result = await fetch(
//         url,
//         options,
//       );

//       if (result.status !== 200) {
//         responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
//         //responseWarning.msgText += `Code: ${result.status}<br/>`;
//         responseWarning.msgText += `Url: ${result.url}<br/>`;
//         if (!isUndNullEmp(response, localMethod)?.result && !isUndNull(response.msgText, localMethod)?.result) {
//           responseWarning.msgText += `Message: ${response.msgText}`;
//         }
//         return responseWarning;
//       }

//       response = await result.json();

//       //#endregion Method
//     } catch (ex) {
//       response.msgText = `Method: ${localMethod}<br/>`;
//       if (subMethod !== '') {
//         response.msgText += `Sub method: ${subMethod}<br/>`;
//       }

//       switch (isUndNullEmp(result)?.result) {
//         case true:
//           response.isWarning = true;
//           response.msgType = 1;
//           response.msgText += `Error: 404 - url not found<br/>`;
//           response.msgText += `Message: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           //response.msgText += `Data: ${JSON.stringify(result)}<br/>`;
//           //response.msgText += `Data: ${JSON.stringify(response)}`;
//           break;
//         default:
//           response.isSuccess = false;
//           response.msgType = -1;
//           response.msgText += `Error: ${ex.message}<br/>`;
//           response.msgText += `Url: ${url}`;
//           //response.msgText += `Data: ${JSON.stringify(result)}<br/>`;
//           //response.msgText += `Data: ${JSON.stringify(response)}`;
//           break;
//       }
//     }
//     return response;
//   }

//   //#endregion post
// }
//#endregion old code

export const axios = {
  //#region delete

  delete: async (url = '', headers = {}, subMethod = '') => {
    //#region variables
    let response = getResponse({ type: 0 });
    const localMethod = 'axios / delete';
    let result = {};

    //#endregion variables
    try {
      //#region variables

      result = {};
      let options = {};

      //#endregion variables

      //#region Method

      options = {
        method: 'DELETE',
        headers: isUndNullEmp(headers, localMethod)?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      //#endregion Method
    } catch (ex) {
      response.msgText = `Method: ${localMethod}<br/>`;
      if (!isUndNullEmp(subMethod, localMethod)?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, localMethod)?.result) {
        case true:
          response.isWarning = true;
          response.msgType = 1;
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        default:
          response.isSuccess = false;
          response.msgType = -1;
          response.msgText += `Error: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
      }
    }
    return response;
  },

  //#endregion delete

  //#region get

  get: async (url = '', headers = {}, subMethod = '') => {
    //#region variables
    let response = getResponse({ type: 0 });
    const localMethod = 'axios / get';
    let result = {};

    //#endregion variables
    try {
      //#region variables

      result = {};
      let options = {};

      //#region Response is warning

      let responseWarning = getResponse({ type: 0 });
      responseWarning.msgType = 1;
      responseWarning.isWarning = true;
      responseWarning.msgText = `Method: ${localMethod}<br/>`;
      if (responseWarning !== '') {
        responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
      }

      //#endregion Response is warning

      //#endregion variables

      //#region Method

      options = {
        method: 'GET',
        headers: isUndNullEmp(headers, localMethod)?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          //responseWarning.msgText += `Code: ${result.status}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }

      //#endregion Method
    } catch (ex) {
      response.msgText = `Method: ${localMethod}<br/>`;
      if (!isUndNullEmp(subMethod, localMethod)?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, localMethod)?.result) {
        case true:
          response.isWarning = true;
          response.msgType = 1;
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        default:
          response.isSuccess = false;
          response.msgType = -1;
          response.msgText += `Error: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
      }
    }
    return response;
  },

  //#endregion get

  //#region post

  post: async (url = '', data = {}, headers = {}, subMethod = '') => {
    //#region variables
    let response = getResponse({ type: 0 });
    const localMethod = 'axios / post';
    let result = {};

    //#endregion variables
    try {
      //#region variables

      result = {};
      let options = {};

      //#region Response is warning

      let responseWarning = getResponse({ type: 0 });
      responseWarning.msgType = 1;
      responseWarning.isWarning = true;
      responseWarning.msgText = `Method: ${localMethod}<br/>`;
      if (responseWarning !== '') {
        responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
      }

      //#endregion Response is warning

      //#endregion variables

      //#region Method

      options = {
        method: 'POST',
        headers: isUndNullEmp(headers, localMethod)?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          //responseWarning.msgText += `Code: ${result.status}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }

      //#endregion Method
    } catch (ex) {
      response.msgText = `Method: ${localMethod}<br/>`;
      if (!isUndNullEmp(subMethod, localMethod)?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, localMethod)?.result) {
        case true:
          response.isWarning = true;
          response.msgType = 1;
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        //return response;
        default:
          response.isSuccess = false;
          response.msgType = -1;
          response.msgText += `Error: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        //return response;
      }
    }
    return response;
  },

  //#endregion post

  //#region Put

  put: async (url = '', data = {}, headers = {}, subMethod = '') => {
    //#region variables
    let response = getResponse({ type: 0 });
    const localMethod = 'axios / put';
    let result = {};

    //#endregion variables
    try {
      //#region variables

      result = {};
      let options = {};

      //#region Response is warning

      let responseWarning = getResponse({ type: 0 });
      responseWarning.msgType = 1;
      responseWarning.isWarning = true;
      responseWarning.msgText = `Method: ${localMethod}<br/>`;
      if (responseWarning !== '') {
        responseWarning.msgText += `Sub method: ${subMethod}<br/>`;
      }

      //#endregion Response is warning

      //#endregion variables

      //#region Method

      options = {
        method: 'PUT',
        headers: isUndNullEmp(headers, localMethod)?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }

      //#endregion Method
    } catch (ex) {
      response.msgText = `Method: ${localMethod}<br/>`;
      if (!isUndNullEmp(subMethod, localMethod)?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, localMethod)?.result) {
        case true:
          response.isWarning = true;
          response.msgType = 1;
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        default:
          response.isSuccess = false;
          response.msgType = -1;
          response.msgText += `Error: ${ex.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
      }
    }
    return response;
  }

  //#endregion Put
}

export const axiosV2 = {
  //#region delete
  delete: async ({
    url = '',
    headers = {},
    data = {},
    subMethod = ''
  } = {}) => {
    //#region variables
    const currentMethod = 'axios / delete';
    let response = getResponse({ type: 0 });
    let result = {};
    //#endregion variables
    try {
      //#region variables
      result = {};
      let options = {};
      //#region response is warning
      let responseWarning = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
      //#endregion response is warning
      //#endregion variables

      //#region method
      options = {
        method: 'DELETE',
        headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isSuccess, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isWarning, subMethod: currentMethod })?.result) {
            response = response?.result;
          }
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          //responseWarning.msgText += `Code: ${result.status}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }
      //#endregion method
    } catch (ex) {
      switch (isUndNullEmp(result, currentMethod)?.result) {
        case true:
          response = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
        default:
          response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          break;
      }
    }
    return response;
  },
  //#endregion delete

  //#region get
  get: async ({
    url = '',
    headers = {},
    subMethod = ''
  } = {}) => {
    //#region variables
    const currentMethod = 'axios / get';
    let response = getResponse({ type: 0 });
    let result = {};
    //#endregion variables
    try {
      //#region variables
      result = {};
      let options = {};
      //#region response is warning
      let responseWarning = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
      //#endregion response is warning
      //#endregion variables

      //#region method
      options = {
        method: 'GET',
        headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isSuccess, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isWarning, subMethod: currentMethod })?.result) {
            response = response?.result;
          }
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          //responseWarning.msgText += `Code: ${result.status}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }
      //#endregion method
    } catch (ex) {
      response.msgText = `Method: ${currentMethod}<br/>`;
      if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, currentMethod)?.result) {
        case true:
          response = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
        default:
          response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
      }
    }
    return response;
  },
  //#endregion get

  //#region post
  post: async ({
    url = '',
    data = {},
    headers = {},
    subMethod = ''
  } = {}) => {
    //#region variables
    const currentMethod = 'axios / post';
    let response = getResponse({ type: 0 });
    let result = {};
    //#endregion variables
    try {
      //#region variables
      result = {};
      let options = {};
      //#region response is warning
      let responseWarning = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
      //#endregion response is warning
      //#endregion variables

      //#region method
      options = {
        method: 'POST',
        headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isSuccess, subMethod: currentMethod })?.result &&
            !isUndNull({ data: response?.result?.isWarning, subMethod: currentMethod })?.result) {
            response = response?.result;
          }
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          //responseWarning.msgText += `Code: ${result.status}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }

      //#endregion method
    } catch (ex) {
      switch (isUndNullEmp(result, currentMethod)?.result) {
        case true:
          response = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
        default:
          response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
      }
    }
    return response;
  },
  //#endregion post

  //#region put
  put: async ({
    url = '',
    data = {},
    headers = {},
    subMethod = ''
  } = {}) => {
    //#region variables
    const currentMethod = 'axios / put';
    let response = getResponse({ type: 0 });
    let result = {};
    //#endregion variables
    try {
      //#region variables
      result = {};
      let options = {};
      //#region response is warning
      let responseWarning = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
      //#endregion response is warning
      //#endregion variables

      //#region method
      options = {
        method: 'PUT',
        headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
          { 'Content-Type': 'application/json', } :
          { ...headers, 'Content-Type': 'application/json', },
        body: JSON.stringify(data),
      };

      result = await fetch(url, options,);
      response.result = await result.json();

      switch (result.status) {
        case 200:
          break;
        default:
          responseWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
          responseWarning.msgText += `Url: ${result.url}<br/>`;
          responseWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
          responseWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
          responseWarning.result = result;
          return responseWarning;
      }

      //#endregion method
    } catch (ex) {
      response.msgText = `Method: ${currentMethod}<br/>`;
      if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        response.msgText += `Sub method: ${subMethod}<br/>`;
      }

      switch (isUndNullEmp(result, currentMethod)?.result) {
        case true:
          response = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: 404 - url not found<br/>`;
          response.msgText += `Message: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
        default:
          response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod });
          response.msgText += `Error: ${ex?.message}<br/>`;
          response.msgText += `Url: ${url}<br/>`;
          response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
          return response;
      }
    }
    return response;
  }
  //#endregion put
}

export const registerUserMessages = {
  msg001: ({
    firstName = '',
    lastName = '',
    email = '',
    languageId = 'en',
    subMethod = ''
  } = {}) => {
    const currentMethod = 'registerUserMessages / msg001';
    let response = getResponse({ type: 0 });
    try {
      const { dptoSupport } = settings.app.emails;

      switch (languageId) {
        case 'en':
          response.result = `<br/>`;
          response.result += `Dear <b>${firstName} ${lastName}</b>, for security and to complete the registration process you must enter your email account: `;
          response.result += `<br/>`;
          response.result += `<br/>`;
          response.result += `<p>- <b>${email}</b> and verify your account <b>(by clicking in the link that we have sent you)</b>.</p>`;
          response.result += `<p>- Once the account is verified you will be able to access our system.</p>`;
          response.result += `<p>- If you can't see the mail in the <b>Inbox</b>, please check the <b>Spam</b> or <b>Junk Mail</b> mailbox.</p>`;
          response.result += `If you do not receive the confirmation email, contact the `;
          response.result += `<a href='mailto:${dptoSupport}?subject=Register%20new%20user%20(message)'><b>Support Department</b></a>`;
          response.result += `<br/>`;
          response.result += `<br/>`;
          break;
        default:
          response.result = `<br/>`;
          response.result += `Estimado <b>${firstName} ${lastName}</b>, por seguridad y para completar el proceso de registro debe ingresar su cuenta de correo electrónico: `;
          response.result += `<br/>`;
          response.result += `<br/>`;
          response.result += `<p>- <b>${email}</b> y verifica tu cuenta <b>(haciendo clic en el enlace que te hemos enviado)</b>.</p>`;
          response.result += `<p>- Una vez verificada la cuenta podrás acceder a nuestro sistema.</p>`;
          response.result += `<p>- Si no puedes ver el correo en la <b>Bandeja de entrada</b>, compruebe el buzón de <b>Correo no deseado</b> o <b>Correo Spam</b>.</p>`;
          response.result += `Si no recibe el correo electrónico de confirmación, comuníquese con `;
          response.result += `<a href='mailto:${dptoSupport}?subject=Registrar%20nuevo%20usuario%20(mensaje)'><b>Departamento de soporte</b></a >`;
          response.result += `<br/>`;
          response.result += `<br/>`;
          break;
      }
    } catch (ex) {
      response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod, subMethod_: subMethod });
      response.result = response.msgText;
    }
    return response;
  }
}

export const charactersRemainingGet = (text = '', maxLength = 0, msgText = '', subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    //response.result = `${text.length - maxLength} ${msgText}`;
    response.result = `${msgText} <b>${maxLength - text.length}</b>`;
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: charactersRemainingGet<br/>`;
    if (!isUndNullEmp(subMethod)?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
    response.result = 'Status - error'
    sendMessageNew({
      msgType: response?.msgType,
      msgText: response?.msgText,
      timer: 0,
      confirmButton: true,
      timerProgressBar: false,
      languageId: 'en',
    });
  }
  return response;
}

export const formatBytes = (bytes = 0, decimals = settings?.numberPositions?.decimalsPlace, subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    if (bytes === 0) {
      response.result = '0 Bytes';
    } else {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      //return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      response.result = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.result = '';
    response.msgText = `Method: formatBytes<br/>`;
    if (!isUndNullEmp(subMethod)?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
  }
  return response;
}

export const formatBytesNew = ({
  bytes = 0,
  decimals = settings?.numberPositions?.decimalsPlace,
  subMethod = ''
} = {}) => {
  const currentMethod = 'formatBytesNew';
  let response = getResponse({ type: 0 });
  try {
    if (bytes === 0) {
      response.result = '0 Bytes';
    } else {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      //return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      response.result = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    return response;
  } catch (ex) {
    return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
}

export const fileNameByExtensionGet = (fileTypes = [], fileMaxSize = 0, subMethod = '') => {
  const currentMethod = 'fileNameByExtensionGet';
  let response = getResponse({ type: 0 });
  try {
    //#region check file type (object)
    response.isWarning = true;
    response.msgType = 1;

    if (isUndNull(fileTypes)?.result || fileTypes.length <= 0) {
      response.msgText = `${settings.messages.youMustDefineFileTypes.en}<br/>`;
      response.msgText += `Method: ${currentMethod}<br/>`;
      response.msgText += `${settings.messages.pleaseTryAgain.en}`;
      return response;
    }

    //#endregion check file type (object)

    //#region check file types (get names)
    response.msgText = `${settings.messages.onlyTheFollowingFilesAreAllowed.en}:<br/>`;
    fileTypes.forEach((type) => {
      switch (type) {
        //#region images
        case 'image/png':
          response.msgText += 'PNG, '
          break;
        case 'image/jpeg':
          response.msgText += 'JPEG, '
          break;
        case 'image/jpg':
          response.msgText += 'JPG, '
          break;
        case 'image/bmp':
          response.msgText += 'BMP, '
          break;
        //#endregion images

        //#region files
        case 'application/msword':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.ms-excel':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.ms-powerpoint':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;
        case 'application/pdf':
          response.msgText += 'PDF, ';
          break;
        case 'text/plain':
          response.msgText += 'TXT, ';
          break;
        //#endregion files
        default:
          break;
      }
    });
    //#endregion check file types (get names)

    //#region add leyend max size
    if (fileMaxSize > 0) {
      response.msgText += `<br/>${settings.messages.maximunWeightAllowed.en}: <b>${formatBytes(fileMaxSize, 0)?.result}</b>`;
    }
    //#endregion add leyend max size
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
  return response;
}

export const getFileNameByExtension = ({
  fileTypes = [],
  fileMaxSize = 0,
  languageId = 'en',
  subMethod = ''
} = {}) => {
  const currentMethod = 'getFileNameByExtension';
  let response = getResponse({ type: 0 });
  try {
    //#region variables
    const { messages } = settings;
    //#endregion variables

    //#region check file type (object)
    response.isWarning = true;
    response.msgType = 1;

    if (isUndNull(fileTypes)?.result || fileTypes.length <= 0) {
      response.msgText = `${messages?.youMustDefineFileTypes?.[languageId]}<br/>`;
      response.msgText += `Method: ${currentMethod}<br/>`;
      response.msgText += `${messages?.pleaseTryAgain?.[languageId]}`;
      return response;
    }

    //#endregion check file type (object)

    //#region check file types (get names)
    response.msgText = `${messages?.onlyTheFollowingFilesAreAllowed?.[languageId]}:<br/>`;
    fileTypes.forEach((type) => {
      switch (type) {
        //#region images
        case 'image/png':
          response.msgText += 'PNG, '
          break;
        case 'image/jpeg':
          response.msgText += 'JPEG, '
          break;
        case 'image/jpg':
          response.msgText += 'JPG, '
          break;
        case 'image/bmp':
          response.msgText += 'BMP, '
          break;
        //#endregion images

        //#region files
        case 'application/msword':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          if (response.msgText.indexOf('Word', response.msgText) <= -1) {
            response.msgText += 'Word, '
          }
          break;
        case 'application/vnd.ms-excel':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          if (response.msgText.indexOf('Excel', response.msgText) <= -1) {
            response.msgText += 'Excel, '
          }
          break;
        case 'application/vnd.ms-powerpoint':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          if (response.msgText.indexOf('Power point', response.msgText) <= -1) {
            response.msgText += 'Power point, '
          }
          break;
        case 'application/pdf':
          response.msgText += 'PDF, ';
          break;
        case 'text/plain':
          response.msgText += 'TXT, ';
          break;
        //#endregion files
        default:
          break;
      }
    });
    //#endregion check file types (get names)

    //#region add leyend max size
    if (fileMaxSize > 0) {
      response.msgText += `<br/>${messages?.maximunWeightAllowed?.[languageId]}: <b>${formatBytesNew({ bytes: fileMaxSize, decimals: 0, subMethod: currentMethod })?.result}</b>`;
    }
    //#endregion add leyend max size

    return response;
  } catch (ex) {
    return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
}

export const checkFile = (fileType = '', fileSize = 0, fileAllowedTypes = [], fileMaxSize = 0, subMethod = '') => {
  let response = getResponse({ type: 0 });
  try {
    //#region check file type

    const localFileTypeFind = fileAllowedTypes.find((element) => element === fileType);
    if (isUndNull(localFileTypeFind)?.result || localFileTypeFind.length <= 0) {
      response = fileNameByExtensionGet(fileAllowedTypes, fileMaxSize);
      if (!response?.isSuccess || response?.isWarning) {
        if (response.isSuccess) {
          response.msgText += `<br/>${settings.messages.pleaseTryAgain.en}`;
        }
        return response;
      }
    }

    //#endregion check file type

    //#region check file size

    if (fileSize > fileMaxSize) {
      response = fileNameByExtensionGet(fileAllowedTypes, fileMaxSize);
      if (!response?.isSuccess || response?.isWarning) {
        if (response.isSuccess) {
          response.msgText += `<br/>${settings.messages.pleaseTryAgain.en}`;
        }
        return response;
      }
    }

    //#endregion check file size
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: checkFile<br/>`;
    if (!isUndNullEmp(subMethod)?.result) {
      response.msgText += `Sub method: ${subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
  }
  return response;
}

export const checkFileNew = ({
  fileType = '',
  fileSize = 0,
  fileAllowedTypes = [],
  fileMaxSize = 0,
  languageId = 'en',
  subMethod = ''
} = {}) => {
  let response = getResponse({ type: 0 });
  const currentMethod = 'checkFileNew';
  try {
    //#region check file type
    const fileTypeFind = fileAllowedTypes.find((element) => element === fileType);
    if (isUndNullNew({ data: fileTypeFind, subMethod: currentMethod })?.result || fileTypeFind.length <= 0) {
      response = getFileNameByExtension({
        fileTypes: fileAllowedTypes,
        fileMaxSize: fileMaxSize,
        languageId: languageId,
        subMethod: currentMethod
      });
      if (!response?.isSuccess || response?.isWarning) {
        if (response?.isSuccess) response.msgText += `<br/>${settings?.messages?.pleaseTryAgain?.[languageId]}`;
        return response;
      }
    }
    //#endregion check file type

    //#region check file size
    if (fileSize > fileMaxSize) {
      response = getFileNameByExtension({
        fileTypes: fileAllowedTypes,
        fileMaxSize: fileMaxSize,
        languageId: languageId,
        subMethod: currentMethod
      });
      if (!response?.isSuccess || response?.isWarning) {
        if (response?.isSuccess) response.msgText += `<br/>${settings?.messages?.pleaseTryAgain?.[languageId]}`;
        return response;
      }
    }
    //#endregion check file size

    return response;
  } catch (ex) {
    return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
}

//#region old code
// const getBase64 = file => {
//   return new Promise(resolve => {
//     let fileInfo;
//     let baseURL = "";
//     // Make new FileReader
//     let reader = new FileReader();

//     // Convert the file to base64 text
//     reader.readAsDataURL(file);

//     // on reader load somthing...
//     reader.onload = () => {
//       // Make a fileInfo Object
//       //console.info("Called", reader);
//       baseURL = reader.result;
//       //console.info(baseURL);
//       resolve(baseURL);
//     };
//     //console.info(fileInfo);
//     return fileInfo
//   });
// };
//#endregion old code

export const convertFileAsync = {
  toBase64URL: (file = {}, subMethod = '') => {
    return new Promise(resolve => {
      let response = getResponse({ type: 0 });
      try {
        let baseURL = "";

        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          baseURL = reader.result;
          response.result = baseURL;
          resolve(response);
        };

        //response.result = fileInfo;
      } catch (ex) {
        response.isSuccess = false;
        response.msgType = -1;
        response.msgText = `Method: convertFileAsync / toBase64URL<br/>`;
        if (!isUndNullEmp(subMethod)?.result) {
          response.msgText += `Sub method: ${subMethod}<br/>`
        }
        response.msgText += `Error: ${ex.message}`;
        resolve(response);
      }
      return response
    });
  },
}

export const convertFile = {
  toBase64URL: ({
    file = {},
    subMethod = ''
  } = {}) => {
    return new Promise(resolve => {
      const currentMethod = '';
      let response = getResponse({ type: 0 });
      try {
        let baseURL = "";

        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          baseURL = reader.result;
          response.result = baseURL;
          resolve(response);
        };
      } catch (ex) {
        response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        resolve(response);
      }
      return response
    });
  },
}

export const setBadgeStatusGeneric = (data = { type: 0, value: '', }) => {
  switch (data.type) {
    case -1:
      return `<span class='badge badge-danger'>${data.value}</span>`;
    case 0:
      return `<span class='badge badge-success'>${data.value}</span>`;
    case 1:
      return `<span class='badge badge-warning'>${data.value}</span>`;
    case 2:
      return `<span class='badge badge-primary'>${data.value}</span>`;
    case 3:
      return `<span class='badge badge-info'>${data.value}</span>`;
    case 4:
      return `<span class='badge badge-default'>${data.value}</span>`;
    default:
      return `<span class='badge badge-secondary'>${data.value}</span>`;
  }
}

export const setBadgeStatusGenericNew = ({
  type = 0,
  value = '',
  title = '',
  attribues = {
    id: '',
    method: '',
    description: ''
  },
  pointer = false
} = {}) => {
  const badgedClass = [
    'badge badge-danger',
    'badge badge-success',
    'badge badge-warning',
    'badge badge-primary',
    'badge badge-info',
    'badge badge-default',
    'badge badge-secondary',
  ];
  const cursor_ = pointer ? `style='cursor:pointer'` : ``;
  const id_ = attribues?.id ? `id='${attribues?.id}'` : ``;
  const method_ = attribues?.method ? `method='${attribues?.method}'` : ``;
  const description_ = attribues?.description ? `description='${attribues?.description}'` : ``;
  const index_ = type >= -1 && type <= 5 ? type + 1 : 0;
  return `<span class='${badgedClass[index_]} custom-toolip-01' data-title='${title}' ${id_} ${method_} ${description_} ${cursor_}>${value}</span>`;
}

export const getBadgesClassName = ({
  type = 0,
  subMethod = '',
}) => {
  const currentMethod = 'getBadgesClassName';
  let response = getResponse({ type: 0 });
  try {
    const badgedClass = [
      'badge badge-danger float-right',
      'badge badge-success float-right',
      'badge badge-warning float-right',
      'badge badge-primary float-right',
      'badge badge-info float-right',
      'badge badge-default float-right',
      'badge badge-secondary float-right',
    ];
    response.result = type <= badgedClass?.length ? badgedClass[type] : badgedClass[0];
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    response.result = 'error';
  }
  return response;

}

export const convertTextHtmlToTex = (data = { htmlText: '', subMethod: '' }) => {
  let response = getResponse({ type: 0 });
  try {
    let localRegex = /<[^>]+>/g;
    response.result = data.htmlText.replace(localRegex, '');
  } catch (ex) {
    response.msgType = -1;
    response.isSuccess = false;
    response.msgText = `Method: convertTextHtmlToTex<br/>`;
    if (!isUndNullEmp(data.subMethod)?.result) {
      response.msgText += `Sub method: ${data.subMethod}<br/>`
    }
    response.msgText += `Error: ${ex.message}`;
    response.result = data;
  }
  return response;
}

export const controlMethods = {
  inputs: {
    minusFirtsMaxLengthOnLyNumbers: (data = { e: {}, currenTarget: {}, maxLength: 0, subMethod: '' }) => {
      let response = getResponse({ type: 0 });
      try {
        //#region variables

        let charKey = data.e.key;
        let charKeyIsNaN = isNaN(charKey);
        let targetValue = data.e.target.value;
        const charKeyIncludes = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Enter', '-',]

        //#endregion variables

        //console.log({ charKey, charKeyIsNaN, targetValue, e: data.e, currenTarget: data.currenTarget });

        //#region Allow non-printable keys

        //#region old code

        // if (charKeyIsNaN && (charKey === 'Delete' || charKey === 'Backspace')) {
        //   //console.log(1);
        //   return response;
        // }

        //#endregion old code

        if (charKeyIsNaN && !charKeyIncludes.includes(charKey)) {
          //console.log(1);
          //return response;
          data.e?.preventDefault();
          return response;
        }


        //#endregion Allow non-printable keys

        //#region Allow numeric characters

        //#region old code

        //console.log(/\d/.test(charKey));
        // if (/\d/.test(charKey)) {
        //   console.log(2);
        //   return response;
        // }

        //#endregion old code

        if (!(/\d/.test(charKey)) && !charKeyIncludes.includes(charKey)) {
          //console.log(2);
          data.e?.preventDefault();
          return response;
        }

        //#endregion Allow numeric characters

        //#region Allow the minus sign (-) if the user enters it first

        //#region old code

        // if (charKey === '-' && targetValue === '') {
        //   console.log(3);
        //   return response;
        // }

        //#endregion old code

        if (charKey === '-' && targetValue !== '' && data.currenTarget.value.slice(0, data.currenTarget.selectionStart).length !== 0) {
          //console.log(3);
          data.e?.preventDefault();
          return response;
        }

        //#endregion Allow the minus sign (-) if the user enters it first

        //#region Max length

        if (targetValue.length > data.maxLength && !charKeyIncludes.includes(charKey)) {
          //console.log(4)
          data.e?.preventDefault();
        }

        //#endregion Max length

        // In all other cases, suppress the event
        //data.e?.preventDefault();

        //#region Documentation

        ////https://www.codeproject.com/Questions/996785/Enter-only-numbers-and-minus-sign-in-textbox
        // onKeyPress={(e) => {
        //     e = e || window.event;
        //     var charCode = (typeof e.which == 'number') ? e.which : e.keyCode;

        //     // Allow non-printable keys
        //     if (!charCode || charCode === 8 /* Backspace */) {
        //         return;
        //     }

        //     var typedChar = String.fromCharCode(charCode);

        //     // Allow numeric characters
        //     if (/\d/.test(typedChar)) {
        //         return;
        //     }

        //     // Allow the minus sign (-) if the user enters it first
        //     if (typedChar === '-' && this.value === '') {
        //         return;
        //     }

        //     // In all other cases, suppress the event
        //     return false;
        // }}    

        //#endregion Documentation
      } catch (ex) {
        response.isSuccess = false;
        response.msgType = -1;
        response.msgText = `Method: controlMethods.inputs.minusFirtsMaxLengthOnLyNumbers<br/>`;
        if (!isUndNullEmp(data.subMethod)?.result) {
          response.msgText += `Sub method: ${data.subMethod}<br/>`
        }
        response.msgText += `Error: ${ex.message}`;
        response.result = data;
        console?.error(response);
      }
      return response;
    },
  },
}

//#region old code
// export const getError = ({
//   ex = {},
//   response = new ResponseClass()?.getClass(),
//   currentMethod = '',
//   subMethod = '',
// }) => {
//   response.msgType = -1;
//   response.isSuccess = false;
//   response.msgText = `Method: ${currentMethod}<br/>`;
//   if (!isUndNullEmpNew({ data: subMethod, subMethod: 'getError' })?.result) {
//     response.msgText += `Sub method: ${subMethod}<br/>`;
//   }
//   response.msgText += `Error: ${ex.message}`;
//   return response;
// }
//#endregion old code

export const LoadingSection = ({
  alt = '',
  className = '',
  showText = true,
  text = '',
  height = 16,
  hidden = false,
  languageId = 'en',
  width = 16,
  subMethod = '',
} = {}) => {
  const currentMethod = 'LoadingSection';
  let response = getResponse({ type: 0 });
  try {
    const { labels, gifs } = settings;

    text = isUndNullEmpNew({ data: text, subMethod: currentMethod, })?.result ?
      labels?.loading?.[languageId] :
      text;
    return (
      <div className={className}
        hidden={hidden}>
        <img alt={alt}
          src={gifs?.normal?.circle}
          height={height}
          width={width} /> {showText ? ` ${text}...` : ''}
      </div>
    );
  } catch (ex) {
    response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    console?.error(response);
    return null;
  }
}

export const getError = ({
  ex = { message: '', },
  response = getResponse({ type: 0 }),
  currentMethod_ = '',
  subMethod_ = '',
}) => {
  const currentMethod = 'getError';
  //#region old code
  // response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod_ });
  //#endregion old code
  try {
    //#region old code
    // response.msgText = `Method: ${currentMethod_}<br/>`;
    // if (!isUndNullEmpNew({ data: subMethod_, subMethod: currentMethod })?.result) {
    //   response.msgText += `Sub method: ${subMethod_}<br/>`;
    // }
    // response.msgText += `Error: ${ex.message}`;
    //#endregion old code
    response = getResponse({ type: -1, msgText_: `Error: ${ex.message}`, currentMethod_: currentMethod_, subMethod_: subMethod_ });
  } catch (ex) {
    //#region old code
    // response.msgText = `Method: ${currentMethod}<br/>`;
    // if (!isUndNullEmpNew({ data: currentMethod_, subMethod: currentMethod })?.result) {
    //   response.msgText += `Sub method: ${currentMethod_}<br/>`;
    // } else {
    //   if (!isUndNullEmpNew({ data: subMethod_, subMethod: currentMethod })?.result) {
    //     response.msgText += `Sub sub method: ${subMethod_}<br/>`;
    //   }
    // }

    // response.msgText += `Error: ${ex.message}`;
    //#endregion old code
    response = getResponse({ type: -1, currentMethod_: currentMethod, subMethod_: subMethod_ });
    if (!isUndNullEmpNew({ data: subMethod_, subMethod: currentMethod })?.result) {
      response.msgText += `Sub sub method: ${subMethod_}<br/>`;
    }
    response.msgText += `Error: ${ex.message}`;
  }
  return response;
}

export const checkFileOnLine = async ({
  url = '',
  languageId = '',
  subMethod = '',
}) => {
  const currentMethod = 'checkFileOnLine';
  let response = getResponse({ type: 0 });
  try {
    //#region variables
    let responseWarning = getResponse({ type: 1, currentMethod_: currentMethod, subMethod_: subMethod });
    //#endregion variables

    if (!validURL({ url: url, subMethod: currentMethod })?.result) {
      responseWarning.msgText += `Error: url is not valid. <br/>`;
      responseWarning.msgText += `url: ${url}`;
      return responseWarning;
    }

    const result = await fetch(url, { method: 'GET' });
    if (!result?.ok || result?.status === 404) {
      responseWarning.msgText += `Error: ${result?.status} - ${result?.statusText} <br/>`;
      responseWarning.msgText += `url: ${url}`;
      return responseWarning;
    }

    return response;
  } catch (ex) {
    return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
  }
}